
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $6e69ca24f4636b79$exports = {};

$parcel$export($6e69ca24f4636b79$exports, "create", () => $6e69ca24f4636b79$export$185802fd694ee1f5);
$parcel$export($6e69ca24f4636b79$exports, "clone", () => $6e69ca24f4636b79$export$9cd59f9826255e47);
$parcel$export($6e69ca24f4636b79$exports, "copy", () => $6e69ca24f4636b79$export$784d13d8ee351f07);
$parcel$export($6e69ca24f4636b79$exports, "fromValues", () => $6e69ca24f4636b79$export$a82be99ed2a44a7d);
$parcel$export($6e69ca24f4636b79$exports, "set", () => $6e69ca24f4636b79$export$adaa4cf7ef1b65be);
$parcel$export($6e69ca24f4636b79$exports, "identity", () => $6e69ca24f4636b79$export$f0954fd7d5368655);
$parcel$export($6e69ca24f4636b79$exports, "transpose", () => $6e69ca24f4636b79$export$9cb09a71b7d66923);
$parcel$export($6e69ca24f4636b79$exports, "invert", () => $6e69ca24f4636b79$export$6897c284b6f9f4dc);
$parcel$export($6e69ca24f4636b79$exports, "adjoint", () => $6e69ca24f4636b79$export$33f3c024b4ae00a1);
$parcel$export($6e69ca24f4636b79$exports, "determinant", () => $6e69ca24f4636b79$export$a04698f914c55ed9);
$parcel$export($6e69ca24f4636b79$exports, "multiply", () => $6e69ca24f4636b79$export$2060d2db72cce88f);
$parcel$export($6e69ca24f4636b79$exports, "translate", () => $6e69ca24f4636b79$export$d73ee8ef04f5226a);
$parcel$export($6e69ca24f4636b79$exports, "scale", () => $6e69ca24f4636b79$export$dcdf75081b88279d);
$parcel$export($6e69ca24f4636b79$exports, "rotate", () => $6e69ca24f4636b79$export$bb628a54ab399bc9);
$parcel$export($6e69ca24f4636b79$exports, "rotateX", () => $6e69ca24f4636b79$export$a59c8716592e09af);
$parcel$export($6e69ca24f4636b79$exports, "rotateY", () => $6e69ca24f4636b79$export$cf71e4d4ca4d1cfd);
$parcel$export($6e69ca24f4636b79$exports, "rotateZ", () => $6e69ca24f4636b79$export$ea6eae3365de5b9c);
$parcel$export($6e69ca24f4636b79$exports, "fromTranslation", () => $6e69ca24f4636b79$export$bc9e79e74e9fddf6);
$parcel$export($6e69ca24f4636b79$exports, "fromScaling", () => $6e69ca24f4636b79$export$832ca188ffb1955d);
$parcel$export($6e69ca24f4636b79$exports, "fromRotation", () => $6e69ca24f4636b79$export$926fc125ff3c666c);
$parcel$export($6e69ca24f4636b79$exports, "fromXRotation", () => $6e69ca24f4636b79$export$dd47cc2f828c32ef);
$parcel$export($6e69ca24f4636b79$exports, "fromYRotation", () => $6e69ca24f4636b79$export$7dc997d67d2b7f33);
$parcel$export($6e69ca24f4636b79$exports, "fromZRotation", () => $6e69ca24f4636b79$export$ad5ddaedc8f405df);
$parcel$export($6e69ca24f4636b79$exports, "fromRotationTranslation", () => $6e69ca24f4636b79$export$9545ac307f2a256b);
$parcel$export($6e69ca24f4636b79$exports, "fromQuat2", () => $6e69ca24f4636b79$export$ff497f2be31cc6a);
$parcel$export($6e69ca24f4636b79$exports, "getTranslation", () => $6e69ca24f4636b79$export$202e99f82f7f0395);
$parcel$export($6e69ca24f4636b79$exports, "getScaling", () => $6e69ca24f4636b79$export$71dc54d92bd04b57);
$parcel$export($6e69ca24f4636b79$exports, "getRotation", () => $6e69ca24f4636b79$export$df3937d3b537df0a);
$parcel$export($6e69ca24f4636b79$exports, "decompose", () => $6e69ca24f4636b79$export$4e06b4a690896b27);
$parcel$export($6e69ca24f4636b79$exports, "fromRotationTranslationScale", () => $6e69ca24f4636b79$export$ddf9c55c9f2be172);
$parcel$export($6e69ca24f4636b79$exports, "fromRotationTranslationScaleOrigin", () => $6e69ca24f4636b79$export$1def1f860edc4b1f);
$parcel$export($6e69ca24f4636b79$exports, "fromQuat", () => $6e69ca24f4636b79$export$2ff2bbe382249af7);
$parcel$export($6e69ca24f4636b79$exports, "frustum", () => $6e69ca24f4636b79$export$89b5708c387cac6c);
$parcel$export($6e69ca24f4636b79$exports, "perspectiveNO", () => $6e69ca24f4636b79$export$4cf19729ec9a96b8);
$parcel$export($6e69ca24f4636b79$exports, "perspective", () => $6e69ca24f4636b79$export$541149539f3a4684);
$parcel$export($6e69ca24f4636b79$exports, "perspectiveZO", () => $6e69ca24f4636b79$export$294bba99a6af0c0c);
$parcel$export($6e69ca24f4636b79$exports, "perspectiveFromFieldOfView", () => $6e69ca24f4636b79$export$58ae211c788e338f);
$parcel$export($6e69ca24f4636b79$exports, "orthoNO", () => $6e69ca24f4636b79$export$c5f65ef3eb668f27);
$parcel$export($6e69ca24f4636b79$exports, "ortho", () => $6e69ca24f4636b79$export$4f2167e613cfc87b);
$parcel$export($6e69ca24f4636b79$exports, "orthoZO", () => $6e69ca24f4636b79$export$b1d31ea7b4d854e);
$parcel$export($6e69ca24f4636b79$exports, "lookAt", () => $6e69ca24f4636b79$export$d924e14fd6d9aa66);
$parcel$export($6e69ca24f4636b79$exports, "targetTo", () => $6e69ca24f4636b79$export$aa67782f4dc9e52c);
$parcel$export($6e69ca24f4636b79$exports, "str", () => $6e69ca24f4636b79$export$42d51816ce590c93);
$parcel$export($6e69ca24f4636b79$exports, "frob", () => $6e69ca24f4636b79$export$326827e8268e9cdb);
$parcel$export($6e69ca24f4636b79$exports, "add", () => $6e69ca24f4636b79$export$e16d8520af44a096);
$parcel$export($6e69ca24f4636b79$exports, "subtract", () => $6e69ca24f4636b79$export$4e2d2ead65e5f7e3);
$parcel$export($6e69ca24f4636b79$exports, "multiplyScalar", () => $6e69ca24f4636b79$export$c697bed75648cdb7);
$parcel$export($6e69ca24f4636b79$exports, "multiplyScalarAndAdd", () => $6e69ca24f4636b79$export$553579f63bdd7137);
$parcel$export($6e69ca24f4636b79$exports, "exactEquals", () => $6e69ca24f4636b79$export$f2599a5cf1109d8);
$parcel$export($6e69ca24f4636b79$exports, "equals", () => $6e69ca24f4636b79$export$e9bab7fafb253603);
$parcel$export($6e69ca24f4636b79$exports, "mul", () => $6e69ca24f4636b79$export$6e3a27864ab166fe);
$parcel$export($6e69ca24f4636b79$exports, "sub", () => $6e69ca24f4636b79$export$f93b5905241a7cca);
/**
 * Common utilities
 * @module glMatrix
 */ // Configuration Constants
var $b3d72613362f56f7$export$fd293b15f47e270 = 0.000001;
var $b3d72613362f56f7$export$b67359430d3b1b2 = typeof Float32Array !== "undefined" ? Float32Array : Array;
var $b3d72613362f56f7$export$5ada478c8a628231 = Math.random;
var $b3d72613362f56f7$export$217057687ee20298 = "zyx";
function $b3d72613362f56f7$export$2077e0241d6afd3c(a) {
    if (a >= 0) return Math.round(a);
    return a % 0.5 === 0 ? Math.floor(a) : Math.round(a);
}
function $b3d72613362f56f7$export$cb2c0eb57f5e532c(type) {
    $b3d72613362f56f7$export$b67359430d3b1b2 = type;
}
var $b3d72613362f56f7$var$degree = Math.PI / 180;
var $b3d72613362f56f7$var$radian = 180 / Math.PI;
function $b3d72613362f56f7$export$408b8ee5959eefd5(a) {
    return a * $b3d72613362f56f7$var$degree;
}
function $b3d72613362f56f7$export$c796d9d3e501591f(a) {
    return a * $b3d72613362f56f7$var$radian;
}
function $b3d72613362f56f7$export$e9bab7fafb253603(a, b) {
    var tolerance = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $b3d72613362f56f7$export$fd293b15f47e270;
    return Math.abs(a - b) <= tolerance * Math.max(1, Math.abs(a), Math.abs(b));
}


function $6e69ca24f4636b79$export$185802fd694ee1f5() {
    var out = new $b3d72613362f56f7$export$b67359430d3b1b2(16);
    if ($b3d72613362f56f7$export$b67359430d3b1b2 != Float32Array) {
        out[1] = 0;
        out[2] = 0;
        out[3] = 0;
        out[4] = 0;
        out[6] = 0;
        out[7] = 0;
        out[8] = 0;
        out[9] = 0;
        out[11] = 0;
        out[12] = 0;
        out[13] = 0;
        out[14] = 0;
    }
    out[0] = 1;
    out[5] = 1;
    out[10] = 1;
    out[15] = 1;
    return out;
}
function $6e69ca24f4636b79$export$9cd59f9826255e47(a) {
    var out = new $b3d72613362f56f7$export$b67359430d3b1b2(16);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    out[9] = a[9];
    out[10] = a[10];
    out[11] = a[11];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
function $6e69ca24f4636b79$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    out[9] = a[9];
    out[10] = a[10];
    out[11] = a[11];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
function $6e69ca24f4636b79$export$a82be99ed2a44a7d(m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
    var out = new $b3d72613362f56f7$export$b67359430d3b1b2(16);
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m03;
    out[4] = m10;
    out[5] = m11;
    out[6] = m12;
    out[7] = m13;
    out[8] = m20;
    out[9] = m21;
    out[10] = m22;
    out[11] = m23;
    out[12] = m30;
    out[13] = m31;
    out[14] = m32;
    out[15] = m33;
    return out;
}
function $6e69ca24f4636b79$export$adaa4cf7ef1b65be(out, m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m03;
    out[4] = m10;
    out[5] = m11;
    out[6] = m12;
    out[7] = m13;
    out[8] = m20;
    out[9] = m21;
    out[10] = m22;
    out[11] = m23;
    out[12] = m30;
    out[13] = m31;
    out[14] = m32;
    out[15] = m33;
    return out;
}
function $6e69ca24f4636b79$export$f0954fd7d5368655(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $6e69ca24f4636b79$export$9cb09a71b7d66923(out, a) {
    // If we are transposing ourselves we can skip a few steps but have to cache some values
    if (out === a) {
        var a01 = a[1], a02 = a[2], a03 = a[3];
        var a12 = a[6], a13 = a[7];
        var a23 = a[11];
        out[1] = a[4];
        out[2] = a[8];
        out[3] = a[12];
        out[4] = a01;
        out[6] = a[9];
        out[7] = a[13];
        out[8] = a02;
        out[9] = a12;
        out[11] = a[14];
        out[12] = a03;
        out[13] = a13;
        out[14] = a23;
    } else {
        out[0] = a[0];
        out[1] = a[4];
        out[2] = a[8];
        out[3] = a[12];
        out[4] = a[1];
        out[5] = a[5];
        out[6] = a[9];
        out[7] = a[13];
        out[8] = a[2];
        out[9] = a[6];
        out[10] = a[10];
        out[11] = a[14];
        out[12] = a[3];
        out[13] = a[7];
        out[14] = a[11];
        out[15] = a[15];
    }
    return out;
}
function $6e69ca24f4636b79$export$6897c284b6f9f4dc(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    var b00 = a00 * a11 - a01 * a10;
    var b01 = a00 * a12 - a02 * a10;
    var b02 = a00 * a13 - a03 * a10;
    var b03 = a01 * a12 - a02 * a11;
    var b04 = a01 * a13 - a03 * a11;
    var b05 = a02 * a13 - a03 * a12;
    var b06 = a20 * a31 - a21 * a30;
    var b07 = a20 * a32 - a22 * a30;
    var b08 = a20 * a33 - a23 * a30;
    var b09 = a21 * a32 - a22 * a31;
    var b10 = a21 * a33 - a23 * a31;
    var b11 = a22 * a33 - a23 * a32;
    // Calculate the determinant
    var det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
    out[1] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
    out[2] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
    out[3] = (a22 * b04 - a21 * b05 - a23 * b03) * det;
    out[4] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
    out[5] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
    out[6] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
    out[7] = (a20 * b05 - a22 * b02 + a23 * b01) * det;
    out[8] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
    out[9] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
    out[10] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
    out[11] = (a21 * b02 - a20 * b04 - a23 * b00) * det;
    out[12] = (a11 * b07 - a10 * b09 - a12 * b06) * det;
    out[13] = (a00 * b09 - a01 * b07 + a02 * b06) * det;
    out[14] = (a31 * b01 - a30 * b03 - a32 * b00) * det;
    out[15] = (a20 * b03 - a21 * b01 + a22 * b00) * det;
    return out;
}
function $6e69ca24f4636b79$export$33f3c024b4ae00a1(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    var b00 = a00 * a11 - a01 * a10;
    var b01 = a00 * a12 - a02 * a10;
    var b02 = a00 * a13 - a03 * a10;
    var b03 = a01 * a12 - a02 * a11;
    var b04 = a01 * a13 - a03 * a11;
    var b05 = a02 * a13 - a03 * a12;
    var b06 = a20 * a31 - a21 * a30;
    var b07 = a20 * a32 - a22 * a30;
    var b08 = a20 * a33 - a23 * a30;
    var b09 = a21 * a32 - a22 * a31;
    var b10 = a21 * a33 - a23 * a31;
    var b11 = a22 * a33 - a23 * a32;
    out[0] = a11 * b11 - a12 * b10 + a13 * b09;
    out[1] = a02 * b10 - a01 * b11 - a03 * b09;
    out[2] = a31 * b05 - a32 * b04 + a33 * b03;
    out[3] = a22 * b04 - a21 * b05 - a23 * b03;
    out[4] = a12 * b08 - a10 * b11 - a13 * b07;
    out[5] = a00 * b11 - a02 * b08 + a03 * b07;
    out[6] = a32 * b02 - a30 * b05 - a33 * b01;
    out[7] = a20 * b05 - a22 * b02 + a23 * b01;
    out[8] = a10 * b10 - a11 * b08 + a13 * b06;
    out[9] = a01 * b08 - a00 * b10 - a03 * b06;
    out[10] = a30 * b04 - a31 * b02 + a33 * b00;
    out[11] = a21 * b02 - a20 * b04 - a23 * b00;
    out[12] = a11 * b07 - a10 * b09 - a12 * b06;
    out[13] = a00 * b09 - a01 * b07 + a02 * b06;
    out[14] = a31 * b01 - a30 * b03 - a32 * b00;
    out[15] = a20 * b03 - a21 * b01 + a22 * b00;
    return out;
}
function $6e69ca24f4636b79$export$a04698f914c55ed9(a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    var b0 = a00 * a11 - a01 * a10;
    var b1 = a00 * a12 - a02 * a10;
    var b2 = a01 * a12 - a02 * a11;
    var b3 = a20 * a31 - a21 * a30;
    var b4 = a20 * a32 - a22 * a30;
    var b5 = a21 * a32 - a22 * a31;
    var b6 = a00 * b5 - a01 * b4 + a02 * b3;
    var b7 = a10 * b5 - a11 * b4 + a12 * b3;
    var b8 = a20 * b2 - a21 * b1 + a22 * b0;
    var b9 = a30 * b2 - a31 * b1 + a32 * b0;
    // Calculate the determinant
    return a13 * b6 - a03 * b7 + a33 * b8 - a23 * b9;
}
function $6e69ca24f4636b79$export$2060d2db72cce88f(out, a, b) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    // Cache only the current line of the second matrix
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    out[0] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[1] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[2] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[3] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[4];
    b1 = b[5];
    b2 = b[6];
    b3 = b[7];
    out[4] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[5] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[6] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[7] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[8];
    b1 = b[9];
    b2 = b[10];
    b3 = b[11];
    out[8] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[9] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[10] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[11] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[12];
    b1 = b[13];
    b2 = b[14];
    b3 = b[15];
    out[12] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[13] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[14] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[15] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    return out;
}
function $6e69ca24f4636b79$export$d73ee8ef04f5226a(out, a, v) {
    var x = v[0], y = v[1], z = v[2];
    var a00, a01, a02, a03;
    var a10, a11, a12, a13;
    var a20, a21, a22, a23;
    if (a === out) {
        out[12] = a[0] * x + a[4] * y + a[8] * z + a[12];
        out[13] = a[1] * x + a[5] * y + a[9] * z + a[13];
        out[14] = a[2] * x + a[6] * y + a[10] * z + a[14];
        out[15] = a[3] * x + a[7] * y + a[11] * z + a[15];
    } else {
        a00 = a[0];
        a01 = a[1];
        a02 = a[2];
        a03 = a[3];
        a10 = a[4];
        a11 = a[5];
        a12 = a[6];
        a13 = a[7];
        a20 = a[8];
        a21 = a[9];
        a22 = a[10];
        a23 = a[11];
        out[0] = a00;
        out[1] = a01;
        out[2] = a02;
        out[3] = a03;
        out[4] = a10;
        out[5] = a11;
        out[6] = a12;
        out[7] = a13;
        out[8] = a20;
        out[9] = a21;
        out[10] = a22;
        out[11] = a23;
        out[12] = a00 * x + a10 * y + a20 * z + a[12];
        out[13] = a01 * x + a11 * y + a21 * z + a[13];
        out[14] = a02 * x + a12 * y + a22 * z + a[14];
        out[15] = a03 * x + a13 * y + a23 * z + a[15];
    }
    return out;
}
function $6e69ca24f4636b79$export$dcdf75081b88279d(out, a, v) {
    var x = v[0], y = v[1], z = v[2];
    out[0] = a[0] * x;
    out[1] = a[1] * x;
    out[2] = a[2] * x;
    out[3] = a[3] * x;
    out[4] = a[4] * y;
    out[5] = a[5] * y;
    out[6] = a[6] * y;
    out[7] = a[7] * y;
    out[8] = a[8] * z;
    out[9] = a[9] * z;
    out[10] = a[10] * z;
    out[11] = a[11] * z;
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
function $6e69ca24f4636b79$export$bb628a54ab399bc9(out, a, rad, axis) {
    var x = axis[0], y = axis[1], z = axis[2];
    var len = Math.sqrt(x * x + y * y + z * z);
    var s, c, t;
    var a00, a01, a02, a03;
    var a10, a11, a12, a13;
    var a20, a21, a22, a23;
    var b00, b01, b02;
    var b10, b11, b12;
    var b20, b21, b22;
    if (len < $b3d72613362f56f7$export$fd293b15f47e270) return null;
    len = 1 / len;
    x *= len;
    y *= len;
    z *= len;
    s = Math.sin(rad);
    c = Math.cos(rad);
    t = 1 - c;
    a00 = a[0];
    a01 = a[1];
    a02 = a[2];
    a03 = a[3];
    a10 = a[4];
    a11 = a[5];
    a12 = a[6];
    a13 = a[7];
    a20 = a[8];
    a21 = a[9];
    a22 = a[10];
    a23 = a[11];
    // Construct the elements of the rotation matrix
    b00 = x * x * t + c;
    b01 = y * x * t + z * s;
    b02 = z * x * t - y * s;
    b10 = x * y * t - z * s;
    b11 = y * y * t + c;
    b12 = z * y * t + x * s;
    b20 = x * z * t + y * s;
    b21 = y * z * t - x * s;
    b22 = z * z * t + c;
    // Perform rotation-specific matrix multiplication
    out[0] = a00 * b00 + a10 * b01 + a20 * b02;
    out[1] = a01 * b00 + a11 * b01 + a21 * b02;
    out[2] = a02 * b00 + a12 * b01 + a22 * b02;
    out[3] = a03 * b00 + a13 * b01 + a23 * b02;
    out[4] = a00 * b10 + a10 * b11 + a20 * b12;
    out[5] = a01 * b10 + a11 * b11 + a21 * b12;
    out[6] = a02 * b10 + a12 * b11 + a22 * b12;
    out[7] = a03 * b10 + a13 * b11 + a23 * b12;
    out[8] = a00 * b20 + a10 * b21 + a20 * b22;
    out[9] = a01 * b20 + a11 * b21 + a21 * b22;
    out[10] = a02 * b20 + a12 * b21 + a22 * b22;
    out[11] = a03 * b20 + a13 * b21 + a23 * b22;
    if (a !== out) {
        // If the source and destination differ, copy the unchanged last row
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }
    return out;
}
function $6e69ca24f4636b79$export$a59c8716592e09af(out, a, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    var a10 = a[4];
    var a11 = a[5];
    var a12 = a[6];
    var a13 = a[7];
    var a20 = a[8];
    var a21 = a[9];
    var a22 = a[10];
    var a23 = a[11];
    if (a !== out) {
        // If the source and destination differ, copy the unchanged rows
        out[0] = a[0];
        out[1] = a[1];
        out[2] = a[2];
        out[3] = a[3];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }
    // Perform axis-specific matrix multiplication
    out[4] = a10 * c + a20 * s;
    out[5] = a11 * c + a21 * s;
    out[6] = a12 * c + a22 * s;
    out[7] = a13 * c + a23 * s;
    out[8] = a20 * c - a10 * s;
    out[9] = a21 * c - a11 * s;
    out[10] = a22 * c - a12 * s;
    out[11] = a23 * c - a13 * s;
    return out;
}
function $6e69ca24f4636b79$export$cf71e4d4ca4d1cfd(out, a, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    var a00 = a[0];
    var a01 = a[1];
    var a02 = a[2];
    var a03 = a[3];
    var a20 = a[8];
    var a21 = a[9];
    var a22 = a[10];
    var a23 = a[11];
    if (a !== out) {
        // If the source and destination differ, copy the unchanged rows
        out[4] = a[4];
        out[5] = a[5];
        out[6] = a[6];
        out[7] = a[7];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }
    // Perform axis-specific matrix multiplication
    out[0] = a00 * c - a20 * s;
    out[1] = a01 * c - a21 * s;
    out[2] = a02 * c - a22 * s;
    out[3] = a03 * c - a23 * s;
    out[8] = a00 * s + a20 * c;
    out[9] = a01 * s + a21 * c;
    out[10] = a02 * s + a22 * c;
    out[11] = a03 * s + a23 * c;
    return out;
}
function $6e69ca24f4636b79$export$ea6eae3365de5b9c(out, a, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    var a00 = a[0];
    var a01 = a[1];
    var a02 = a[2];
    var a03 = a[3];
    var a10 = a[4];
    var a11 = a[5];
    var a12 = a[6];
    var a13 = a[7];
    if (a !== out) {
        // If the source and destination differ, copy the unchanged last row
        out[8] = a[8];
        out[9] = a[9];
        out[10] = a[10];
        out[11] = a[11];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }
    // Perform axis-specific matrix multiplication
    out[0] = a00 * c + a10 * s;
    out[1] = a01 * c + a11 * s;
    out[2] = a02 * c + a12 * s;
    out[3] = a03 * c + a13 * s;
    out[4] = a10 * c - a00 * s;
    out[5] = a11 * c - a01 * s;
    out[6] = a12 * c - a02 * s;
    out[7] = a13 * c - a03 * s;
    return out;
}
function $6e69ca24f4636b79$export$bc9e79e74e9fddf6(out, v) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
}
function $6e69ca24f4636b79$export$832ca188ffb1955d(out, v) {
    out[0] = v[0];
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = v[1];
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = v[2];
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $6e69ca24f4636b79$export$926fc125ff3c666c(out, rad, axis) {
    var x = axis[0], y = axis[1], z = axis[2];
    var len = Math.sqrt(x * x + y * y + z * z);
    var s, c, t;
    if (len < $b3d72613362f56f7$export$fd293b15f47e270) return null;
    len = 1 / len;
    x *= len;
    y *= len;
    z *= len;
    s = Math.sin(rad);
    c = Math.cos(rad);
    t = 1 - c;
    // Perform rotation-specific matrix multiplication
    out[0] = x * x * t + c;
    out[1] = y * x * t + z * s;
    out[2] = z * x * t - y * s;
    out[3] = 0;
    out[4] = x * y * t - z * s;
    out[5] = y * y * t + c;
    out[6] = z * y * t + x * s;
    out[7] = 0;
    out[8] = x * z * t + y * s;
    out[9] = y * z * t - x * s;
    out[10] = z * z * t + c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $6e69ca24f4636b79$export$dd47cc2f828c32ef(out, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    // Perform axis-specific matrix multiplication
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = c;
    out[6] = s;
    out[7] = 0;
    out[8] = 0;
    out[9] = -s;
    out[10] = c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $6e69ca24f4636b79$export$7dc997d67d2b7f33(out, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    // Perform axis-specific matrix multiplication
    out[0] = c;
    out[1] = 0;
    out[2] = -s;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = s;
    out[9] = 0;
    out[10] = c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $6e69ca24f4636b79$export$ad5ddaedc8f405df(out, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    // Perform axis-specific matrix multiplication
    out[0] = c;
    out[1] = s;
    out[2] = 0;
    out[3] = 0;
    out[4] = -s;
    out[5] = c;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $6e69ca24f4636b79$export$9545ac307f2a256b(out, q, v) {
    // Quaternion math
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var xy = x * y2;
    var xz = x * z2;
    var yy = y * y2;
    var yz = y * z2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    out[0] = 1 - (yy + zz);
    out[1] = xy + wz;
    out[2] = xz - wy;
    out[3] = 0;
    out[4] = xy - wz;
    out[5] = 1 - (xx + zz);
    out[6] = yz + wx;
    out[7] = 0;
    out[8] = xz + wy;
    out[9] = yz - wx;
    out[10] = 1 - (xx + yy);
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
}
function $6e69ca24f4636b79$export$ff497f2be31cc6a(out, a) {
    var translation = new $b3d72613362f56f7$export$b67359430d3b1b2(3);
    var bx = -a[0], by = -a[1], bz = -a[2], bw = a[3], ax = a[4], ay = a[5], az = a[6], aw = a[7];
    var magnitude = bx * bx + by * by + bz * bz + bw * bw;
    //Only scale if it makes sense
    if (magnitude > 0) {
        translation[0] = (ax * bw + aw * bx + ay * bz - az * by) * 2 / magnitude;
        translation[1] = (ay * bw + aw * by + az * bx - ax * bz) * 2 / magnitude;
        translation[2] = (az * bw + aw * bz + ax * by - ay * bx) * 2 / magnitude;
    } else {
        translation[0] = (ax * bw + aw * bx + ay * bz - az * by) * 2;
        translation[1] = (ay * bw + aw * by + az * bx - ax * bz) * 2;
        translation[2] = (az * bw + aw * bz + ax * by - ay * bx) * 2;
    }
    $6e69ca24f4636b79$export$9545ac307f2a256b(out, a, translation);
    return out;
}
function $6e69ca24f4636b79$export$202e99f82f7f0395(out, mat) {
    out[0] = mat[12];
    out[1] = mat[13];
    out[2] = mat[14];
    return out;
}
function $6e69ca24f4636b79$export$71dc54d92bd04b57(out, mat) {
    var m11 = mat[0];
    var m12 = mat[1];
    var m13 = mat[2];
    var m21 = mat[4];
    var m22 = mat[5];
    var m23 = mat[6];
    var m31 = mat[8];
    var m32 = mat[9];
    var m33 = mat[10];
    out[0] = Math.sqrt(m11 * m11 + m12 * m12 + m13 * m13);
    out[1] = Math.sqrt(m21 * m21 + m22 * m22 + m23 * m23);
    out[2] = Math.sqrt(m31 * m31 + m32 * m32 + m33 * m33);
    return out;
}
function $6e69ca24f4636b79$export$df3937d3b537df0a(out, mat) {
    var scaling = new $b3d72613362f56f7$export$b67359430d3b1b2(3);
    $6e69ca24f4636b79$export$71dc54d92bd04b57(scaling, mat);
    var is1 = 1 / scaling[0];
    var is2 = 1 / scaling[1];
    var is3 = 1 / scaling[2];
    var sm11 = mat[0] * is1;
    var sm12 = mat[1] * is2;
    var sm13 = mat[2] * is3;
    var sm21 = mat[4] * is1;
    var sm22 = mat[5] * is2;
    var sm23 = mat[6] * is3;
    var sm31 = mat[8] * is1;
    var sm32 = mat[9] * is2;
    var sm33 = mat[10] * is3;
    var trace = sm11 + sm22 + sm33;
    var S = 0;
    if (trace > 0) {
        S = Math.sqrt(trace + 1.0) * 2;
        out[3] = 0.25 * S;
        out[0] = (sm23 - sm32) / S;
        out[1] = (sm31 - sm13) / S;
        out[2] = (sm12 - sm21) / S;
    } else if (sm11 > sm22 && sm11 > sm33) {
        S = Math.sqrt(1.0 + sm11 - sm22 - sm33) * 2;
        out[3] = (sm23 - sm32) / S;
        out[0] = 0.25 * S;
        out[1] = (sm12 + sm21) / S;
        out[2] = (sm31 + sm13) / S;
    } else if (sm22 > sm33) {
        S = Math.sqrt(1.0 + sm22 - sm11 - sm33) * 2;
        out[3] = (sm31 - sm13) / S;
        out[0] = (sm12 + sm21) / S;
        out[1] = 0.25 * S;
        out[2] = (sm23 + sm32) / S;
    } else {
        S = Math.sqrt(1.0 + sm33 - sm11 - sm22) * 2;
        out[3] = (sm12 - sm21) / S;
        out[0] = (sm31 + sm13) / S;
        out[1] = (sm23 + sm32) / S;
        out[2] = 0.25 * S;
    }
    return out;
}
function $6e69ca24f4636b79$export$4e06b4a690896b27(out_r, out_t, out_s, mat) {
    out_t[0] = mat[12];
    out_t[1] = mat[13];
    out_t[2] = mat[14];
    var m11 = mat[0];
    var m12 = mat[1];
    var m13 = mat[2];
    var m21 = mat[4];
    var m22 = mat[5];
    var m23 = mat[6];
    var m31 = mat[8];
    var m32 = mat[9];
    var m33 = mat[10];
    out_s[0] = Math.sqrt(m11 * m11 + m12 * m12 + m13 * m13);
    out_s[1] = Math.sqrt(m21 * m21 + m22 * m22 + m23 * m23);
    out_s[2] = Math.sqrt(m31 * m31 + m32 * m32 + m33 * m33);
    var is1 = 1 / out_s[0];
    var is2 = 1 / out_s[1];
    var is3 = 1 / out_s[2];
    var sm11 = m11 * is1;
    var sm12 = m12 * is2;
    var sm13 = m13 * is3;
    var sm21 = m21 * is1;
    var sm22 = m22 * is2;
    var sm23 = m23 * is3;
    var sm31 = m31 * is1;
    var sm32 = m32 * is2;
    var sm33 = m33 * is3;
    var trace = sm11 + sm22 + sm33;
    var S = 0;
    if (trace > 0) {
        S = Math.sqrt(trace + 1.0) * 2;
        out_r[3] = 0.25 * S;
        out_r[0] = (sm23 - sm32) / S;
        out_r[1] = (sm31 - sm13) / S;
        out_r[2] = (sm12 - sm21) / S;
    } else if (sm11 > sm22 && sm11 > sm33) {
        S = Math.sqrt(1.0 + sm11 - sm22 - sm33) * 2;
        out_r[3] = (sm23 - sm32) / S;
        out_r[0] = 0.25 * S;
        out_r[1] = (sm12 + sm21) / S;
        out_r[2] = (sm31 + sm13) / S;
    } else if (sm22 > sm33) {
        S = Math.sqrt(1.0 + sm22 - sm11 - sm33) * 2;
        out_r[3] = (sm31 - sm13) / S;
        out_r[0] = (sm12 + sm21) / S;
        out_r[1] = 0.25 * S;
        out_r[2] = (sm23 + sm32) / S;
    } else {
        S = Math.sqrt(1.0 + sm33 - sm11 - sm22) * 2;
        out_r[3] = (sm12 - sm21) / S;
        out_r[0] = (sm31 + sm13) / S;
        out_r[1] = (sm23 + sm32) / S;
        out_r[2] = 0.25 * S;
    }
    return out_r;
}
function $6e69ca24f4636b79$export$ddf9c55c9f2be172(out, q, v, s) {
    // Quaternion math
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var xy = x * y2;
    var xz = x * z2;
    var yy = y * y2;
    var yz = y * z2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    var sx = s[0];
    var sy = s[1];
    var sz = s[2];
    out[0] = (1 - (yy + zz)) * sx;
    out[1] = (xy + wz) * sx;
    out[2] = (xz - wy) * sx;
    out[3] = 0;
    out[4] = (xy - wz) * sy;
    out[5] = (1 - (xx + zz)) * sy;
    out[6] = (yz + wx) * sy;
    out[7] = 0;
    out[8] = (xz + wy) * sz;
    out[9] = (yz - wx) * sz;
    out[10] = (1 - (xx + yy)) * sz;
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
}
function $6e69ca24f4636b79$export$1def1f860edc4b1f(out, q, v, s, o) {
    // Quaternion math
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var xy = x * y2;
    var xz = x * z2;
    var yy = y * y2;
    var yz = y * z2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    var sx = s[0];
    var sy = s[1];
    var sz = s[2];
    var ox = o[0];
    var oy = o[1];
    var oz = o[2];
    var out0 = (1 - (yy + zz)) * sx;
    var out1 = (xy + wz) * sx;
    var out2 = (xz - wy) * sx;
    var out4 = (xy - wz) * sy;
    var out5 = (1 - (xx + zz)) * sy;
    var out6 = (yz + wx) * sy;
    var out8 = (xz + wy) * sz;
    var out9 = (yz - wx) * sz;
    var out10 = (1 - (xx + yy)) * sz;
    out[0] = out0;
    out[1] = out1;
    out[2] = out2;
    out[3] = 0;
    out[4] = out4;
    out[5] = out5;
    out[6] = out6;
    out[7] = 0;
    out[8] = out8;
    out[9] = out9;
    out[10] = out10;
    out[11] = 0;
    out[12] = v[0] + ox - (out0 * ox + out4 * oy + out8 * oz);
    out[13] = v[1] + oy - (out1 * ox + out5 * oy + out9 * oz);
    out[14] = v[2] + oz - (out2 * ox + out6 * oy + out10 * oz);
    out[15] = 1;
    return out;
}
function $6e69ca24f4636b79$export$2ff2bbe382249af7(out, q) {
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var yx = y * x2;
    var yy = y * y2;
    var zx = z * x2;
    var zy = z * y2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    out[0] = 1 - yy - zz;
    out[1] = yx + wz;
    out[2] = zx - wy;
    out[3] = 0;
    out[4] = yx - wz;
    out[5] = 1 - xx - zz;
    out[6] = zy + wx;
    out[7] = 0;
    out[8] = zx + wy;
    out[9] = zy - wx;
    out[10] = 1 - xx - yy;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $6e69ca24f4636b79$export$89b5708c387cac6c(out, left, right, bottom, top, near, far) {
    var rl = 1 / (right - left);
    var tb = 1 / (top - bottom);
    var nf = 1 / (near - far);
    out[0] = near * 2 * rl;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = near * 2 * tb;
    out[6] = 0;
    out[7] = 0;
    out[8] = (right + left) * rl;
    out[9] = (top + bottom) * tb;
    out[10] = (far + near) * nf;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[14] = far * near * 2 * nf;
    out[15] = 0;
    return out;
}
function $6e69ca24f4636b79$export$4cf19729ec9a96b8(out, fovy, aspect, near, far) {
    var f = 1.0 / Math.tan(fovy / 2);
    out[0] = f / aspect;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = f;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[15] = 0;
    if (far != null && far !== Infinity) {
        var nf = 1 / (near - far);
        out[10] = (far + near) * nf;
        out[14] = 2 * far * near * nf;
    } else {
        out[10] = -1;
        out[14] = -2 * near;
    }
    return out;
}
var $6e69ca24f4636b79$export$541149539f3a4684 = $6e69ca24f4636b79$export$4cf19729ec9a96b8;
function $6e69ca24f4636b79$export$294bba99a6af0c0c(out, fovy, aspect, near, far) {
    var f = 1.0 / Math.tan(fovy / 2);
    out[0] = f / aspect;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = f;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[15] = 0;
    if (far != null && far !== Infinity) {
        var nf = 1 / (near - far);
        out[10] = far * nf;
        out[14] = far * near * nf;
    } else {
        out[10] = -1;
        out[14] = -near;
    }
    return out;
}
function $6e69ca24f4636b79$export$58ae211c788e338f(out, fov, near, far) {
    var upTan = Math.tan(fov.upDegrees * Math.PI / 180.0);
    var downTan = Math.tan(fov.downDegrees * Math.PI / 180.0);
    var leftTan = Math.tan(fov.leftDegrees * Math.PI / 180.0);
    var rightTan = Math.tan(fov.rightDegrees * Math.PI / 180.0);
    var xScale = 2.0 / (leftTan + rightTan);
    var yScale = 2.0 / (upTan + downTan);
    out[0] = xScale;
    out[1] = 0.0;
    out[2] = 0.0;
    out[3] = 0.0;
    out[4] = 0.0;
    out[5] = yScale;
    out[6] = 0.0;
    out[7] = 0.0;
    out[8] = -((leftTan - rightTan) * xScale * 0.5);
    out[9] = (upTan - downTan) * yScale * 0.5;
    out[10] = far / (near - far);
    out[11] = -1;
    out[12] = 0.0;
    out[13] = 0.0;
    out[14] = far * near / (near - far);
    out[15] = 0.0;
    return out;
}
function $6e69ca24f4636b79$export$c5f65ef3eb668f27(out, left, right, bottom, top, near, far) {
    var lr = 1 / (left - right);
    var bt = 1 / (bottom - top);
    var nf = 1 / (near - far);
    out[0] = -2 * lr;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = -2 * bt;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 2 * nf;
    out[11] = 0;
    out[12] = (left + right) * lr;
    out[13] = (top + bottom) * bt;
    out[14] = (far + near) * nf;
    out[15] = 1;
    return out;
}
var $6e69ca24f4636b79$export$4f2167e613cfc87b = $6e69ca24f4636b79$export$c5f65ef3eb668f27;
function $6e69ca24f4636b79$export$b1d31ea7b4d854e(out, left, right, bottom, top, near, far) {
    var lr = 1 / (left - right);
    var bt = 1 / (bottom - top);
    var nf = 1 / (near - far);
    out[0] = -2 * lr;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = -2 * bt;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = nf;
    out[11] = 0;
    out[12] = (left + right) * lr;
    out[13] = (top + bottom) * bt;
    out[14] = near * nf;
    out[15] = 1;
    return out;
}
function $6e69ca24f4636b79$export$d924e14fd6d9aa66(out, eye, center, up) {
    var x0, x1, x2, y0, y1, y2, z0, z1, z2, len;
    var eyex = eye[0];
    var eyey = eye[1];
    var eyez = eye[2];
    var upx = up[0];
    var upy = up[1];
    var upz = up[2];
    var centerx = center[0];
    var centery = center[1];
    var centerz = center[2];
    if (Math.abs(eyex - centerx) < $b3d72613362f56f7$export$fd293b15f47e270 && Math.abs(eyey - centery) < $b3d72613362f56f7$export$fd293b15f47e270 && Math.abs(eyez - centerz) < $b3d72613362f56f7$export$fd293b15f47e270) return $6e69ca24f4636b79$export$f0954fd7d5368655(out);
    z0 = eyex - centerx;
    z1 = eyey - centery;
    z2 = eyez - centerz;
    len = 1 / Math.sqrt(z0 * z0 + z1 * z1 + z2 * z2);
    z0 *= len;
    z1 *= len;
    z2 *= len;
    x0 = upy * z2 - upz * z1;
    x1 = upz * z0 - upx * z2;
    x2 = upx * z1 - upy * z0;
    len = Math.sqrt(x0 * x0 + x1 * x1 + x2 * x2);
    if (!len) {
        x0 = 0;
        x1 = 0;
        x2 = 0;
    } else {
        len = 1 / len;
        x0 *= len;
        x1 *= len;
        x2 *= len;
    }
    y0 = z1 * x2 - z2 * x1;
    y1 = z2 * x0 - z0 * x2;
    y2 = z0 * x1 - z1 * x0;
    len = Math.sqrt(y0 * y0 + y1 * y1 + y2 * y2);
    if (!len) {
        y0 = 0;
        y1 = 0;
        y2 = 0;
    } else {
        len = 1 / len;
        y0 *= len;
        y1 *= len;
        y2 *= len;
    }
    out[0] = x0;
    out[1] = y0;
    out[2] = z0;
    out[3] = 0;
    out[4] = x1;
    out[5] = y1;
    out[6] = z1;
    out[7] = 0;
    out[8] = x2;
    out[9] = y2;
    out[10] = z2;
    out[11] = 0;
    out[12] = -(x0 * eyex + x1 * eyey + x2 * eyez);
    out[13] = -(y0 * eyex + y1 * eyey + y2 * eyez);
    out[14] = -(z0 * eyex + z1 * eyey + z2 * eyez);
    out[15] = 1;
    return out;
}
function $6e69ca24f4636b79$export$aa67782f4dc9e52c(out, eye, target, up) {
    var eyex = eye[0], eyey = eye[1], eyez = eye[2], upx = up[0], upy = up[1], upz = up[2];
    var z0 = eyex - target[0], z1 = eyey - target[1], z2 = eyez - target[2];
    var len = z0 * z0 + z1 * z1 + z2 * z2;
    if (len > 0) {
        len = 1 / Math.sqrt(len);
        z0 *= len;
        z1 *= len;
        z2 *= len;
    }
    var x0 = upy * z2 - upz * z1, x1 = upz * z0 - upx * z2, x2 = upx * z1 - upy * z0;
    len = x0 * x0 + x1 * x1 + x2 * x2;
    if (len > 0) {
        len = 1 / Math.sqrt(len);
        x0 *= len;
        x1 *= len;
        x2 *= len;
    }
    out[0] = x0;
    out[1] = x1;
    out[2] = x2;
    out[3] = 0;
    out[4] = z1 * x2 - z2 * x1;
    out[5] = z2 * x0 - z0 * x2;
    out[6] = z0 * x1 - z1 * x0;
    out[7] = 0;
    out[8] = z0;
    out[9] = z1;
    out[10] = z2;
    out[11] = 0;
    out[12] = eyex;
    out[13] = eyey;
    out[14] = eyez;
    out[15] = 1;
    return out;
}
function $6e69ca24f4636b79$export$42d51816ce590c93(a) {
    return "mat4(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ", " + a[4] + ", " + a[5] + ", " + a[6] + ", " + a[7] + ", " + a[8] + ", " + a[9] + ", " + a[10] + ", " + a[11] + ", " + a[12] + ", " + a[13] + ", " + a[14] + ", " + a[15] + ")";
}
function $6e69ca24f4636b79$export$326827e8268e9cdb(a) {
    return Math.sqrt(a[0] * a[0] + a[1] * a[1] + a[2] * a[2] + a[3] * a[3] + a[4] * a[4] + a[5] * a[5] + a[6] * a[6] + a[7] * a[7] + a[8] * a[8] + a[9] * a[9] + a[10] * a[10] + a[11] * a[11] + a[12] * a[12] + a[13] * a[13] + a[14] * a[14] + a[15] * a[15]);
}
function $6e69ca24f4636b79$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    out[4] = a[4] + b[4];
    out[5] = a[5] + b[5];
    out[6] = a[6] + b[6];
    out[7] = a[7] + b[7];
    out[8] = a[8] + b[8];
    out[9] = a[9] + b[9];
    out[10] = a[10] + b[10];
    out[11] = a[11] + b[11];
    out[12] = a[12] + b[12];
    out[13] = a[13] + b[13];
    out[14] = a[14] + b[14];
    out[15] = a[15] + b[15];
    return out;
}
function $6e69ca24f4636b79$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    out[3] = a[3] - b[3];
    out[4] = a[4] - b[4];
    out[5] = a[5] - b[5];
    out[6] = a[6] - b[6];
    out[7] = a[7] - b[7];
    out[8] = a[8] - b[8];
    out[9] = a[9] - b[9];
    out[10] = a[10] - b[10];
    out[11] = a[11] - b[11];
    out[12] = a[12] - b[12];
    out[13] = a[13] - b[13];
    out[14] = a[14] - b[14];
    out[15] = a[15] - b[15];
    return out;
}
function $6e69ca24f4636b79$export$c697bed75648cdb7(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    out[4] = a[4] * b;
    out[5] = a[5] * b;
    out[6] = a[6] * b;
    out[7] = a[7] * b;
    out[8] = a[8] * b;
    out[9] = a[9] * b;
    out[10] = a[10] * b;
    out[11] = a[11] * b;
    out[12] = a[12] * b;
    out[13] = a[13] * b;
    out[14] = a[14] * b;
    out[15] = a[15] * b;
    return out;
}
function $6e69ca24f4636b79$export$553579f63bdd7137(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    out[3] = a[3] + b[3] * scale;
    out[4] = a[4] + b[4] * scale;
    out[5] = a[5] + b[5] * scale;
    out[6] = a[6] + b[6] * scale;
    out[7] = a[7] + b[7] * scale;
    out[8] = a[8] + b[8] * scale;
    out[9] = a[9] + b[9] * scale;
    out[10] = a[10] + b[10] * scale;
    out[11] = a[11] + b[11] * scale;
    out[12] = a[12] + b[12] * scale;
    out[13] = a[13] + b[13] * scale;
    out[14] = a[14] + b[14] * scale;
    out[15] = a[15] + b[15] * scale;
    return out;
}
function $6e69ca24f4636b79$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3] && a[4] === b[4] && a[5] === b[5] && a[6] === b[6] && a[7] === b[7] && a[8] === b[8] && a[9] === b[9] && a[10] === b[10] && a[11] === b[11] && a[12] === b[12] && a[13] === b[13] && a[14] === b[14] && a[15] === b[15];
}
function $6e69ca24f4636b79$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    var a4 = a[4], a5 = a[5], a6 = a[6], a7 = a[7];
    var a8 = a[8], a9 = a[9], a10 = a[10], a11 = a[11];
    var a12 = a[12], a13 = a[13], a14 = a[14], a15 = a[15];
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    var b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7];
    var b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11];
    var b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
    return Math.abs(a0 - b0) <= $b3d72613362f56f7$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $b3d72613362f56f7$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $b3d72613362f56f7$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= $b3d72613362f56f7$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a3), Math.abs(b3)) && Math.abs(a4 - b4) <= $b3d72613362f56f7$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a4), Math.abs(b4)) && Math.abs(a5 - b5) <= $b3d72613362f56f7$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a5), Math.abs(b5)) && Math.abs(a6 - b6) <= $b3d72613362f56f7$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a6), Math.abs(b6)) && Math.abs(a7 - b7) <= $b3d72613362f56f7$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a7), Math.abs(b7)) && Math.abs(a8 - b8) <= $b3d72613362f56f7$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a8), Math.abs(b8)) && Math.abs(a9 - b9) <= $b3d72613362f56f7$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a9), Math.abs(b9)) && Math.abs(a10 - b10) <= $b3d72613362f56f7$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a10), Math.abs(b10)) && Math.abs(a11 - b11) <= $b3d72613362f56f7$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a11), Math.abs(b11)) && Math.abs(a12 - b12) <= $b3d72613362f56f7$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a12), Math.abs(b12)) && Math.abs(a13 - b13) <= $b3d72613362f56f7$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a13), Math.abs(b13)) && Math.abs(a14 - b14) <= $b3d72613362f56f7$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a14), Math.abs(b14)) && Math.abs(a15 - b15) <= $b3d72613362f56f7$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a15), Math.abs(b15));
}
var $6e69ca24f4636b79$export$6e3a27864ab166fe = $6e69ca24f4636b79$export$2060d2db72cce88f;
var $6e69ca24f4636b79$export$f93b5905241a7cca = $6e69ca24f4636b79$export$4e2d2ead65e5f7e3;

var $8f228f84b1e7d967$exports = {};

$parcel$export($8f228f84b1e7d967$exports, "create", () => $8f228f84b1e7d967$export$185802fd694ee1f5);
$parcel$export($8f228f84b1e7d967$exports, "clone", () => $8f228f84b1e7d967$export$9cd59f9826255e47);
$parcel$export($8f228f84b1e7d967$exports, "length", () => $8f228f84b1e7d967$export$f24224f1c91d8156);
$parcel$export($8f228f84b1e7d967$exports, "fromValues", () => $8f228f84b1e7d967$export$a82be99ed2a44a7d);
$parcel$export($8f228f84b1e7d967$exports, "copy", () => $8f228f84b1e7d967$export$784d13d8ee351f07);
$parcel$export($8f228f84b1e7d967$exports, "set", () => $8f228f84b1e7d967$export$adaa4cf7ef1b65be);
$parcel$export($8f228f84b1e7d967$exports, "add", () => $8f228f84b1e7d967$export$e16d8520af44a096);
$parcel$export($8f228f84b1e7d967$exports, "subtract", () => $8f228f84b1e7d967$export$4e2d2ead65e5f7e3);
$parcel$export($8f228f84b1e7d967$exports, "multiply", () => $8f228f84b1e7d967$export$2060d2db72cce88f);
$parcel$export($8f228f84b1e7d967$exports, "divide", () => $8f228f84b1e7d967$export$cd007d971a5a2143);
$parcel$export($8f228f84b1e7d967$exports, "ceil", () => $8f228f84b1e7d967$export$803ce6b71a0a94b2);
$parcel$export($8f228f84b1e7d967$exports, "floor", () => $8f228f84b1e7d967$export$a3fe094919f356fd);
$parcel$export($8f228f84b1e7d967$exports, "min", () => $8f228f84b1e7d967$export$96ec731ed4dcb222);
$parcel$export($8f228f84b1e7d967$exports, "max", () => $8f228f84b1e7d967$export$8960430cfd85939f);
$parcel$export($8f228f84b1e7d967$exports, "round", () => $8f228f84b1e7d967$export$2077e0241d6afd3c);
$parcel$export($8f228f84b1e7d967$exports, "scale", () => $8f228f84b1e7d967$export$dcdf75081b88279d);
$parcel$export($8f228f84b1e7d967$exports, "scaleAndAdd", () => $8f228f84b1e7d967$export$19cedf1da84ba854);
$parcel$export($8f228f84b1e7d967$exports, "distance", () => $8f228f84b1e7d967$export$9f17032d917177de);
$parcel$export($8f228f84b1e7d967$exports, "squaredDistance", () => $8f228f84b1e7d967$export$88e6ebb4fe54f538);
$parcel$export($8f228f84b1e7d967$exports, "squaredLength", () => $8f228f84b1e7d967$export$ab44e1323ffc8376);
$parcel$export($8f228f84b1e7d967$exports, "negate", () => $8f228f84b1e7d967$export$aef51622e549b8b0);
$parcel$export($8f228f84b1e7d967$exports, "inverse", () => $8f228f84b1e7d967$export$70ae2c07e401031b);
$parcel$export($8f228f84b1e7d967$exports, "normalize", () => $8f228f84b1e7d967$export$a3295358bff77e);
$parcel$export($8f228f84b1e7d967$exports, "dot", () => $8f228f84b1e7d967$export$94132a0e348806d4);
$parcel$export($8f228f84b1e7d967$exports, "cross", () => $8f228f84b1e7d967$export$bb646b20bb93d339);
$parcel$export($8f228f84b1e7d967$exports, "lerp", () => $8f228f84b1e7d967$export$3a89f8d6f6bf6c9f);
$parcel$export($8f228f84b1e7d967$exports, "slerp", () => $8f228f84b1e7d967$export$1544d9bc2995de08);
$parcel$export($8f228f84b1e7d967$exports, "hermite", () => $8f228f84b1e7d967$export$ae8865616f30561c);
$parcel$export($8f228f84b1e7d967$exports, "bezier", () => $8f228f84b1e7d967$export$b9c5f84610baddaf);
$parcel$export($8f228f84b1e7d967$exports, "random", () => $8f228f84b1e7d967$export$4385e60b38654f68);
$parcel$export($8f228f84b1e7d967$exports, "transformMat4", () => $8f228f84b1e7d967$export$5ffbd13800309d59);
$parcel$export($8f228f84b1e7d967$exports, "transformMat3", () => $8f228f84b1e7d967$export$f0bfa0a0024626ee);
$parcel$export($8f228f84b1e7d967$exports, "transformQuat", () => $8f228f84b1e7d967$export$c32adef9e939ce85);
$parcel$export($8f228f84b1e7d967$exports, "rotateX", () => $8f228f84b1e7d967$export$a59c8716592e09af);
$parcel$export($8f228f84b1e7d967$exports, "rotateY", () => $8f228f84b1e7d967$export$cf71e4d4ca4d1cfd);
$parcel$export($8f228f84b1e7d967$exports, "rotateZ", () => $8f228f84b1e7d967$export$ea6eae3365de5b9c);
$parcel$export($8f228f84b1e7d967$exports, "angle", () => $8f228f84b1e7d967$export$944b09d2ad10b378);
$parcel$export($8f228f84b1e7d967$exports, "zero", () => $8f228f84b1e7d967$export$7f9972325ebfd559);
$parcel$export($8f228f84b1e7d967$exports, "str", () => $8f228f84b1e7d967$export$42d51816ce590c93);
$parcel$export($8f228f84b1e7d967$exports, "exactEquals", () => $8f228f84b1e7d967$export$f2599a5cf1109d8);
$parcel$export($8f228f84b1e7d967$exports, "equals", () => $8f228f84b1e7d967$export$e9bab7fafb253603);
$parcel$export($8f228f84b1e7d967$exports, "sub", () => $8f228f84b1e7d967$export$f93b5905241a7cca);
$parcel$export($8f228f84b1e7d967$exports, "mul", () => $8f228f84b1e7d967$export$6e3a27864ab166fe);
$parcel$export($8f228f84b1e7d967$exports, "div", () => $8f228f84b1e7d967$export$159d9494db57879b);
$parcel$export($8f228f84b1e7d967$exports, "dist", () => $8f228f84b1e7d967$export$6c4a311cc157c764);
$parcel$export($8f228f84b1e7d967$exports, "sqrDist", () => $8f228f84b1e7d967$export$2422cd6c492a8b3a);
$parcel$export($8f228f84b1e7d967$exports, "len", () => $8f228f84b1e7d967$export$fc1400facf92c78);
$parcel$export($8f228f84b1e7d967$exports, "sqrLen", () => $8f228f84b1e7d967$export$99d8dd3f32a3435);
$parcel$export($8f228f84b1e7d967$exports, "forEach", () => $8f228f84b1e7d967$export$4b80e395e36b5a56);

function $8f228f84b1e7d967$export$185802fd694ee1f5() {
    var out = new $b3d72613362f56f7$export$b67359430d3b1b2(3);
    if ($b3d72613362f56f7$export$b67359430d3b1b2 != Float32Array) {
        out[0] = 0;
        out[1] = 0;
        out[2] = 0;
    }
    return out;
}
function $8f228f84b1e7d967$export$9cd59f9826255e47(a) {
    var out = new $b3d72613362f56f7$export$b67359430d3b1b2(3);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    return out;
}
function $8f228f84b1e7d967$export$f24224f1c91d8156(a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    return Math.sqrt(x * x + y * y + z * z);
}
function $8f228f84b1e7d967$export$a82be99ed2a44a7d(x, y, z) {
    var out = new $b3d72613362f56f7$export$b67359430d3b1b2(3);
    out[0] = x;
    out[1] = y;
    out[2] = z;
    return out;
}
function $8f228f84b1e7d967$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    return out;
}
function $8f228f84b1e7d967$export$adaa4cf7ef1b65be(out, x, y, z) {
    out[0] = x;
    out[1] = y;
    out[2] = z;
    return out;
}
function $8f228f84b1e7d967$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    return out;
}
function $8f228f84b1e7d967$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    return out;
}
function $8f228f84b1e7d967$export$2060d2db72cce88f(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    out[2] = a[2] * b[2];
    return out;
}
function $8f228f84b1e7d967$export$cd007d971a5a2143(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    out[2] = a[2] / b[2];
    return out;
}
function $8f228f84b1e7d967$export$803ce6b71a0a94b2(out, a) {
    out[0] = Math.ceil(a[0]);
    out[1] = Math.ceil(a[1]);
    out[2] = Math.ceil(a[2]);
    return out;
}
function $8f228f84b1e7d967$export$a3fe094919f356fd(out, a) {
    out[0] = Math.floor(a[0]);
    out[1] = Math.floor(a[1]);
    out[2] = Math.floor(a[2]);
    return out;
}
function $8f228f84b1e7d967$export$96ec731ed4dcb222(out, a, b) {
    out[0] = Math.min(a[0], b[0]);
    out[1] = Math.min(a[1], b[1]);
    out[2] = Math.min(a[2], b[2]);
    return out;
}
function $8f228f84b1e7d967$export$8960430cfd85939f(out, a, b) {
    out[0] = Math.max(a[0], b[0]);
    out[1] = Math.max(a[1], b[1]);
    out[2] = Math.max(a[2], b[2]);
    return out;
}
function $8f228f84b1e7d967$export$2077e0241d6afd3c(out, a) {
    out[0] = $b3d72613362f56f7$export$2077e0241d6afd3c(a[0]);
    out[1] = $b3d72613362f56f7$export$2077e0241d6afd3c(a[1]);
    out[2] = $b3d72613362f56f7$export$2077e0241d6afd3c(a[2]);
    return out;
}
function $8f228f84b1e7d967$export$dcdf75081b88279d(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    return out;
}
function $8f228f84b1e7d967$export$19cedf1da84ba854(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    return out;
}
function $8f228f84b1e7d967$export$9f17032d917177de(a, b) {
    var x = b[0] - a[0];
    var y = b[1] - a[1];
    var z = b[2] - a[2];
    return Math.sqrt(x * x + y * y + z * z);
}
function $8f228f84b1e7d967$export$88e6ebb4fe54f538(a, b) {
    var x = b[0] - a[0];
    var y = b[1] - a[1];
    var z = b[2] - a[2];
    return x * x + y * y + z * z;
}
function $8f228f84b1e7d967$export$ab44e1323ffc8376(a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    return x * x + y * y + z * z;
}
function $8f228f84b1e7d967$export$aef51622e549b8b0(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    out[2] = -a[2];
    return out;
}
function $8f228f84b1e7d967$export$70ae2c07e401031b(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    out[2] = 1.0 / a[2];
    return out;
}
function $8f228f84b1e7d967$export$a3295358bff77e(out, a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    var len = x * x + y * y + z * z;
    if (len > 0) //TODO: evaluate use of glm_invsqrt here?
    len = 1 / Math.sqrt(len);
    out[0] = a[0] * len;
    out[1] = a[1] * len;
    out[2] = a[2] * len;
    return out;
}
function $8f228f84b1e7d967$export$94132a0e348806d4(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
function $8f228f84b1e7d967$export$bb646b20bb93d339(out, a, b) {
    var ax = a[0], ay = a[1], az = a[2];
    var bx = b[0], by = b[1], bz = b[2];
    out[0] = ay * bz - az * by;
    out[1] = az * bx - ax * bz;
    out[2] = ax * by - ay * bx;
    return out;
}
function $8f228f84b1e7d967$export$3a89f8d6f6bf6c9f(out, a, b, t) {
    var ax = a[0];
    var ay = a[1];
    var az = a[2];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    out[2] = az + t * (b[2] - az);
    return out;
}
function $8f228f84b1e7d967$export$1544d9bc2995de08(out, a, b, t) {
    var angle = Math.acos(Math.min(Math.max($8f228f84b1e7d967$export$94132a0e348806d4(a, b), -1), 1));
    var sinTotal = Math.sin(angle);
    var ratioA = Math.sin((1 - t) * angle) / sinTotal;
    var ratioB = Math.sin(t * angle) / sinTotal;
    out[0] = ratioA * a[0] + ratioB * b[0];
    out[1] = ratioA * a[1] + ratioB * b[1];
    out[2] = ratioA * a[2] + ratioB * b[2];
    return out;
}
function $8f228f84b1e7d967$export$ae8865616f30561c(out, a, b, c, d, t) {
    var factorTimes2 = t * t;
    var factor1 = factorTimes2 * (2 * t - 3) + 1;
    var factor2 = factorTimes2 * (t - 2) + t;
    var factor3 = factorTimes2 * (t - 1);
    var factor4 = factorTimes2 * (3 - 2 * t);
    out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
    out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
    out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;
    return out;
}
function $8f228f84b1e7d967$export$b9c5f84610baddaf(out, a, b, c, d, t) {
    var inverseFactor = 1 - t;
    var inverseFactorTimesTwo = inverseFactor * inverseFactor;
    var factorTimes2 = t * t;
    var factor1 = inverseFactorTimesTwo * inverseFactor;
    var factor2 = 3 * t * inverseFactorTimesTwo;
    var factor3 = 3 * factorTimes2 * inverseFactor;
    var factor4 = factorTimes2 * t;
    out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
    out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
    out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;
    return out;
}
function $8f228f84b1e7d967$export$4385e60b38654f68(out, scale) {
    scale = scale === undefined ? 1.0 : scale;
    var r = $b3d72613362f56f7$export$5ada478c8a628231() * 2.0 * Math.PI;
    var z = $b3d72613362f56f7$export$5ada478c8a628231() * 2.0 - 1.0;
    var zScale = Math.sqrt(1.0 - z * z) * scale;
    out[0] = Math.cos(r) * zScale;
    out[1] = Math.sin(r) * zScale;
    out[2] = z * scale;
    return out;
}
function $8f228f84b1e7d967$export$5ffbd13800309d59(out, a, m) {
    var x = a[0], y = a[1], z = a[2];
    var w = m[3] * x + m[7] * y + m[11] * z + m[15];
    w = w || 1.0;
    out[0] = (m[0] * x + m[4] * y + m[8] * z + m[12]) / w;
    out[1] = (m[1] * x + m[5] * y + m[9] * z + m[13]) / w;
    out[2] = (m[2] * x + m[6] * y + m[10] * z + m[14]) / w;
    return out;
}
function $8f228f84b1e7d967$export$f0bfa0a0024626ee(out, a, m) {
    var x = a[0], y = a[1], z = a[2];
    out[0] = x * m[0] + y * m[3] + z * m[6];
    out[1] = x * m[1] + y * m[4] + z * m[7];
    out[2] = x * m[2] + y * m[5] + z * m[8];
    return out;
}
function $8f228f84b1e7d967$export$c32adef9e939ce85(out, a, q) {
    // Fast Vector Rotation using Quaternions by Robert Eisele
    // https://raw.org/proof/vector-rotation-using-quaternions/
    var qx = q[0], qy = q[1], qz = q[2], qw = q[3];
    var vx = a[0], vy = a[1], vz = a[2];
    // t = q x v
    var tx = qy * vz - qz * vy;
    var ty = qz * vx - qx * vz;
    var tz = qx * vy - qy * vx;
    // t = 2t
    tx = tx + tx;
    ty = ty + ty;
    tz = tz + tz;
    // v + w t + q x t
    out[0] = vx + qw * tx + qy * tz - qz * ty;
    out[1] = vy + qw * ty + qz * tx - qx * tz;
    out[2] = vz + qw * tz + qx * ty - qy * tx;
    return out;
}
function $8f228f84b1e7d967$export$a59c8716592e09af(out, a, b, rad) {
    var p = [], r = [];
    //Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2];
    //perform rotation
    r[0] = p[0];
    r[1] = p[1] * Math.cos(rad) - p[2] * Math.sin(rad);
    r[2] = p[1] * Math.sin(rad) + p[2] * Math.cos(rad);
    //translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
}
function $8f228f84b1e7d967$export$cf71e4d4ca4d1cfd(out, a, b, rad) {
    var p = [], r = [];
    //Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2];
    //perform rotation
    r[0] = p[2] * Math.sin(rad) + p[0] * Math.cos(rad);
    r[1] = p[1];
    r[2] = p[2] * Math.cos(rad) - p[0] * Math.sin(rad);
    //translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
}
function $8f228f84b1e7d967$export$ea6eae3365de5b9c(out, a, b, rad) {
    var p = [], r = [];
    //Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2];
    //perform rotation
    r[0] = p[0] * Math.cos(rad) - p[1] * Math.sin(rad);
    r[1] = p[0] * Math.sin(rad) + p[1] * Math.cos(rad);
    r[2] = p[2];
    //translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
}
function $8f228f84b1e7d967$export$944b09d2ad10b378(a, b) {
    var ax = a[0], ay = a[1], az = a[2], bx = b[0], by = b[1], bz = b[2], mag = Math.sqrt((ax * ax + ay * ay + az * az) * (bx * bx + by * by + bz * bz)), cosine = mag && $8f228f84b1e7d967$export$94132a0e348806d4(a, b) / mag;
    return Math.acos(Math.min(Math.max(cosine, -1), 1));
}
function $8f228f84b1e7d967$export$7f9972325ebfd559(out) {
    out[0] = 0.0;
    out[1] = 0.0;
    out[2] = 0.0;
    return out;
}
function $8f228f84b1e7d967$export$42d51816ce590c93(a) {
    return "vec3(" + a[0] + ", " + a[1] + ", " + a[2] + ")";
}
function $8f228f84b1e7d967$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2];
}
function $8f228f84b1e7d967$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2];
    var b0 = b[0], b1 = b[1], b2 = b[2];
    return Math.abs(a0 - b0) <= $b3d72613362f56f7$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $b3d72613362f56f7$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $b3d72613362f56f7$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a2), Math.abs(b2));
}
var $8f228f84b1e7d967$export$f93b5905241a7cca = $8f228f84b1e7d967$export$4e2d2ead65e5f7e3;
var $8f228f84b1e7d967$export$6e3a27864ab166fe = $8f228f84b1e7d967$export$2060d2db72cce88f;
var $8f228f84b1e7d967$export$159d9494db57879b = $8f228f84b1e7d967$export$cd007d971a5a2143;
var $8f228f84b1e7d967$export$6c4a311cc157c764 = $8f228f84b1e7d967$export$9f17032d917177de;
var $8f228f84b1e7d967$export$2422cd6c492a8b3a = $8f228f84b1e7d967$export$88e6ebb4fe54f538;
var $8f228f84b1e7d967$export$fc1400facf92c78 = $8f228f84b1e7d967$export$f24224f1c91d8156;
var $8f228f84b1e7d967$export$99d8dd3f32a3435 = $8f228f84b1e7d967$export$ab44e1323ffc8376;
var $8f228f84b1e7d967$export$4b80e395e36b5a56 = function() {
    var vec = $8f228f84b1e7d967$export$185802fd694ee1f5();
    return function(a, stride, offset, count, fn, arg) {
        var i, l;
        if (!stride) stride = 3;
        if (!offset) offset = 0;
        if (count) l = Math.min(count * stride + offset, a.length);
        else l = a.length;
        for(i = offset; i < l; i += stride){
            vec[0] = a[i];
            vec[1] = a[i + 1];
            vec[2] = a[i + 2];
            fn(vec, vec, arg);
            a[i] = vec[0];
            a[i + 1] = vec[1];
            a[i + 2] = vec[2];
        }
        return a;
    };
}();



// Shared shader code - enhanced environment and reflections
const $69f13b8a7d15be5e$var$COMMON_SHADER = `
	// Environment colors
	const vec3 SUN_COLOR = vec3(1.0, 0.95, 0.85);
	const vec3 SUN_DIR = normalize(vec3(0.4, 0.7, 0.3));
	const vec3 SKY_ZENITH = vec3(0.22, 0.4, 0.75);
	const vec3 SKY_HORIZON = vec3(0.55, 0.65, 0.8);
	const vec3 GROUND_COLOR = vec3(0.06, 0.05, 0.04);
	
	// Enhanced sky with clouds for better reflections
	vec3 getSkyColor(vec3 dir) {
		float y = max(dir.y, 0.0);
		
		// Multi-layer sky gradient
		vec3 sky = mix(SKY_HORIZON, SKY_ZENITH, pow(y, 0.35));
		
		// Atmospheric scattering
		float horizon = 1.0 - pow(y, 0.25);
		sky = mix(sky, vec3(0.7, 0.75, 0.85), horizon * 0.4);
		
		// Fake clouds for interesting reflections
		float cloudNoise = sin(dir.x * 3.0) * sin(dir.z * 2.5) * 0.5 + 0.5;
		cloudNoise *= sin(dir.x * 7.0 + dir.z * 5.0) * 0.5 + 0.5;
		float cloudMask = smoothstep(0.1, 0.6, y) * smoothstep(0.9, 0.5, y);
		vec3 cloudColor = vec3(0.9, 0.92, 0.95);
		sky = mix(sky, cloudColor, cloudNoise * cloudMask * 0.3);
		
		// Sun glow
		float sunDot = max(dot(dir, SUN_DIR), 0.0);
		vec3 sunGlow = SUN_COLOR * pow(sunDot, 6.0) * 0.5;
		vec3 sunCore = SUN_COLOR * pow(sunDot, 48.0) * 1.2;
		vec3 sunDisc = vec3(1.0, 0.98, 0.95) * pow(sunDot, 400.0) * 2.5;
		
		return sky + sunGlow + sunCore + sunDisc;
	}
	
	// Get environment color for reflections (includes ground)
	vec3 getEnvironmentColor(vec3 dir) {
		if (dir.y < 0.0) {
			// Ground reflection - darker with gradient
			float groundFade = smoothstep(-0.5, 0.0, dir.y);
			vec3 groundReflect = GROUND_COLOR * 0.4;
			return mix(groundReflect, SKY_HORIZON * 0.3, groundFade);
		}
		return getSkyColor(dir);
	}
	
	// Sample environment at multiple roughness levels (fake mip mapping)
	vec3 sampleEnvironmentBlurred(vec3 R, float roughness) {
		vec3 color = vec3(0.0);
		
		if (roughness < 0.1) {
			// Sharp reflection
			return getEnvironmentColor(R);
		}
		
		// Blur by sampling multiple directions
		float blur = roughness * 0.5;
		vec3 up = abs(R.y) < 0.999 ? vec3(0.0, 1.0, 0.0) : vec3(1.0, 0.0, 0.0);
		vec3 tangent = normalize(cross(up, R));
		vec3 bitangent = cross(R, tangent);
		
		// Sample in a cone pattern
		color += getEnvironmentColor(R) * 0.4;
		color += getEnvironmentColor(normalize(R + tangent * blur)) * 0.15;
		color += getEnvironmentColor(normalize(R - tangent * blur)) * 0.15;
		color += getEnvironmentColor(normalize(R + bitangent * blur)) * 0.15;
		color += getEnvironmentColor(normalize(R - bitangent * blur)) * 0.15;
		
		return color;
	}
	
	// Height-based shadow estimation
	float estimateShadow(vec3 worldPos) {
		float heightFade = smoothstep(0.0, 8.0, worldPos.y);
		return mix(0.35, 1.0, heightFade);
	}
	
	// Ambient occlusion approximation
	float approximateAO(vec3 N, vec3 worldPos) {
		float aoFromNormal = N.y * 0.5 + 0.5;
		aoFromNormal = pow(aoFromNormal, 0.4);
		float groundAO = smoothstep(0.0, 2.0, worldPos.y);
		groundAO = mix(0.4, 1.0, groundAO);
		return aoFromNormal * groundAO;
	}
`;
// Main object shader with enhanced PBR and reflections
const $69f13b8a7d15be5e$var$MAIN_VS = `
	attribute vec3 aPosition;
	attribute vec3 aNormal;
	attribute vec3 aColor;

	uniform mat4 uProjection;
	uniform mat4 uView;
	uniform mat4 uModel;
	uniform mat4 uNormalMatrix;

	varying vec3 vNormal;
	varying vec3 vPosition;
	varying vec3 vColor;
	varying vec3 vWorldPos;
	varying vec3 vTangent;

	void main() {
		vec4 worldPos = uModel * vec4(aPosition, 1.0);
		vWorldPos = worldPos.xyz;
		vPosition = (uView * worldPos).xyz;
		vNormal = normalize((uNormalMatrix * vec4(aNormal, 0.0)).xyz);
		vColor = aColor;
		
		// Generate tangent for anisotropic shading (along track direction)
		vec3 up = vec3(0.0, 1.0, 0.0);
		vTangent = normalize(cross(vNormal, up));
		if (length(vTangent) < 0.1) {
			vTangent = normalize(cross(vNormal, vec3(1.0, 0.0, 0.0)));
		}
		
		gl_Position = uProjection * uView * worldPos;
	}
`;
const $69f13b8a7d15be5e$var$MAIN_FS = `
	precision highp float;

	varying vec3 vNormal;
	varying vec3 vPosition;
	varying vec3 vColor;
	varying vec3 vWorldPos;
	varying vec3 vTangent;

	uniform vec3 uCameraPos;
	uniform float uMetallic;
	uniform float uRoughness;
	uniform float uTime;
	uniform int uIsMarble;
	uniform int uIsGround;

	${$69f13b8a7d15be5e$var$COMMON_SHADER}

	// Fresnel with roughness consideration
	vec3 fresnelSchlickRoughness(float cosTheta, vec3 F0, float roughness) {
		return F0 + (max(vec3(1.0 - roughness), F0) - F0) * pow(clamp(1.0 - cosTheta, 0.0, 1.0), 5.0);
	}
	
	vec3 fresnelSchlick(float cosTheta, vec3 F0) {
		return F0 + (1.0 - F0) * pow(clamp(1.0 - cosTheta, 0.0, 1.0), 5.0);
	}

	// GGX Distribution
	float distributionGGX(float NdotH, float roughness) {
		float a = roughness * roughness;
		float a2 = a * a;
		float denom = NdotH * NdotH * (a2 - 1.0) + 1.0;
		return a2 / (3.14159 * denom * denom + 0.0001);
	}
	
	// Anisotropic GGX for brushed metal
	float distributionGGXAnisotropic(float NdotH, float TdotH, float BdotH, float ax, float ay) {
		float d = TdotH * TdotH / (ax * ax) + BdotH * BdotH / (ay * ay) + NdotH * NdotH;
		return 1.0 / (3.14159 * ax * ay * d * d + 0.0001);
	}

	// Geometry function
	float geometrySmith(float NdotV, float NdotL, float roughness) {
		float k = (roughness + 1.0) * (roughness + 1.0) / 8.0;
		float ggx1 = NdotV / (NdotV * (1.0 - k) + k);
		float ggx2 = NdotL / (NdotL * (1.0 - k) + k);
		return ggx1 * ggx2;
	}

	void main() {
		vec3 N = normalize(vNormal);
		vec3 V = normalize(uCameraPos - vWorldPos);
		vec3 R = reflect(-V, N);
		vec3 T = normalize(vTangent);
		vec3 B = normalize(cross(N, T));
		
		vec3 baseColor = vColor;
		float metallic = uMetallic;
		float roughness = uRoughness;
		
		// Marble swirl pattern
		if (uIsMarble == 1) {
			float swirl = sin(vWorldPos.x * 25.0 + vWorldPos.y * 20.0 + vWorldPos.z * 15.0 + uTime * 2.0) * 0.5 + 0.5;
			float swirl2 = sin(vWorldPos.x * 10.0 - vWorldPos.z * 12.0 + uTime * 1.5) * 0.5 + 0.5;
			// Green marble swirl pattern
			baseColor = mix(baseColor, vec3(0.05, 0.25, 0.1), swirl * 0.35);
			baseColor = mix(baseColor, vec3(0.15, 0.5, 0.2), pow(swirl, 4.0) * 0.2);
			baseColor = mix(baseColor, vec3(0.02, 0.15, 0.05), swirl2 * 0.15);
		}

		// Metal F0 - use base color for metals
		vec3 F0 = mix(vec3(0.04), baseColor, metallic);
		
		// Shadow and AO
		float shadow = estimateShadow(vWorldPos);
		float ao = approximateAO(N, vWorldPos);
		
		// === Direct Lighting (Sun) ===
		vec3 L = SUN_DIR;
		vec3 H = normalize(V + L);
		
		float NdotL = max(dot(N, L), 0.0);
		float NdotH = max(dot(N, H), 0.0);
		float NdotV = max(dot(N, V), 0.001);
		float HdotV = max(dot(H, V), 0.0);
		
		// Anisotropic parameters for metals (brushed metal look)
		float TdotH = dot(T, H);
		float BdotH = dot(B, H);
		float anisotropy = metallic * 0.7; // More anisotropy for metals
		float ax = max(0.001, roughness * (1.0 + anisotropy));
		float ay = max(0.001, roughness * (1.0 - anisotropy * 0.5));
		
		// Use anisotropic distribution for high metallic surfaces
		float D;
		if (metallic > 0.5) {
			D = distributionGGXAnisotropic(NdotH, TdotH, BdotH, ax, ay);
		} else {
			D = distributionGGX(NdotH, roughness);
		}
		
		vec3 F = fresnelSchlick(HdotV, F0);
		float G = geometrySmith(NdotV, NdotL, roughness);
		
		vec3 specular = (D * G * F) / (4.0 * NdotV * NdotL + 0.001);
		vec3 kD = (1.0 - F) * (1.0 - metallic);
		
		vec3 sunLight = SUN_COLOR * 2.0;
		vec3 directLight = (kD * baseColor / 3.14159 + specular) * sunLight * NdotL * shadow;
		
		// === Environment Reflections (IBL approximation) ===
		vec3 F_env = fresnelSchlickRoughness(NdotV, F0, roughness);
		
		// Sample environment with roughness-based blur
		vec3 envReflection = sampleEnvironmentBlurred(R, roughness);
		
		// Metallic surfaces get more reflection
		float envStrength = mix(0.15, 0.9, metallic) * (1.0 - roughness * 0.7);
		vec3 reflectionColor = envReflection * F_env * envStrength;
		
		// Add secondary reflection bounce for extra realism on metals
		if (metallic > 0.5) {
			vec3 R2 = reflect(R, N);
			vec3 secondBounce = sampleEnvironmentBlurred(R2, roughness + 0.3) * 0.15;
			reflectionColor += secondBounce * F_env * metallic;
		}
		
		// === Fill Lights ===
		vec3 fillDir = normalize(vec3(-0.5, 0.3, -0.4));
		float fillNdotL = max(dot(N, fillDir), 0.0);
		vec3 fillLight = SKY_ZENITH * 0.2 * fillNdotL * baseColor * (1.0 - metallic * 0.5);
		
		vec3 backDir = normalize(vec3(0.0, 0.2, -1.0));
		float backNdotL = max(dot(N, backDir), 0.0);
		vec3 backLight = vec3(0.12, 0.15, 0.2) * backNdotL * baseColor;
		
		// === Ambient/Diffuse IBL ===
		float hemisphere = N.y * 0.5 + 0.5;
		vec3 ambientColor = mix(GROUND_COLOR * 0.3, SKY_ZENITH * 0.2, hemisphere);
		vec3 ambient = baseColor * ambientColor * ao * (1.0 - metallic * 0.8);
		
		// === Combine ===
		vec3 result = directLight + reflectionColor + fillLight + backLight + ambient;
		
		// Rim lighting - stronger on metals for that chrome look
		float rim = 1.0 - NdotV;
		rim = pow(rim, 3.0);
		float rimStrength = mix(0.05, 0.25, metallic);
		result += rim * getSkyColor(R) * rimStrength;
		
		// Extra rim glow for marble
		if (uIsMarble == 1) {
			result += rim * vec3(0.2, 0.5, 0.25) * 0.25;
		}
		
		// === REFLECTIVE FLOOR WITH PLATFORM ===
		if (uIsGround == 1) {
			float distFromCenter = length(vWorldPos.xz);
			float platformRadius = 40.0;
			
			// Floor material properties
			vec3 floorAlbedo = vec3(0.15, 0.15, 0.17);
			float floorMetallic = 0.0;
			float floorRoughness = 0.3;
			
			// Grid pattern modifies albedo
			float gridScale = 2.0;
			float gridLineWidth = 0.02;
			float gridX = abs(fract(vWorldPos.x / gridScale) - 0.5);
			float gridZ = abs(fract(vWorldPos.z / gridScale) - 0.5);
			float grid = 1.0 - smoothstep(gridLineWidth, gridLineWidth + 0.015, min(gridX, gridZ));
			
			float majorGridScale = 10.0;
			float majorGridX = abs(fract(vWorldPos.x / majorGridScale) - 0.5);
			float majorGridZ = abs(fract(vWorldPos.z / majorGridScale) - 0.5);
			float majorGrid = 1.0 - smoothstep(gridLineWidth * 2.0, gridLineWidth * 2.0 + 0.015, min(majorGridX, majorGridZ));
			
			vec3 gridColor = vec3(0.25, 0.27, 0.32);
			floorAlbedo = mix(floorAlbedo, gridColor, grid * 0.4 + majorGrid * 0.6);
			
			// Use same PBR lighting as other objects
			vec3 floorN = vec3(0.0, 1.0, 0.0);
			vec3 floorR = reflect(-V, floorN);
			float floorNdotV = max(dot(floorN, V), 0.0);
			float floorNdotL = max(dot(floorN, SUN_DIR), 0.0);
			vec3 floorH = normalize(V + SUN_DIR);
			float floorNdotH = max(dot(floorN, floorH), 0.0);
			
			// PBR calculations
			vec3 floorF0 = mix(vec3(0.04), floorAlbedo, floorMetallic);
			vec3 floorF = fresnelSchlickRoughness(floorNdotV, floorF0, floorRoughness);
			float floorD = distributionGGX(floorNdotH, floorRoughness);
			float floorG = geometrySmith(floorNdotV, floorNdotL, floorRoughness);
			
			// Specular
			vec3 floorSpec = (floorD * floorG * floorF) / (4.0 * floorNdotV * floorNdotL + 0.0001);
			
			// Diffuse
			vec3 floorKd = (1.0 - floorF) * (1.0 - floorMetallic);
			vec3 floorDiffuse = floorKd * floorAlbedo / 3.14159;
			
			// Direct lighting from sun
			vec3 floorDirect = (floorDiffuse + floorSpec) * SUN_COLOR * floorNdotL * 2.5;
			
			// Ambient/IBL
			vec3 floorAmbient = sampleEnvironmentBlurred(floorN, 0.8) * floorAlbedo * 0.3;
			vec3 floorReflection = sampleEnvironmentBlurred(floorR, floorRoughness);
			float floorFresnel = pow(1.0 - floorNdotV, 3.0);
			floorAmbient += floorReflection * mix(0.2, 0.7, floorFresnel);
			
			vec3 floorResult = floorDirect + floorAmbient;
			
			// Fade to dark at edges
			float edgeFade = smoothstep(platformRadius + 5.0, platformRadius - 5.0, distFromCenter);
			vec3 voidColor = vec3(0.02, 0.02, 0.025);
			floorResult = mix(voidColor, floorResult, edgeFade);
			
			// Subtle edge glow
			float edgeGlow = smoothstep(platformRadius + 1.0, platformRadius - 2.0, distFromCenter) 
			               * smoothstep(platformRadius - 8.0, platformRadius - 2.0, distFromCenter);
			floorResult += vec3(0.08, 0.12, 0.2) * edgeGlow * 0.3;
			
			result = floorResult;
		} else {
			// Apply AO only to non-ground objects
			result *= mix(0.6, 1.0, ao);
		}
		
		// Atmospheric fog (less on ground)
		float dist = length(vPosition);
		float fogFactor = 1.0 - exp(-0.0015 * dist * dist);
		vec3 fogColor = mix(SKY_HORIZON, SKY_ZENITH, 0.2) * 0.6;
		float fogAmount = (uIsGround == 1) ? 0.2 : 0.6;
		result = mix(result, fogColor, fogFactor * fogAmount);
		
		// Tone mapping (ACES)
		vec3 x = result;
		result = (x * (2.51 * x + 0.03)) / (x * (2.43 * x + 0.59) + 0.14);
		
		// Contrast
		result = pow(result, vec3(1.08));
		
		// Gamma
		result = pow(result, vec3(1.0/2.2));
		
		// Screen vignette
		vec2 screenUV = gl_FragCoord.xy / vec2(1920.0, 1080.0);
		float screenVignette = 1.0 - dot(screenUV - 0.5, screenUV - 0.5) * 0.25;
		result *= screenVignette;
		
		gl_FragColor = vec4(result, 1.0);
	}
`;
// Sky shader
const $69f13b8a7d15be5e$var$SKY_VS = `
	attribute vec3 aPosition;
	varying vec3 vDirection;
	uniform mat4 uProjection;
	uniform mat4 uView;
	
	void main() {
		vDirection = aPosition;
		mat4 viewNoTranslation = uView;
		viewNoTranslation[3] = vec4(0.0, 0.0, 0.0, 1.0);
		vec4 pos = uProjection * viewNoTranslation * vec4(aPosition * 100.0, 1.0);
		gl_Position = pos.xyww;
	}
`;
const $69f13b8a7d15be5e$var$SKY_FS = `
	precision highp float;
	varying vec3 vDirection;
	uniform float uTime;
	
	${$69f13b8a7d15be5e$var$COMMON_SHADER}
	
	void main() {
		vec3 dir = normalize(vDirection);
		vec3 color;
		
		if (dir.y < 0.0) {
			// Below horizon
			vec3 groundReflect = GROUND_COLOR * 0.25;
			color = mix(SKY_HORIZON * 0.35, groundReflect, smoothstep(0.0, -0.5, dir.y));
		} else {
			color = getSkyColor(dir);
		}
		
		// Subtle noise
		float noise = fract(sin(dot(dir.xy, vec2(12.9898, 78.233))) * 43758.5453);
		color += (noise - 0.5) * 0.012;
		
		// Tone mapping
		color = (color * (2.51 * color + 0.03)) / (color * (2.43 * color + 0.59) + 0.14);
		color = pow(color, vec3(1.0/2.2));
		
		gl_FragColor = vec4(color, 1.0);
	}
`;
// Particle shader
const $69f13b8a7d15be5e$var$PARTICLE_VS = `
	attribute vec3 aPosition;
	attribute float aSize;
	attribute float aLife;
	attribute vec3 aColor;
	
	uniform mat4 uProjection;
	uniform mat4 uView;
	
	varying float vLife;
	varying vec3 vColor;
	
	void main() {
		vLife = aLife;
		vColor = aColor;
		vec4 viewPos = uView * vec4(aPosition, 1.0);
		gl_Position = uProjection * viewPos;
		gl_PointSize = aSize * (300.0 / -viewPos.z);
	}
`;
const $69f13b8a7d15be5e$var$PARTICLE_FS = `
	precision mediump float;
	varying float vLife;
	varying vec3 vColor;
	
	void main() {
		vec2 coord = gl_PointCoord - vec2(0.5);
		float dist = length(coord);
		if (dist > 0.5) discard;
		
		float alpha = smoothstep(0.5, 0.1, dist) * vLife;
		vec3 color = vColor * (1.0 + vLife * 0.3);
		gl_FragColor = vec4(color, alpha * 0.6);
	}
`;
class $69f13b8a7d15be5e$export$88530751e3977073 {
    constructor(canvas){
        this.canvas = canvas;
        this.gl = canvas.getContext('webgl', {
            antialias: true,
            alpha: false
        });
        if (!this.gl) throw new Error('WebGL not supported');
        this.resize();
        window.addEventListener('resize', ()=>this.resize());
        this.initShaders();
        this.initMatrices();
        this.initSkybox();
        this.time = 0;
    }
    resize() {
        const dpr = Math.min(window.devicePixelRatio || 1, 2);
        this.canvas.width = window.innerWidth * dpr;
        this.canvas.height = window.innerHeight * dpr;
        this.gl.viewport(0, 0, this.canvas.width, this.canvas.height);
    }
    initShaders() {
        const gl = this.gl;
        // Main program
        this.program = this.createProgram($69f13b8a7d15be5e$var$MAIN_VS, $69f13b8a7d15be5e$var$MAIN_FS);
        this.locations = {
            aPosition: gl.getAttribLocation(this.program, 'aPosition'),
            aNormal: gl.getAttribLocation(this.program, 'aNormal'),
            aColor: gl.getAttribLocation(this.program, 'aColor'),
            uProjection: gl.getUniformLocation(this.program, 'uProjection'),
            uView: gl.getUniformLocation(this.program, 'uView'),
            uModel: gl.getUniformLocation(this.program, 'uModel'),
            uNormalMatrix: gl.getUniformLocation(this.program, 'uNormalMatrix'),
            uCameraPos: gl.getUniformLocation(this.program, 'uCameraPos'),
            uMetallic: gl.getUniformLocation(this.program, 'uMetallic'),
            uRoughness: gl.getUniformLocation(this.program, 'uRoughness'),
            uTime: gl.getUniformLocation(this.program, 'uTime'),
            uIsMarble: gl.getUniformLocation(this.program, 'uIsMarble'),
            uIsGround: gl.getUniformLocation(this.program, 'uIsGround')
        };
        // Sky program
        this.skyProgram = this.createProgram($69f13b8a7d15be5e$var$SKY_VS, $69f13b8a7d15be5e$var$SKY_FS);
        this.skyLocations = {
            aPosition: gl.getAttribLocation(this.skyProgram, 'aPosition'),
            uProjection: gl.getUniformLocation(this.skyProgram, 'uProjection'),
            uView: gl.getUniformLocation(this.skyProgram, 'uView'),
            uTime: gl.getUniformLocation(this.skyProgram, 'uTime')
        };
        // Particle program
        this.particleProgram = this.createProgram($69f13b8a7d15be5e$var$PARTICLE_VS, $69f13b8a7d15be5e$var$PARTICLE_FS);
        this.particleLocations = {
            aPosition: gl.getAttribLocation(this.particleProgram, 'aPosition'),
            aSize: gl.getAttribLocation(this.particleProgram, 'aSize'),
            aLife: gl.getAttribLocation(this.particleProgram, 'aLife'),
            aColor: gl.getAttribLocation(this.particleProgram, 'aColor'),
            uProjection: gl.getUniformLocation(this.particleProgram, 'uProjection'),
            uView: gl.getUniformLocation(this.particleProgram, 'uView')
        };
    }
    createProgram(vsSource, fsSource) {
        const gl = this.gl;
        const vs = this.compileShader(gl.VERTEX_SHADER, vsSource);
        const fs = this.compileShader(gl.FRAGMENT_SHADER, fsSource);
        const program = gl.createProgram();
        gl.attachShader(program, vs);
        gl.attachShader(program, fs);
        gl.linkProgram(program);
        if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
            console.error('Shader link error:', gl.getProgramInfoLog(program));
            throw new Error('Shader link error');
        }
        return program;
    }
    compileShader(type, source) {
        const gl = this.gl;
        const shader = gl.createShader(type);
        gl.shaderSource(shader, source);
        gl.compileShader(shader);
        if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
            console.error('Shader error:', gl.getShaderInfoLog(shader));
            throw new Error('Shader compile error');
        }
        return shader;
    }
    initMatrices() {
        this.projection = (0, $6e69ca24f4636b79$exports).create();
        this.view = (0, $6e69ca24f4636b79$exports).create();
        this.model = (0, $6e69ca24f4636b79$exports).create();
        this.normalMatrix = (0, $6e69ca24f4636b79$exports).create();
    }
    initSkybox() {
        const gl = this.gl;
        const positions = new Float32Array([
            -1,
            -1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            -1,
            -1,
            1,
            1,
            -1,
            1,
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            1,
            -1,
            1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            -1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            1,
            1,
            -1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            1,
            1,
            1,
            1,
            1,
            -1
        ]);
        const indices = new Uint16Array([
            0,
            1,
            2,
            0,
            2,
            3,
            4,
            6,
            5,
            4,
            7,
            6,
            8,
            10,
            9,
            8,
            11,
            10,
            12,
            13,
            14,
            12,
            14,
            15,
            16,
            17,
            18,
            16,
            18,
            19,
            20,
            22,
            21,
            20,
            23,
            22
        ]);
        this.skyboxPositionBuffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, this.skyboxPositionBuffer);
        gl.bufferData(gl.ARRAY_BUFFER, positions, gl.STATIC_DRAW);
        this.skyboxIndexBuffer = gl.createBuffer();
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.skyboxIndexBuffer);
        gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, indices, gl.STATIC_DRAW);
    }
    setCamera(position, target) {
        const aspect = this.canvas.width / this.canvas.height;
        (0, $6e69ca24f4636b79$exports).perspective(this.projection, Math.PI / 4, aspect, 0.1, 500);
        (0, $6e69ca24f4636b79$exports).lookAt(this.view, position, target, [
            0,
            1,
            0
        ]);
        this.cameraPos = position;
    }
    clear() {
        const gl = this.gl;
        gl.clearColor(0.22, 0.4, 0.75, 1.0);
        gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
        gl.enable(gl.DEPTH_TEST);
    }
    drawSky() {
        const gl = this.gl;
        gl.useProgram(this.skyProgram);
        gl.depthFunc(gl.LEQUAL);
        gl.disable(gl.CULL_FACE);
        gl.uniformMatrix4fv(this.skyLocations.uProjection, false, this.projection);
        gl.uniformMatrix4fv(this.skyLocations.uView, false, this.view);
        gl.uniform1f(this.skyLocations.uTime, this.time);
        gl.bindBuffer(gl.ARRAY_BUFFER, this.skyboxPositionBuffer);
        gl.enableVertexAttribArray(this.skyLocations.aPosition);
        gl.vertexAttribPointer(this.skyLocations.aPosition, 3, gl.FLOAT, false, 0, 0);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.skyboxIndexBuffer);
        gl.drawElements(gl.TRIANGLES, 36, gl.UNSIGNED_SHORT, 0);
        gl.depthFunc(gl.LESS);
        gl.enable(gl.CULL_FACE);
    }
    beginMainPass() {
        const gl = this.gl;
        gl.useProgram(this.program);
        gl.uniformMatrix4fv(this.locations.uProjection, false, this.projection);
        gl.uniformMatrix4fv(this.locations.uView, false, this.view);
        gl.uniform3fv(this.locations.uCameraPos, this.cameraPos);
        gl.uniform1f(this.locations.uTime, this.time);
    }
    drawMesh(mesh, modelMatrix, metallic = 0.0, roughness = 0.5, isMarble = false, isGround = false, doubleSided = false) {
        const gl = this.gl;
        // Disable culling for double-sided meshes
        if (doubleSided) gl.disable(gl.CULL_FACE);
        (0, $6e69ca24f4636b79$exports).copy(this.model, modelMatrix);
        (0, $6e69ca24f4636b79$exports).invert(this.normalMatrix, this.model);
        (0, $6e69ca24f4636b79$exports).transpose(this.normalMatrix, this.normalMatrix);
        gl.uniformMatrix4fv(this.locations.uModel, false, this.model);
        gl.uniformMatrix4fv(this.locations.uNormalMatrix, false, this.normalMatrix);
        gl.uniform1f(this.locations.uMetallic, metallic);
        gl.uniform1f(this.locations.uRoughness, roughness);
        gl.uniform1i(this.locations.uIsMarble, isMarble ? 1 : 0);
        gl.uniform1i(this.locations.uIsGround, isGround ? 1 : 0);
        gl.bindBuffer(gl.ARRAY_BUFFER, mesh.positionBuffer);
        gl.enableVertexAttribArray(this.locations.aPosition);
        gl.vertexAttribPointer(this.locations.aPosition, 3, gl.FLOAT, false, 0, 0);
        gl.bindBuffer(gl.ARRAY_BUFFER, mesh.normalBuffer);
        gl.enableVertexAttribArray(this.locations.aNormal);
        gl.vertexAttribPointer(this.locations.aNormal, 3, gl.FLOAT, false, 0, 0);
        gl.bindBuffer(gl.ARRAY_BUFFER, mesh.colorBuffer);
        gl.enableVertexAttribArray(this.locations.aColor);
        gl.vertexAttribPointer(this.locations.aColor, 3, gl.FLOAT, false, 0, 0);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, mesh.indexBuffer);
        gl.drawElements(gl.TRIANGLES, mesh.indexCount, gl.UNSIGNED_SHORT, 0);
        // Re-enable culling
        if (doubleSided) gl.enable(gl.CULL_FACE);
    }
    createMesh(positions, normals, colors, indices) {
        const gl = this.gl;
        const positionBuffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);
        gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(positions), gl.STATIC_DRAW);
        const normalBuffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, normalBuffer);
        gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(normals), gl.STATIC_DRAW);
        const colorBuffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, colorBuffer);
        gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(colors), gl.STATIC_DRAW);
        const indexBuffer = gl.createBuffer();
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, indexBuffer);
        gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, new Uint16Array(indices), gl.STATIC_DRAW);
        return {
            positionBuffer: positionBuffer,
            normalBuffer: normalBuffer,
            colorBuffer: colorBuffer,
            indexBuffer: indexBuffer,
            indexCount: indices.length
        };
    }
    updateTime(t) {
        this.time = t;
    }
}



var $c118a6fbc1a11e7b$exports = {};

$parcel$export($c118a6fbc1a11e7b$exports, "create", () => $c118a6fbc1a11e7b$export$185802fd694ee1f5);
$parcel$export($c118a6fbc1a11e7b$exports, "identity", () => $c118a6fbc1a11e7b$export$f0954fd7d5368655);
$parcel$export($c118a6fbc1a11e7b$exports, "setAxisAngle", () => $c118a6fbc1a11e7b$export$4286ddefc8f49512);
$parcel$export($c118a6fbc1a11e7b$exports, "getAxisAngle", () => $c118a6fbc1a11e7b$export$3f70be5e7d7dc51);
$parcel$export($c118a6fbc1a11e7b$exports, "getAngle", () => $c118a6fbc1a11e7b$export$b363da9ded343252);
$parcel$export($c118a6fbc1a11e7b$exports, "dot", () => $c118a6fbc1a11e7b$export$94132a0e348806d4);
$parcel$export($c118a6fbc1a11e7b$exports, "multiply", () => $c118a6fbc1a11e7b$export$2060d2db72cce88f);
$parcel$export($c118a6fbc1a11e7b$exports, "rotateX", () => $c118a6fbc1a11e7b$export$a59c8716592e09af);
$parcel$export($c118a6fbc1a11e7b$exports, "rotateY", () => $c118a6fbc1a11e7b$export$cf71e4d4ca4d1cfd);
$parcel$export($c118a6fbc1a11e7b$exports, "rotateZ", () => $c118a6fbc1a11e7b$export$ea6eae3365de5b9c);
$parcel$export($c118a6fbc1a11e7b$exports, "calculateW", () => $c118a6fbc1a11e7b$export$fb72b72e8d764d4e);
$parcel$export($c118a6fbc1a11e7b$exports, "exp", () => $c118a6fbc1a11e7b$export$b310ec824aaee37f);
$parcel$export($c118a6fbc1a11e7b$exports, "ln", () => $c118a6fbc1a11e7b$export$876cb1b29620556f);
$parcel$export($c118a6fbc1a11e7b$exports, "pow", () => $c118a6fbc1a11e7b$export$9c297f60e22e3389);
$parcel$export($c118a6fbc1a11e7b$exports, "scale", () => $c118a6fbc1a11e7b$export$dcdf75081b88279d);
$parcel$export($c118a6fbc1a11e7b$exports, "slerp", () => $c118a6fbc1a11e7b$export$1544d9bc2995de08);
$parcel$export($c118a6fbc1a11e7b$exports, "random", () => $c118a6fbc1a11e7b$export$4385e60b38654f68);
$parcel$export($c118a6fbc1a11e7b$exports, "invert", () => $c118a6fbc1a11e7b$export$6897c284b6f9f4dc);
$parcel$export($c118a6fbc1a11e7b$exports, "conjugate", () => $c118a6fbc1a11e7b$export$7679f47e72c62560);
$parcel$export($c118a6fbc1a11e7b$exports, "fromMat3", () => $c118a6fbc1a11e7b$export$272a1eb8e5a4b55b);
$parcel$export($c118a6fbc1a11e7b$exports, "fromEuler", () => $c118a6fbc1a11e7b$export$7a404a587ea85af);
$parcel$export($c118a6fbc1a11e7b$exports, "str", () => $c118a6fbc1a11e7b$export$42d51816ce590c93);
$parcel$export($c118a6fbc1a11e7b$exports, "clone", () => $c118a6fbc1a11e7b$export$9cd59f9826255e47);
$parcel$export($c118a6fbc1a11e7b$exports, "fromValues", () => $c118a6fbc1a11e7b$export$a82be99ed2a44a7d);
$parcel$export($c118a6fbc1a11e7b$exports, "copy", () => $c118a6fbc1a11e7b$export$784d13d8ee351f07);
$parcel$export($c118a6fbc1a11e7b$exports, "set", () => $c118a6fbc1a11e7b$export$adaa4cf7ef1b65be);
$parcel$export($c118a6fbc1a11e7b$exports, "add", () => $c118a6fbc1a11e7b$export$e16d8520af44a096);
$parcel$export($c118a6fbc1a11e7b$exports, "mul", () => $c118a6fbc1a11e7b$export$6e3a27864ab166fe);
$parcel$export($c118a6fbc1a11e7b$exports, "lerp", () => $c118a6fbc1a11e7b$export$3a89f8d6f6bf6c9f);
$parcel$export($c118a6fbc1a11e7b$exports, "length", () => $c118a6fbc1a11e7b$export$f24224f1c91d8156);
$parcel$export($c118a6fbc1a11e7b$exports, "len", () => $c118a6fbc1a11e7b$export$fc1400facf92c78);
$parcel$export($c118a6fbc1a11e7b$exports, "squaredLength", () => $c118a6fbc1a11e7b$export$ab44e1323ffc8376);
$parcel$export($c118a6fbc1a11e7b$exports, "sqrLen", () => $c118a6fbc1a11e7b$export$99d8dd3f32a3435);
$parcel$export($c118a6fbc1a11e7b$exports, "normalize", () => $c118a6fbc1a11e7b$export$a3295358bff77e);
$parcel$export($c118a6fbc1a11e7b$exports, "exactEquals", () => $c118a6fbc1a11e7b$export$f2599a5cf1109d8);
$parcel$export($c118a6fbc1a11e7b$exports, "equals", () => $c118a6fbc1a11e7b$export$e9bab7fafb253603);
$parcel$export($c118a6fbc1a11e7b$exports, "rotationTo", () => $c118a6fbc1a11e7b$export$72d66f5842c00904);
$parcel$export($c118a6fbc1a11e7b$exports, "sqlerp", () => $c118a6fbc1a11e7b$export$699b0866ca50f6cb);
$parcel$export($c118a6fbc1a11e7b$exports, "setAxes", () => $c118a6fbc1a11e7b$export$937ca0a544b2d712);


function $5bff4ecde74cc669$export$185802fd694ee1f5() {
    var out = new $b3d72613362f56f7$export$b67359430d3b1b2(9);
    if ($b3d72613362f56f7$export$b67359430d3b1b2 != Float32Array) {
        out[1] = 0;
        out[2] = 0;
        out[3] = 0;
        out[5] = 0;
        out[6] = 0;
        out[7] = 0;
    }
    out[0] = 1;
    out[4] = 1;
    out[8] = 1;
    return out;
}
function $5bff4ecde74cc669$export$b4ad467060d346fe(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[4];
    out[4] = a[5];
    out[5] = a[6];
    out[6] = a[8];
    out[7] = a[9];
    out[8] = a[10];
    return out;
}
function $5bff4ecde74cc669$export$9cd59f9826255e47(a) {
    var out = new $b3d72613362f56f7$export$b67359430d3b1b2(9);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    return out;
}
function $5bff4ecde74cc669$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    return out;
}
function $5bff4ecde74cc669$export$a82be99ed2a44a7d(m00, m01, m02, m10, m11, m12, m20, m21, m22) {
    var out = new $b3d72613362f56f7$export$b67359430d3b1b2(9);
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m10;
    out[4] = m11;
    out[5] = m12;
    out[6] = m20;
    out[7] = m21;
    out[8] = m22;
    return out;
}
function $5bff4ecde74cc669$export$adaa4cf7ef1b65be(out, m00, m01, m02, m10, m11, m12, m20, m21, m22) {
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m10;
    out[4] = m11;
    out[5] = m12;
    out[6] = m20;
    out[7] = m21;
    out[8] = m22;
    return out;
}
function $5bff4ecde74cc669$export$f0954fd7d5368655(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 1;
    out[5] = 0;
    out[6] = 0;
    out[7] = 0;
    out[8] = 1;
    return out;
}
function $5bff4ecde74cc669$export$9cb09a71b7d66923(out, a) {
    // If we are transposing ourselves we can skip a few steps but have to cache some values
    if (out === a) {
        var a01 = a[1], a02 = a[2], a12 = a[5];
        out[1] = a[3];
        out[2] = a[6];
        out[3] = a01;
        out[5] = a[7];
        out[6] = a02;
        out[7] = a12;
    } else {
        out[0] = a[0];
        out[1] = a[3];
        out[2] = a[6];
        out[3] = a[1];
        out[4] = a[4];
        out[5] = a[7];
        out[6] = a[2];
        out[7] = a[5];
        out[8] = a[8];
    }
    return out;
}
function $5bff4ecde74cc669$export$6897c284b6f9f4dc(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2];
    var a10 = a[3], a11 = a[4], a12 = a[5];
    var a20 = a[6], a21 = a[7], a22 = a[8];
    var b01 = a22 * a11 - a12 * a21;
    var b11 = -a22 * a10 + a12 * a20;
    var b21 = a21 * a10 - a11 * a20;
    // Calculate the determinant
    var det = a00 * b01 + a01 * b11 + a02 * b21;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = b01 * det;
    out[1] = (-a22 * a01 + a02 * a21) * det;
    out[2] = (a12 * a01 - a02 * a11) * det;
    out[3] = b11 * det;
    out[4] = (a22 * a00 - a02 * a20) * det;
    out[5] = (-a12 * a00 + a02 * a10) * det;
    out[6] = b21 * det;
    out[7] = (-a21 * a00 + a01 * a20) * det;
    out[8] = (a11 * a00 - a01 * a10) * det;
    return out;
}
function $5bff4ecde74cc669$export$33f3c024b4ae00a1(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2];
    var a10 = a[3], a11 = a[4], a12 = a[5];
    var a20 = a[6], a21 = a[7], a22 = a[8];
    out[0] = a11 * a22 - a12 * a21;
    out[1] = a02 * a21 - a01 * a22;
    out[2] = a01 * a12 - a02 * a11;
    out[3] = a12 * a20 - a10 * a22;
    out[4] = a00 * a22 - a02 * a20;
    out[5] = a02 * a10 - a00 * a12;
    out[6] = a10 * a21 - a11 * a20;
    out[7] = a01 * a20 - a00 * a21;
    out[8] = a00 * a11 - a01 * a10;
    return out;
}
function $5bff4ecde74cc669$export$a04698f914c55ed9(a) {
    var a00 = a[0], a01 = a[1], a02 = a[2];
    var a10 = a[3], a11 = a[4], a12 = a[5];
    var a20 = a[6], a21 = a[7], a22 = a[8];
    return a00 * (a22 * a11 - a12 * a21) + a01 * (-a22 * a10 + a12 * a20) + a02 * (a21 * a10 - a11 * a20);
}
function $5bff4ecde74cc669$export$2060d2db72cce88f(out, a, b) {
    var a00 = a[0], a01 = a[1], a02 = a[2];
    var a10 = a[3], a11 = a[4], a12 = a[5];
    var a20 = a[6], a21 = a[7], a22 = a[8];
    var b00 = b[0], b01 = b[1], b02 = b[2];
    var b10 = b[3], b11 = b[4], b12 = b[5];
    var b20 = b[6], b21 = b[7], b22 = b[8];
    out[0] = b00 * a00 + b01 * a10 + b02 * a20;
    out[1] = b00 * a01 + b01 * a11 + b02 * a21;
    out[2] = b00 * a02 + b01 * a12 + b02 * a22;
    out[3] = b10 * a00 + b11 * a10 + b12 * a20;
    out[4] = b10 * a01 + b11 * a11 + b12 * a21;
    out[5] = b10 * a02 + b11 * a12 + b12 * a22;
    out[6] = b20 * a00 + b21 * a10 + b22 * a20;
    out[7] = b20 * a01 + b21 * a11 + b22 * a21;
    out[8] = b20 * a02 + b21 * a12 + b22 * a22;
    return out;
}
function $5bff4ecde74cc669$export$d73ee8ef04f5226a(out, a, v) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a10 = a[3], a11 = a[4], a12 = a[5], a20 = a[6], a21 = a[7], a22 = a[8], x = v[0], y = v[1];
    out[0] = a00;
    out[1] = a01;
    out[2] = a02;
    out[3] = a10;
    out[4] = a11;
    out[5] = a12;
    out[6] = x * a00 + y * a10 + a20;
    out[7] = x * a01 + y * a11 + a21;
    out[8] = x * a02 + y * a12 + a22;
    return out;
}
function $5bff4ecde74cc669$export$bb628a54ab399bc9(out, a, rad) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a10 = a[3], a11 = a[4], a12 = a[5], a20 = a[6], a21 = a[7], a22 = a[8], s = Math.sin(rad), c = Math.cos(rad);
    out[0] = c * a00 + s * a10;
    out[1] = c * a01 + s * a11;
    out[2] = c * a02 + s * a12;
    out[3] = c * a10 - s * a00;
    out[4] = c * a11 - s * a01;
    out[5] = c * a12 - s * a02;
    out[6] = a20;
    out[7] = a21;
    out[8] = a22;
    return out;
}
function $5bff4ecde74cc669$export$dcdf75081b88279d(out, a, v) {
    var x = v[0], y = v[1];
    out[0] = x * a[0];
    out[1] = x * a[1];
    out[2] = x * a[2];
    out[3] = y * a[3];
    out[4] = y * a[4];
    out[5] = y * a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    return out;
}
function $5bff4ecde74cc669$export$bc9e79e74e9fddf6(out, v) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 1;
    out[5] = 0;
    out[6] = v[0];
    out[7] = v[1];
    out[8] = 1;
    return out;
}
function $5bff4ecde74cc669$export$926fc125ff3c666c(out, rad) {
    var s = Math.sin(rad), c = Math.cos(rad);
    out[0] = c;
    out[1] = s;
    out[2] = 0;
    out[3] = -s;
    out[4] = c;
    out[5] = 0;
    out[6] = 0;
    out[7] = 0;
    out[8] = 1;
    return out;
}
function $5bff4ecde74cc669$export$832ca188ffb1955d(out, v) {
    out[0] = v[0];
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = v[1];
    out[5] = 0;
    out[6] = 0;
    out[7] = 0;
    out[8] = 1;
    return out;
}
function $5bff4ecde74cc669$export$68f5977575fae9bf(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = 0;
    out[3] = a[2];
    out[4] = a[3];
    out[5] = 0;
    out[6] = a[4];
    out[7] = a[5];
    out[8] = 1;
    return out;
}
function $5bff4ecde74cc669$export$2ff2bbe382249af7(out, q) {
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var yx = y * x2;
    var yy = y * y2;
    var zx = z * x2;
    var zy = z * y2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    out[0] = 1 - yy - zz;
    out[3] = yx - wz;
    out[6] = zx + wy;
    out[1] = yx + wz;
    out[4] = 1 - xx - zz;
    out[7] = zy - wx;
    out[2] = zx - wy;
    out[5] = zy + wx;
    out[8] = 1 - xx - yy;
    return out;
}
function $5bff4ecde74cc669$export$966b25ab6dc1b1f9(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    var b00 = a00 * a11 - a01 * a10;
    var b01 = a00 * a12 - a02 * a10;
    var b02 = a00 * a13 - a03 * a10;
    var b03 = a01 * a12 - a02 * a11;
    var b04 = a01 * a13 - a03 * a11;
    var b05 = a02 * a13 - a03 * a12;
    var b06 = a20 * a31 - a21 * a30;
    var b07 = a20 * a32 - a22 * a30;
    var b08 = a20 * a33 - a23 * a30;
    var b09 = a21 * a32 - a22 * a31;
    var b10 = a21 * a33 - a23 * a31;
    var b11 = a22 * a33 - a23 * a32;
    // Calculate the determinant
    var det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
    out[1] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
    out[2] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
    out[3] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
    out[4] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
    out[5] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
    out[6] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
    out[7] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
    out[8] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
    return out;
}
function $5bff4ecde74cc669$export$b74061472fe7c07(out, width, height) {
    out[0] = 2 / width;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = -2 / height;
    out[5] = 0;
    out[6] = -1;
    out[7] = 1;
    out[8] = 1;
    return out;
}
function $5bff4ecde74cc669$export$42d51816ce590c93(a) {
    return "mat3(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ", " + a[4] + ", " + a[5] + ", " + a[6] + ", " + a[7] + ", " + a[8] + ")";
}
function $5bff4ecde74cc669$export$326827e8268e9cdb(a) {
    return Math.sqrt(a[0] * a[0] + a[1] * a[1] + a[2] * a[2] + a[3] * a[3] + a[4] * a[4] + a[5] * a[5] + a[6] * a[6] + a[7] * a[7] + a[8] * a[8]);
}
function $5bff4ecde74cc669$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    out[4] = a[4] + b[4];
    out[5] = a[5] + b[5];
    out[6] = a[6] + b[6];
    out[7] = a[7] + b[7];
    out[8] = a[8] + b[8];
    return out;
}
function $5bff4ecde74cc669$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    out[3] = a[3] - b[3];
    out[4] = a[4] - b[4];
    out[5] = a[5] - b[5];
    out[6] = a[6] - b[6];
    out[7] = a[7] - b[7];
    out[8] = a[8] - b[8];
    return out;
}
function $5bff4ecde74cc669$export$c697bed75648cdb7(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    out[4] = a[4] * b;
    out[5] = a[5] * b;
    out[6] = a[6] * b;
    out[7] = a[7] * b;
    out[8] = a[8] * b;
    return out;
}
function $5bff4ecde74cc669$export$553579f63bdd7137(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    out[3] = a[3] + b[3] * scale;
    out[4] = a[4] + b[4] * scale;
    out[5] = a[5] + b[5] * scale;
    out[6] = a[6] + b[6] * scale;
    out[7] = a[7] + b[7] * scale;
    out[8] = a[8] + b[8] * scale;
    return out;
}
function $5bff4ecde74cc669$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3] && a[4] === b[4] && a[5] === b[5] && a[6] === b[6] && a[7] === b[7] && a[8] === b[8];
}
function $5bff4ecde74cc669$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3], a4 = a[4], a5 = a[5], a6 = a[6], a7 = a[7], a8 = a[8];
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8];
    return Math.abs(a0 - b0) <= $b3d72613362f56f7$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $b3d72613362f56f7$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $b3d72613362f56f7$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= $b3d72613362f56f7$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a3), Math.abs(b3)) && Math.abs(a4 - b4) <= $b3d72613362f56f7$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a4), Math.abs(b4)) && Math.abs(a5 - b5) <= $b3d72613362f56f7$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a5), Math.abs(b5)) && Math.abs(a6 - b6) <= $b3d72613362f56f7$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a6), Math.abs(b6)) && Math.abs(a7 - b7) <= $b3d72613362f56f7$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a7), Math.abs(b7)) && Math.abs(a8 - b8) <= $b3d72613362f56f7$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a8), Math.abs(b8));
}
var $5bff4ecde74cc669$export$6e3a27864ab166fe = $5bff4ecde74cc669$export$2060d2db72cce88f;
var $5bff4ecde74cc669$export$f93b5905241a7cca = $5bff4ecde74cc669$export$4e2d2ead65e5f7e3;




function $6708dc2edf160318$export$185802fd694ee1f5() {
    var out = new $b3d72613362f56f7$export$b67359430d3b1b2(4);
    if ($b3d72613362f56f7$export$b67359430d3b1b2 != Float32Array) {
        out[0] = 0;
        out[1] = 0;
        out[2] = 0;
        out[3] = 0;
    }
    return out;
}
function $6708dc2edf160318$export$9cd59f9826255e47(a) {
    var out = new $b3d72613362f56f7$export$b67359430d3b1b2(4);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
function $6708dc2edf160318$export$a82be99ed2a44a7d(x, y, z, w) {
    var out = new $b3d72613362f56f7$export$b67359430d3b1b2(4);
    out[0] = x;
    out[1] = y;
    out[2] = z;
    out[3] = w;
    return out;
}
function $6708dc2edf160318$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
function $6708dc2edf160318$export$adaa4cf7ef1b65be(out, x, y, z, w) {
    out[0] = x;
    out[1] = y;
    out[2] = z;
    out[3] = w;
    return out;
}
function $6708dc2edf160318$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    return out;
}
function $6708dc2edf160318$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    out[3] = a[3] - b[3];
    return out;
}
function $6708dc2edf160318$export$2060d2db72cce88f(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    out[2] = a[2] * b[2];
    out[3] = a[3] * b[3];
    return out;
}
function $6708dc2edf160318$export$cd007d971a5a2143(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    out[2] = a[2] / b[2];
    out[3] = a[3] / b[3];
    return out;
}
function $6708dc2edf160318$export$803ce6b71a0a94b2(out, a) {
    out[0] = Math.ceil(a[0]);
    out[1] = Math.ceil(a[1]);
    out[2] = Math.ceil(a[2]);
    out[3] = Math.ceil(a[3]);
    return out;
}
function $6708dc2edf160318$export$a3fe094919f356fd(out, a) {
    out[0] = Math.floor(a[0]);
    out[1] = Math.floor(a[1]);
    out[2] = Math.floor(a[2]);
    out[3] = Math.floor(a[3]);
    return out;
}
function $6708dc2edf160318$export$96ec731ed4dcb222(out, a, b) {
    out[0] = Math.min(a[0], b[0]);
    out[1] = Math.min(a[1], b[1]);
    out[2] = Math.min(a[2], b[2]);
    out[3] = Math.min(a[3], b[3]);
    return out;
}
function $6708dc2edf160318$export$8960430cfd85939f(out, a, b) {
    out[0] = Math.max(a[0], b[0]);
    out[1] = Math.max(a[1], b[1]);
    out[2] = Math.max(a[2], b[2]);
    out[3] = Math.max(a[3], b[3]);
    return out;
}
function $6708dc2edf160318$export$2077e0241d6afd3c(out, a) {
    out[0] = $b3d72613362f56f7$export$2077e0241d6afd3c(a[0]);
    out[1] = $b3d72613362f56f7$export$2077e0241d6afd3c(a[1]);
    out[2] = $b3d72613362f56f7$export$2077e0241d6afd3c(a[2]);
    out[3] = $b3d72613362f56f7$export$2077e0241d6afd3c(a[3]);
    return out;
}
function $6708dc2edf160318$export$dcdf75081b88279d(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    return out;
}
function $6708dc2edf160318$export$19cedf1da84ba854(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    out[3] = a[3] + b[3] * scale;
    return out;
}
function $6708dc2edf160318$export$9f17032d917177de(a, b) {
    var x = b[0] - a[0];
    var y = b[1] - a[1];
    var z = b[2] - a[2];
    var w = b[3] - a[3];
    return Math.sqrt(x * x + y * y + z * z + w * w);
}
function $6708dc2edf160318$export$88e6ebb4fe54f538(a, b) {
    var x = b[0] - a[0];
    var y = b[1] - a[1];
    var z = b[2] - a[2];
    var w = b[3] - a[3];
    return x * x + y * y + z * z + w * w;
}
function $6708dc2edf160318$export$f24224f1c91d8156(a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    var w = a[3];
    return Math.sqrt(x * x + y * y + z * z + w * w);
}
function $6708dc2edf160318$export$ab44e1323ffc8376(a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    var w = a[3];
    return x * x + y * y + z * z + w * w;
}
function $6708dc2edf160318$export$aef51622e549b8b0(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    out[2] = -a[2];
    out[3] = -a[3];
    return out;
}
function $6708dc2edf160318$export$70ae2c07e401031b(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    out[2] = 1.0 / a[2];
    out[3] = 1.0 / a[3];
    return out;
}
function $6708dc2edf160318$export$a3295358bff77e(out, a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    var w = a[3];
    var len = x * x + y * y + z * z + w * w;
    if (len > 0) len = 1 / Math.sqrt(len);
    out[0] = x * len;
    out[1] = y * len;
    out[2] = z * len;
    out[3] = w * len;
    return out;
}
function $6708dc2edf160318$export$94132a0e348806d4(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
}
function $6708dc2edf160318$export$bb646b20bb93d339(out, u, v, w) {
    var A = v[0] * w[1] - v[1] * w[0], B = v[0] * w[2] - v[2] * w[0], C = v[0] * w[3] - v[3] * w[0], D = v[1] * w[2] - v[2] * w[1], E = v[1] * w[3] - v[3] * w[1], F = v[2] * w[3] - v[3] * w[2];
    var G = u[0];
    var H = u[1];
    var I = u[2];
    var J = u[3];
    out[0] = H * F - I * E + J * D;
    out[1] = -(G * F) + I * C - J * B;
    out[2] = G * E - H * C + J * A;
    out[3] = -(G * D) + H * B - I * A;
    return out;
}
function $6708dc2edf160318$export$3a89f8d6f6bf6c9f(out, a, b, t) {
    var ax = a[0];
    var ay = a[1];
    var az = a[2];
    var aw = a[3];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    out[2] = az + t * (b[2] - az);
    out[3] = aw + t * (b[3] - aw);
    return out;
}
function $6708dc2edf160318$export$4385e60b38654f68(out, scale) {
    scale = scale === undefined ? 1.0 : scale;
    // Marsaglia, George. Choosing a Point from the Surface of a
    // Sphere. Ann. Math. Statist. 43 (1972), no. 2, 645--646.
    // http://projecteuclid.org/euclid.aoms/1177692644;
    var v1, v2, v3, v4;
    var s1, s2;
    var rand;
    rand = $b3d72613362f56f7$export$5ada478c8a628231();
    v1 = rand * 2 - 1;
    v2 = (4 * $b3d72613362f56f7$export$5ada478c8a628231() - 2) * Math.sqrt(rand * -rand + rand);
    s1 = v1 * v1 + v2 * v2;
    rand = $b3d72613362f56f7$export$5ada478c8a628231();
    v3 = rand * 2 - 1;
    v4 = (4 * $b3d72613362f56f7$export$5ada478c8a628231() - 2) * Math.sqrt(rand * -rand + rand);
    s2 = v3 * v3 + v4 * v4;
    var d = Math.sqrt((1 - s1) / s2);
    out[0] = scale * v1;
    out[1] = scale * v2;
    out[2] = scale * v3 * d;
    out[3] = scale * v4 * d;
    return out;
}
function $6708dc2edf160318$export$5ffbd13800309d59(out, a, m) {
    var x = a[0], y = a[1], z = a[2], w = a[3];
    out[0] = m[0] * x + m[4] * y + m[8] * z + m[12] * w;
    out[1] = m[1] * x + m[5] * y + m[9] * z + m[13] * w;
    out[2] = m[2] * x + m[6] * y + m[10] * z + m[14] * w;
    out[3] = m[3] * x + m[7] * y + m[11] * z + m[15] * w;
    return out;
}
function $6708dc2edf160318$export$c32adef9e939ce85(out, a, q) {
    // Fast Vector Rotation using Quaternions by Robert Eisele
    // https://raw.org/proof/vector-rotation-using-quaternions/
    var qx = q[0], qy = q[1], qz = q[2], qw = q[3];
    var vx = a[0], vy = a[1], vz = a[2];
    // t = q x v
    var tx = qy * vz - qz * vy;
    var ty = qz * vx - qx * vz;
    var tz = qx * vy - qy * vx;
    // t = 2t
    tx = tx + tx;
    ty = ty + ty;
    tz = tz + tz;
    // v + w t + q x t
    out[0] = vx + qw * tx + qy * tz - qz * ty;
    out[1] = vy + qw * ty + qz * tx - qx * tz;
    out[2] = vz + qw * tz + qx * ty - qy * tx;
    out[3] = a[3];
    return out;
}
function $6708dc2edf160318$export$7f9972325ebfd559(out) {
    out[0] = 0.0;
    out[1] = 0.0;
    out[2] = 0.0;
    out[3] = 0.0;
    return out;
}
function $6708dc2edf160318$export$42d51816ce590c93(a) {
    return "vec4(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ")";
}
function $6708dc2edf160318$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3];
}
function $6708dc2edf160318$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    return Math.abs(a0 - b0) <= $b3d72613362f56f7$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $b3d72613362f56f7$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $b3d72613362f56f7$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= $b3d72613362f56f7$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a3), Math.abs(b3));
}
var $6708dc2edf160318$export$f93b5905241a7cca = $6708dc2edf160318$export$4e2d2ead65e5f7e3;
var $6708dc2edf160318$export$6e3a27864ab166fe = $6708dc2edf160318$export$2060d2db72cce88f;
var $6708dc2edf160318$export$159d9494db57879b = $6708dc2edf160318$export$cd007d971a5a2143;
var $6708dc2edf160318$export$6c4a311cc157c764 = $6708dc2edf160318$export$9f17032d917177de;
var $6708dc2edf160318$export$2422cd6c492a8b3a = $6708dc2edf160318$export$88e6ebb4fe54f538;
var $6708dc2edf160318$export$fc1400facf92c78 = $6708dc2edf160318$export$f24224f1c91d8156;
var $6708dc2edf160318$export$99d8dd3f32a3435 = $6708dc2edf160318$export$ab44e1323ffc8376;
var $6708dc2edf160318$export$4b80e395e36b5a56 = function() {
    var vec = $6708dc2edf160318$export$185802fd694ee1f5();
    return function(a, stride, offset, count, fn, arg) {
        var i, l;
        if (!stride) stride = 4;
        if (!offset) offset = 0;
        if (count) l = Math.min(count * stride + offset, a.length);
        else l = a.length;
        for(i = offset; i < l; i += stride){
            vec[0] = a[i];
            vec[1] = a[i + 1];
            vec[2] = a[i + 2];
            vec[3] = a[i + 3];
            fn(vec, vec, arg);
            a[i] = vec[0];
            a[i + 1] = vec[1];
            a[i + 2] = vec[2];
            a[i + 3] = vec[3];
        }
        return a;
    };
}();


function $c118a6fbc1a11e7b$export$185802fd694ee1f5() {
    var out = new $b3d72613362f56f7$export$b67359430d3b1b2(4);
    if ($b3d72613362f56f7$export$b67359430d3b1b2 != Float32Array) {
        out[0] = 0;
        out[1] = 0;
        out[2] = 0;
    }
    out[3] = 1;
    return out;
}
function $c118a6fbc1a11e7b$export$f0954fd7d5368655(out) {
    out[0] = 0;
    out[1] = 0;
    out[2] = 0;
    out[3] = 1;
    return out;
}
function $c118a6fbc1a11e7b$export$4286ddefc8f49512(out, axis, rad) {
    rad = rad * 0.5;
    var s = Math.sin(rad);
    out[0] = s * axis[0];
    out[1] = s * axis[1];
    out[2] = s * axis[2];
    out[3] = Math.cos(rad);
    return out;
}
function $c118a6fbc1a11e7b$export$3f70be5e7d7dc51(out_axis, q) {
    var rad = Math.acos(q[3]) * 2.0;
    var s = Math.sin(rad / 2.0);
    if (s > $b3d72613362f56f7$export$fd293b15f47e270) {
        out_axis[0] = q[0] / s;
        out_axis[1] = q[1] / s;
        out_axis[2] = q[2] / s;
    } else {
        // If s is zero, return any axis (no rotation - axis does not matter)
        out_axis[0] = 1;
        out_axis[1] = 0;
        out_axis[2] = 0;
    }
    return rad;
}
function $c118a6fbc1a11e7b$export$b363da9ded343252(a, b) {
    var dotproduct = $c118a6fbc1a11e7b$export$94132a0e348806d4(a, b);
    return Math.acos(2 * dotproduct * dotproduct - 1);
}
function $c118a6fbc1a11e7b$export$2060d2db72cce88f(out, a, b) {
    var ax = a[0], ay = a[1], az = a[2], aw = a[3];
    var bx = b[0], by = b[1], bz = b[2], bw = b[3];
    out[0] = ax * bw + aw * bx + ay * bz - az * by;
    out[1] = ay * bw + aw * by + az * bx - ax * bz;
    out[2] = az * bw + aw * bz + ax * by - ay * bx;
    out[3] = aw * bw - ax * bx - ay * by - az * bz;
    return out;
}
function $c118a6fbc1a11e7b$export$a59c8716592e09af(out, a, rad) {
    rad *= 0.5;
    var ax = a[0], ay = a[1], az = a[2], aw = a[3];
    var bx = Math.sin(rad), bw = Math.cos(rad);
    out[0] = ax * bw + aw * bx;
    out[1] = ay * bw + az * bx;
    out[2] = az * bw - ay * bx;
    out[3] = aw * bw - ax * bx;
    return out;
}
function $c118a6fbc1a11e7b$export$cf71e4d4ca4d1cfd(out, a, rad) {
    rad *= 0.5;
    var ax = a[0], ay = a[1], az = a[2], aw = a[3];
    var by = Math.sin(rad), bw = Math.cos(rad);
    out[0] = ax * bw - az * by;
    out[1] = ay * bw + aw * by;
    out[2] = az * bw + ax * by;
    out[3] = aw * bw - ay * by;
    return out;
}
function $c118a6fbc1a11e7b$export$ea6eae3365de5b9c(out, a, rad) {
    rad *= 0.5;
    var ax = a[0], ay = a[1], az = a[2], aw = a[3];
    var bz = Math.sin(rad), bw = Math.cos(rad);
    out[0] = ax * bw + ay * bz;
    out[1] = ay * bw - ax * bz;
    out[2] = az * bw + aw * bz;
    out[3] = aw * bw - az * bz;
    return out;
}
function $c118a6fbc1a11e7b$export$fb72b72e8d764d4e(out, a) {
    var x = a[0], y = a[1], z = a[2];
    out[0] = x;
    out[1] = y;
    out[2] = z;
    out[3] = Math.sqrt(Math.abs(1.0 - x * x - y * y - z * z));
    return out;
}
function $c118a6fbc1a11e7b$export$b310ec824aaee37f(out, a) {
    var x = a[0], y = a[1], z = a[2], w = a[3];
    var r = Math.sqrt(x * x + y * y + z * z);
    var et = Math.exp(w);
    var s = r > 0 ? et * Math.sin(r) / r : 0;
    out[0] = x * s;
    out[1] = y * s;
    out[2] = z * s;
    out[3] = et * Math.cos(r);
    return out;
}
function $c118a6fbc1a11e7b$export$876cb1b29620556f(out, a) {
    var x = a[0], y = a[1], z = a[2], w = a[3];
    var r = Math.sqrt(x * x + y * y + z * z);
    var t = r > 0 ? Math.atan2(r, w) / r : 0;
    out[0] = x * t;
    out[1] = y * t;
    out[2] = z * t;
    out[3] = 0.5 * Math.log(x * x + y * y + z * z + w * w);
    return out;
}
function $c118a6fbc1a11e7b$export$9c297f60e22e3389(out, a, b) {
    $c118a6fbc1a11e7b$export$876cb1b29620556f(out, a);
    $c118a6fbc1a11e7b$export$dcdf75081b88279d(out, out, b);
    $c118a6fbc1a11e7b$export$b310ec824aaee37f(out, out);
    return out;
}
function $c118a6fbc1a11e7b$export$1544d9bc2995de08(out, a, b, t) {
    // benchmarks:
    //    http://jsperf.com/quaternion-slerp-implementations
    var ax = a[0], ay = a[1], az = a[2], aw = a[3];
    var bx = b[0], by = b[1], bz = b[2], bw = b[3];
    var omega, cosom, sinom, scale0, scale1;
    // calc cosine
    cosom = ax * bx + ay * by + az * bz + aw * bw;
    // adjust signs (if necessary)
    if (cosom < 0.0) {
        cosom = -cosom;
        bx = -bx;
        by = -by;
        bz = -bz;
        bw = -bw;
    }
    // calculate coefficients
    if (1.0 - cosom > $b3d72613362f56f7$export$fd293b15f47e270) {
        // standard case (slerp)
        omega = Math.acos(cosom);
        sinom = Math.sin(omega);
        scale0 = Math.sin((1.0 - t) * omega) / sinom;
        scale1 = Math.sin(t * omega) / sinom;
    } else {
        // "from" and "to" quaternions are very close
        //  ... so we can do a linear interpolation
        scale0 = 1.0 - t;
        scale1 = t;
    }
    // calculate final values
    out[0] = scale0 * ax + scale1 * bx;
    out[1] = scale0 * ay + scale1 * by;
    out[2] = scale0 * az + scale1 * bz;
    out[3] = scale0 * aw + scale1 * bw;
    return out;
}
function $c118a6fbc1a11e7b$export$4385e60b38654f68(out) {
    // Implementation of http://planning.cs.uiuc.edu/node198.html
    // TODO: Calling random 3 times is probably not the fastest solution
    var u1 = $b3d72613362f56f7$export$5ada478c8a628231();
    var u2 = $b3d72613362f56f7$export$5ada478c8a628231();
    var u3 = $b3d72613362f56f7$export$5ada478c8a628231();
    var sqrt1MinusU1 = Math.sqrt(1 - u1);
    var sqrtU1 = Math.sqrt(u1);
    out[0] = sqrt1MinusU1 * Math.sin(2.0 * Math.PI * u2);
    out[1] = sqrt1MinusU1 * Math.cos(2.0 * Math.PI * u2);
    out[2] = sqrtU1 * Math.sin(2.0 * Math.PI * u3);
    out[3] = sqrtU1 * Math.cos(2.0 * Math.PI * u3);
    return out;
}
function $c118a6fbc1a11e7b$export$6897c284b6f9f4dc(out, a) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    var dot = a0 * a0 + a1 * a1 + a2 * a2 + a3 * a3;
    var invDot = dot ? 1.0 / dot : 0;
    // TODO: Would be faster to return [0,0,0,0] immediately if dot == 0
    out[0] = -a0 * invDot;
    out[1] = -a1 * invDot;
    out[2] = -a2 * invDot;
    out[3] = a3 * invDot;
    return out;
}
function $c118a6fbc1a11e7b$export$7679f47e72c62560(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    out[2] = -a[2];
    out[3] = a[3];
    return out;
}
function $c118a6fbc1a11e7b$export$272a1eb8e5a4b55b(out, m) {
    // Algorithm in Ken Shoemake's article in 1987 SIGGRAPH course notes
    // article "Quaternion Calculus and Fast Animation".
    var fTrace = m[0] + m[4] + m[8];
    var fRoot;
    if (fTrace > 0.0) {
        // |w| > 1/2, may as well choose w > 1/2
        fRoot = Math.sqrt(fTrace + 1.0); // 2w
        out[3] = 0.5 * fRoot;
        fRoot = 0.5 / fRoot; // 1/(4w)
        out[0] = (m[5] - m[7]) * fRoot;
        out[1] = (m[6] - m[2]) * fRoot;
        out[2] = (m[1] - m[3]) * fRoot;
    } else {
        // |w| <= 1/2
        var i = 0;
        if (m[4] > m[0]) i = 1;
        if (m[8] > m[i * 3 + i]) i = 2;
        var j = (i + 1) % 3;
        var k = (i + 2) % 3;
        fRoot = Math.sqrt(m[i * 3 + i] - m[j * 3 + j] - m[k * 3 + k] + 1.0);
        out[i] = 0.5 * fRoot;
        fRoot = 0.5 / fRoot;
        out[3] = (m[j * 3 + k] - m[k * 3 + j]) * fRoot;
        out[j] = (m[j * 3 + i] + m[i * 3 + j]) * fRoot;
        out[k] = (m[k * 3 + i] + m[i * 3 + k]) * fRoot;
    }
    return out;
}
function $c118a6fbc1a11e7b$export$7a404a587ea85af(out, x, y, z) {
    var order = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : $b3d72613362f56f7$export$217057687ee20298;
    var halfToRad = Math.PI / 360;
    x *= halfToRad;
    z *= halfToRad;
    y *= halfToRad;
    var sx = Math.sin(x);
    var cx = Math.cos(x);
    var sy = Math.sin(y);
    var cy = Math.cos(y);
    var sz = Math.sin(z);
    var cz = Math.cos(z);
    switch(order){
        case "xyz":
            out[0] = sx * cy * cz + cx * sy * sz;
            out[1] = cx * sy * cz - sx * cy * sz;
            out[2] = cx * cy * sz + sx * sy * cz;
            out[3] = cx * cy * cz - sx * sy * sz;
            break;
        case "xzy":
            out[0] = sx * cy * cz - cx * sy * sz;
            out[1] = cx * sy * cz - sx * cy * sz;
            out[2] = cx * cy * sz + sx * sy * cz;
            out[3] = cx * cy * cz + sx * sy * sz;
            break;
        case "yxz":
            out[0] = sx * cy * cz + cx * sy * sz;
            out[1] = cx * sy * cz - sx * cy * sz;
            out[2] = cx * cy * sz - sx * sy * cz;
            out[3] = cx * cy * cz + sx * sy * sz;
            break;
        case "yzx":
            out[0] = sx * cy * cz + cx * sy * sz;
            out[1] = cx * sy * cz + sx * cy * sz;
            out[2] = cx * cy * sz - sx * sy * cz;
            out[3] = cx * cy * cz - sx * sy * sz;
            break;
        case "zxy":
            out[0] = sx * cy * cz - cx * sy * sz;
            out[1] = cx * sy * cz + sx * cy * sz;
            out[2] = cx * cy * sz + sx * sy * cz;
            out[3] = cx * cy * cz - sx * sy * sz;
            break;
        case "zyx":
            out[0] = sx * cy * cz - cx * sy * sz;
            out[1] = cx * sy * cz + sx * cy * sz;
            out[2] = cx * cy * sz - sx * sy * cz;
            out[3] = cx * cy * cz + sx * sy * sz;
            break;
        default:
            throw new Error('Unknown angle order ' + order);
    }
    return out;
}
function $c118a6fbc1a11e7b$export$42d51816ce590c93(a) {
    return "quat(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ")";
}
var $c118a6fbc1a11e7b$export$9cd59f9826255e47 = $6708dc2edf160318$export$9cd59f9826255e47;
var $c118a6fbc1a11e7b$export$a82be99ed2a44a7d = $6708dc2edf160318$export$a82be99ed2a44a7d;
var $c118a6fbc1a11e7b$export$784d13d8ee351f07 = $6708dc2edf160318$export$784d13d8ee351f07;
var $c118a6fbc1a11e7b$export$adaa4cf7ef1b65be = $6708dc2edf160318$export$adaa4cf7ef1b65be;
var $c118a6fbc1a11e7b$export$e16d8520af44a096 = $6708dc2edf160318$export$e16d8520af44a096;
var $c118a6fbc1a11e7b$export$6e3a27864ab166fe = $c118a6fbc1a11e7b$export$2060d2db72cce88f;
var $c118a6fbc1a11e7b$export$dcdf75081b88279d = $6708dc2edf160318$export$dcdf75081b88279d;
var $c118a6fbc1a11e7b$export$94132a0e348806d4 = $6708dc2edf160318$export$94132a0e348806d4;
var $c118a6fbc1a11e7b$export$3a89f8d6f6bf6c9f = $6708dc2edf160318$export$3a89f8d6f6bf6c9f;
var $c118a6fbc1a11e7b$export$f24224f1c91d8156 = $6708dc2edf160318$export$f24224f1c91d8156;
var $c118a6fbc1a11e7b$export$fc1400facf92c78 = $c118a6fbc1a11e7b$export$f24224f1c91d8156;
var $c118a6fbc1a11e7b$export$ab44e1323ffc8376 = $6708dc2edf160318$export$ab44e1323ffc8376;
var $c118a6fbc1a11e7b$export$99d8dd3f32a3435 = $c118a6fbc1a11e7b$export$ab44e1323ffc8376;
var $c118a6fbc1a11e7b$export$a3295358bff77e = $6708dc2edf160318$export$a3295358bff77e;
var $c118a6fbc1a11e7b$export$f2599a5cf1109d8 = $6708dc2edf160318$export$f2599a5cf1109d8;
function $c118a6fbc1a11e7b$export$e9bab7fafb253603(a, b) {
    return Math.abs($6708dc2edf160318$export$94132a0e348806d4(a, b)) >= 1 - $b3d72613362f56f7$export$fd293b15f47e270;
}
var $c118a6fbc1a11e7b$export$72d66f5842c00904 = function() {
    var tmpvec3 = $8f228f84b1e7d967$export$185802fd694ee1f5();
    var xUnitVec3 = $8f228f84b1e7d967$export$a82be99ed2a44a7d(1, 0, 0);
    var yUnitVec3 = $8f228f84b1e7d967$export$a82be99ed2a44a7d(0, 1, 0);
    return function(out, a, b) {
        var dot = $8f228f84b1e7d967$export$94132a0e348806d4(a, b);
        if (dot < -0.999999) {
            $8f228f84b1e7d967$export$bb646b20bb93d339(tmpvec3, xUnitVec3, a);
            if ($8f228f84b1e7d967$export$fc1400facf92c78(tmpvec3) < 0.000001) $8f228f84b1e7d967$export$bb646b20bb93d339(tmpvec3, yUnitVec3, a);
            $8f228f84b1e7d967$export$a3295358bff77e(tmpvec3, tmpvec3);
            $c118a6fbc1a11e7b$export$4286ddefc8f49512(out, tmpvec3, Math.PI);
            return out;
        } else if (dot > 0.999999) {
            out[0] = 0;
            out[1] = 0;
            out[2] = 0;
            out[3] = 1;
            return out;
        } else {
            $8f228f84b1e7d967$export$bb646b20bb93d339(tmpvec3, a, b);
            out[0] = tmpvec3[0];
            out[1] = tmpvec3[1];
            out[2] = tmpvec3[2];
            out[3] = 1 + dot;
            return $c118a6fbc1a11e7b$export$a3295358bff77e(out, out);
        }
    };
}();
var $c118a6fbc1a11e7b$export$699b0866ca50f6cb = function() {
    var temp1 = $c118a6fbc1a11e7b$export$185802fd694ee1f5();
    var temp2 = $c118a6fbc1a11e7b$export$185802fd694ee1f5();
    return function(out, a, b, c, d, t) {
        $c118a6fbc1a11e7b$export$1544d9bc2995de08(temp1, a, d, t);
        $c118a6fbc1a11e7b$export$1544d9bc2995de08(temp2, b, c, t);
        $c118a6fbc1a11e7b$export$1544d9bc2995de08(out, temp1, temp2, 2 * t * (1 - t));
        return out;
    };
}();
var $c118a6fbc1a11e7b$export$937ca0a544b2d712 = function() {
    var matr = $5bff4ecde74cc669$export$185802fd694ee1f5();
    return function(out, view, right, up) {
        matr[0] = right[0];
        matr[3] = right[1];
        matr[6] = right[2];
        matr[1] = up[0];
        matr[4] = up[1];
        matr[7] = up[2];
        matr[2] = -view[0];
        matr[5] = -view[1];
        matr[8] = -view[2];
        return $c118a6fbc1a11e7b$export$a3295358bff77e(out, $c118a6fbc1a11e7b$export$272a1eb8e5a4b55b(out, matr));
    };
}();


function $5409e5fedd273992$export$d21c7469ce5b89bf(renderer, radius, segments, color) {
    const positions = [];
    const normals = [];
    const colors = [];
    const indices = [];
    for(let lat = 0; lat <= segments; lat++){
        const theta = lat * Math.PI / segments;
        const sinTheta = Math.sin(theta);
        const cosTheta = Math.cos(theta);
        for(let lon = 0; lon <= segments; lon++){
            const phi = lon * 2 * Math.PI / segments;
            const x = Math.cos(phi) * sinTheta;
            const y = cosTheta;
            const z = Math.sin(phi) * sinTheta;
            positions.push(radius * x, radius * y, radius * z);
            normals.push(x, y, z);
            colors.push(color[0], color[1], color[2]);
        }
    }
    for(let lat = 0; lat < segments; lat++)for(let lon = 0; lon < segments; lon++){
        const first = lat * (segments + 1) + lon;
        const second = first + segments + 1;
        indices.push(first, second, first + 1);
        indices.push(second, second + 1, first + 1);
    }
    return renderer.createMesh(positions, normals, colors, indices);
}
function $5409e5fedd273992$export$16b64c4e1093e073(renderer, path, radius, segments, color) {
    const positions = [];
    const normals = [];
    const colors = [];
    const indices = [];
    const frames = $5409e5fedd273992$export$9f33702dd6cd6b56(path);
    for(let i = 0; i < path.length; i++){
        const p = path[i];
        const { normal: normal, binormal: binormal } = frames[i];
        for(let j = 0; j <= segments; j++){
            const angle = j * 2 * Math.PI / segments;
            const cos = Math.cos(angle);
            const sin = Math.sin(angle);
            const nx = cos * normal[0] + sin * binormal[0];
            const ny = cos * normal[1] + sin * binormal[1];
            const nz = cos * normal[2] + sin * binormal[2];
            positions.push(p[0] + radius * nx, p[1] + radius * ny, p[2] + radius * nz);
            normals.push(nx, ny, nz);
            colors.push(color[0], color[1], color[2]);
        }
    }
    for(let i = 0; i < path.length - 1; i++)for(let j = 0; j < segments; j++){
        const a = i * (segments + 1) + j;
        const b = a + segments + 1;
        indices.push(a, b, a + 1);
        indices.push(b, b + 1, a + 1);
    }
    return renderer.createMesh(positions, normals, colors, indices);
}
function $5409e5fedd273992$export$9f33702dd6cd6b56(path) {
    const frames = [];
    let tangent = (0, $8f228f84b1e7d967$exports).sub((0, $8f228f84b1e7d967$exports).create(), path[1], path[0]);
    (0, $8f228f84b1e7d967$exports).normalize(tangent, tangent);
    // Initial normal - always start with world up projected onto the plane perpendicular to tangent
    const worldUp = (0, $8f228f84b1e7d967$exports).fromValues(0, 1, 0);
    let binormal = (0, $8f228f84b1e7d967$exports).cross((0, $8f228f84b1e7d967$exports).create(), tangent, worldUp);
    // Handle case where tangent is nearly vertical
    if ((0, $8f228f84b1e7d967$exports).length(binormal) < 0.1) binormal = (0, $8f228f84b1e7d967$exports).fromValues(1, 0, 0);
    (0, $8f228f84b1e7d967$exports).normalize(binormal, binormal);
    let normal = (0, $8f228f84b1e7d967$exports).cross((0, $8f228f84b1e7d967$exports).create(), binormal, tangent);
    (0, $8f228f84b1e7d967$exports).normalize(normal, normal);
    frames.push({
        tangent: (0, $8f228f84b1e7d967$exports).clone(tangent),
        normal: (0, $8f228f84b1e7d967$exports).clone(normal),
        binormal: (0, $8f228f84b1e7d967$exports).clone(binormal)
    });
    for(let i = 1; i < path.length; i++){
        const prevFrame = frames[i - 1];
        if (i < path.length - 1) tangent = (0, $8f228f84b1e7d967$exports).sub((0, $8f228f84b1e7d967$exports).create(), path[i + 1], path[i - 1]);
        else tangent = (0, $8f228f84b1e7d967$exports).sub((0, $8f228f84b1e7d967$exports).create(), path[i], path[i - 1]);
        (0, $8f228f84b1e7d967$exports).normalize(tangent, tangent);
        // RMF: rotate the previous frame to align with new tangent
        const axis = (0, $8f228f84b1e7d967$exports).cross((0, $8f228f84b1e7d967$exports).create(), prevFrame.tangent, tangent);
        const axisLen = (0, $8f228f84b1e7d967$exports).length(axis);
        if (axisLen > 0.0001) {
            (0, $8f228f84b1e7d967$exports).scale(axis, axis, 1 / axisLen);
            const angle = Math.acos(Math.max(-1, Math.min(1, (0, $8f228f84b1e7d967$exports).dot(prevFrame.tangent, tangent))));
            const q = (0, $c118a6fbc1a11e7b$exports).setAxisAngle((0, $c118a6fbc1a11e7b$exports).create(), axis, angle);
            normal = (0, $8f228f84b1e7d967$exports).transformQuat((0, $8f228f84b1e7d967$exports).create(), prevFrame.normal, q);
            binormal = (0, $8f228f84b1e7d967$exports).cross((0, $8f228f84b1e7d967$exports).create(), tangent, normal);
        } else {
            normal = (0, $8f228f84b1e7d967$exports).clone(prevFrame.normal);
            binormal = (0, $8f228f84b1e7d967$exports).clone(prevFrame.binormal);
        }
        (0, $8f228f84b1e7d967$exports).normalize(normal, normal);
        (0, $8f228f84b1e7d967$exports).normalize(binormal, binormal);
        // Bias normal towards world up to prevent excessive track rotation
        // This keeps the track floor more horizontal
        const upBias = 0.15;
        const biasedNormal = (0, $8f228f84b1e7d967$exports).create();
        (0, $8f228f84b1e7d967$exports).scaleAndAdd(biasedNormal, normal, worldUp, upBias);
        // Re-orthogonalize after biasing
        binormal = (0, $8f228f84b1e7d967$exports).cross((0, $8f228f84b1e7d967$exports).create(), tangent, biasedNormal);
        (0, $8f228f84b1e7d967$exports).normalize(binormal, binormal);
        normal = (0, $8f228f84b1e7d967$exports).cross((0, $8f228f84b1e7d967$exports).create(), binormal, tangent);
        (0, $8f228f84b1e7d967$exports).normalize(normal, normal);
        frames.push({
            tangent: (0, $8f228f84b1e7d967$exports).clone(tangent),
            normal: normal,
            binormal: binormal
        });
    }
    return frames;
}
function $5409e5fedd273992$export$41fd1f401015bea3(renderer, size, divisions) {
    const positions = [];
    const normals = [];
    const colors = [];
    const indices = [];
    const half = size / 2;
    const step = size / divisions;
    for(let i = 0; i <= divisions; i++)for(let j = 0; j <= divisions; j++){
        const x = -half + i * step;
        const z = -half + j * step;
        positions.push(x, 0, z);
        normals.push(0, 1, 0);
        // Improved grid pattern with depth
        const distFromCenter = Math.sqrt(x * x + z * z) / half;
        // Grid lines - subtle
        const gridX = Math.abs(Math.sin(x * 0.4)) < 0.05;
        const gridZ = Math.abs(Math.sin(z * 0.4)) < 0.05;
        const isGrid = gridX || gridZ;
        // Major grid lines every 5 units
        const majorGridX = Math.abs(x % 10) < 0.3;
        const majorGridZ = Math.abs(z % 10) < 0.3;
        const isMajorGrid = majorGridX || majorGridZ;
        // Base color - darker, more contrast
        let r = 0.12;
        let g = 0.13;
        let b = 0.15;
        // Add grid pattern
        if (isMajorGrid) {
            r += 0.08;
            g += 0.09;
            b += 0.12;
        } else if (isGrid) {
            r += 0.03;
            g += 0.035;
            b += 0.05;
        }
        // Distance fade - darker at edges
        const edgeFade = 1.0 - distFromCenter * 0.6;
        r *= edgeFade;
        g *= edgeFade;
        b *= edgeFade;
        colors.push(r, g, b);
    }
    for(let i = 0; i < divisions; i++)for(let j = 0; j < divisions; j++){
        const a = i * (divisions + 1) + j;
        const b = a + 1;
        const c = a + divisions + 1;
        const d = c + 1;
        // CCW winding when viewed from above (normal pointing up)
        indices.push(a, b, c);
        indices.push(b, d, c);
    }
    return renderer.createMesh(positions, normals, colors, indices);
}
function $5409e5fedd273992$export$97696543eb826098(renderer, bottomPath, topPath, color, normalDir = 1) {
    const positions = [];
    const normals = [];
    const colors = [];
    const indices = [];
    // First pass: front faces
    for(let i = 0; i < bottomPath.length; i++){
        const bottom = bottomPath[i];
        const top = topPath[i];
        // Calculate normal for this segment
        let wallNormal;
        if (i < bottomPath.length - 1) {
            const nextBottom = bottomPath[i + 1];
            const tangent = (0, $8f228f84b1e7d967$exports).sub((0, $8f228f84b1e7d967$exports).create(), nextBottom, bottom);
            const up = (0, $8f228f84b1e7d967$exports).sub((0, $8f228f84b1e7d967$exports).create(), top, bottom);
            wallNormal = (0, $8f228f84b1e7d967$exports).cross((0, $8f228f84b1e7d967$exports).create(), tangent, up);
            (0, $8f228f84b1e7d967$exports).normalize(wallNormal, wallNormal);
            (0, $8f228f84b1e7d967$exports).scale(wallNormal, wallNormal, normalDir);
        } else if (i > 0) {
            const prevBottom = bottomPath[i - 1];
            const tangent = (0, $8f228f84b1e7d967$exports).sub((0, $8f228f84b1e7d967$exports).create(), bottom, prevBottom);
            const up = (0, $8f228f84b1e7d967$exports).sub((0, $8f228f84b1e7d967$exports).create(), top, bottom);
            wallNormal = (0, $8f228f84b1e7d967$exports).cross((0, $8f228f84b1e7d967$exports).create(), tangent, up);
            (0, $8f228f84b1e7d967$exports).normalize(wallNormal, wallNormal);
            (0, $8f228f84b1e7d967$exports).scale(wallNormal, wallNormal, normalDir);
        } else wallNormal = (0, $8f228f84b1e7d967$exports).fromValues(normalDir, 0, 0);
        // Bottom vertex
        positions.push(bottom[0], bottom[1], bottom[2]);
        normals.push(wallNormal[0], wallNormal[1], wallNormal[2]);
        colors.push(color[0], color[1], color[2]);
        // Top vertex
        positions.push(top[0], top[1], top[2]);
        normals.push(wallNormal[0], wallNormal[1], wallNormal[2]);
        colors.push(color[0], color[1], color[2]);
    }
    // Create front face triangles
    for(let i = 0; i < bottomPath.length - 1; i++){
        const bl = i * 2;
        const tl = i * 2 + 1;
        const br = (i + 1) * 2;
        const tr = (i + 1) * 2 + 1;
        indices.push(bl, br, tl);
        indices.push(br, tr, tl);
    }
    // Second pass: back faces (reverse winding, opposite normals)
    const vertexOffset = bottomPath.length * 2;
    for(let i = 0; i < bottomPath.length; i++){
        const bottom = bottomPath[i];
        const top = topPath[i];
        let wallNormal;
        if (i < bottomPath.length - 1) {
            const nextBottom = bottomPath[i + 1];
            const tangent = (0, $8f228f84b1e7d967$exports).sub((0, $8f228f84b1e7d967$exports).create(), nextBottom, bottom);
            const up = (0, $8f228f84b1e7d967$exports).sub((0, $8f228f84b1e7d967$exports).create(), top, bottom);
            wallNormal = (0, $8f228f84b1e7d967$exports).cross((0, $8f228f84b1e7d967$exports).create(), tangent, up);
            (0, $8f228f84b1e7d967$exports).normalize(wallNormal, wallNormal);
            (0, $8f228f84b1e7d967$exports).scale(wallNormal, wallNormal, -normalDir); // Opposite direction
        } else if (i > 0) {
            const prevBottom = bottomPath[i - 1];
            const tangent = (0, $8f228f84b1e7d967$exports).sub((0, $8f228f84b1e7d967$exports).create(), bottom, prevBottom);
            const up = (0, $8f228f84b1e7d967$exports).sub((0, $8f228f84b1e7d967$exports).create(), top, bottom);
            wallNormal = (0, $8f228f84b1e7d967$exports).cross((0, $8f228f84b1e7d967$exports).create(), tangent, up);
            (0, $8f228f84b1e7d967$exports).normalize(wallNormal, wallNormal);
            (0, $8f228f84b1e7d967$exports).scale(wallNormal, wallNormal, -normalDir);
        } else wallNormal = (0, $8f228f84b1e7d967$exports).fromValues(-normalDir, 0, 0);
        positions.push(bottom[0], bottom[1], bottom[2]);
        normals.push(wallNormal[0], wallNormal[1], wallNormal[2]);
        colors.push(color[0] * 0.8, color[1] * 0.8, color[2] * 0.8); // Slightly darker back
        positions.push(top[0], top[1], top[2]);
        normals.push(wallNormal[0], wallNormal[1], wallNormal[2]);
        colors.push(color[0] * 0.8, color[1] * 0.8, color[2] * 0.8);
    }
    // Create back face triangles (reverse winding)
    for(let i = 0; i < bottomPath.length - 1; i++){
        const bl = vertexOffset + i * 2;
        const tl = vertexOffset + i * 2 + 1;
        const br = vertexOffset + (i + 1) * 2;
        const tr = vertexOffset + (i + 1) * 2 + 1;
        indices.push(bl, tl, br);
        indices.push(br, tl, tr);
    }
    return renderer.createMesh(positions, normals, colors, indices);
}


class $97dbf72491973e01$export$13921ac0cc260818 {
    constructor(renderer){
        this.renderer = renderer;
        this.meshes = [];
        this.buildTrack();
    }
    buildTrack() {
        // Define control points for a Catmull-Rom spline
        // This ensures smooth continuous curvature throughout
        const controlPoints = [
            // Start - very high for lots of speed
            [
                0,
                28,
                -12
            ],
            [
                0,
                26,
                -8
            ],
            [
                0,
                24,
                -4
            ],
            [
                0,
                21,
                0
            ],
            // First curve - steeper descent
            [
                1,
                18,
                4
            ],
            [
                3,
                15,
                7
            ],
            [
                6,
                12,
                9
            ],
            [
                10,
                9,
                10
            ],
            // Continue curving, maintain slope
            [
                14,
                7,
                9
            ],
            [
                17,
                5,
                6
            ],
            [
                18,
                3.5,
                2
            ],
            // S-curve with good slope
            [
                17,
                2.5,
                -1
            ],
            [
                14,
                1.8,
                -3
            ],
            // Final steep drop to end
            [
                10,
                1.0,
                -2
            ],
            [
                6,
                0.5,
                0
            ]
        ];
        // Generate smooth path using Catmull-Rom interpolation
        let points = this.catmullRomSpline(controlPoints, 15); // 15 points per segment
        // Additional smoothing pass
        points = this.smoothPath(points, 3);
        // Ensure minimum height
        for(let i = 0; i < points.length; i++)if (points[i][1] < 0.4) points[i][1] = 0.4;
        this.path = points;
        this.pathLength = this.calculatePathLength();
        this.frames = (0, $5409e5fedd273992$export$9f33702dd6cd6b56)(points);
        this.createTrackMeshes();
        this.createSupports();
    }
    smoothPath(points, passes) {
        let result = points.map((p)=>(0, $8f228f84b1e7d967$exports).clone(p));
        for(let pass = 0; pass < passes; pass++){
            const newPoints = [
                (0, $8f228f84b1e7d967$exports).clone(result[0])
            ];
            for(let i = 1; i < result.length - 1; i++){
                const smoothed = (0, $8f228f84b1e7d967$exports).create();
                (0, $8f228f84b1e7d967$exports).scale(smoothed, result[i], 0.5);
                (0, $8f228f84b1e7d967$exports).scaleAndAdd(smoothed, smoothed, result[i - 1], 0.25);
                (0, $8f228f84b1e7d967$exports).scaleAndAdd(smoothed, smoothed, result[i + 1], 0.25);
                newPoints.push(smoothed);
            }
            newPoints.push((0, $8f228f84b1e7d967$exports).clone(result[result.length - 1]));
            result = newPoints;
        }
        return result;
    }
    catmullRomSpline(controlPoints, pointsPerSegment) {
        const result = [];
        // Convert control points to vec3
        const pts = controlPoints.map((p)=>(0, $8f228f84b1e7d967$exports).fromValues(p[0], p[1], p[2]));
        // For each segment between control points
        for(let i = 0; i < pts.length - 1; i++){
            // Get 4 control points (with clamping at ends)
            const p0 = pts[Math.max(0, i - 1)];
            const p1 = pts[i];
            const p2 = pts[Math.min(pts.length - 1, i + 1)];
            const p3 = pts[Math.min(pts.length - 1, i + 2)];
            // Generate points along this segment
            for(let j = 0; j < pointsPerSegment; j++){
                const t = j / pointsPerSegment;
                const point = this.catmullRomPoint(p0, p1, p2, p3, t);
                result.push(point);
            }
        }
        // Add final point
        result.push((0, $8f228f84b1e7d967$exports).clone(pts[pts.length - 1]));
        return result;
    }
    catmullRomPoint(p0, p1, p2, p3, t) {
        // Catmull-Rom spline formula
        const t2 = t * t;
        const t3 = t2 * t;
        const result = (0, $8f228f84b1e7d967$exports).create();
        // Coefficients for Catmull-Rom (tension = 0.5)
        for(let i = 0; i < 3; i++)result[i] = 0.5 * (2 * p1[i] + (-p0[i] + p2[i]) * t + (2 * p0[i] - 5 * p1[i] + 4 * p2[i] - p3[i]) * t2 + (-p0[i] + 3 * p1[i] - 3 * p2[i] + p3[i]) * t3);
        return result;
    }
    createTrackMeshes() {
        const railOffset = 0.14; // Wider track - more room for marble
        const railRadius = 0.04;
        const guardHeight = 0.25;
        const guardThickness = 0.02;
        const floorThickness = 0.03; // Thickness of the floor
        const leftPath = this.offsetPath(this.path, -railOffset);
        const rightPath = this.offsetPath(this.path, railOffset);
        // Store paths for collision detection
        this.leftRailPath = leftPath;
        this.rightRailPath = rightPath;
        this.railOffset = railOffset;
        this.railRadius = railRadius;
        this.guardHeight = guardHeight;
        // === CREATE SOLID TRACK CHANNEL (U-shape) ===
        const trackColor = [
            0.35,
            0.35,
            0.38
        ];
        const floorColor = [
            0.28,
            0.28,
            0.3
        ];
        // Floor surface (top of floor where marble rolls)
        const leftFloorTop = [];
        const rightFloorTop = [];
        const leftFloorBottom = [];
        const rightFloorBottom = [];
        const leftWallOuter = [];
        const rightWallOuter = [];
        const leftWallTop = [];
        const rightWallTop = [];
        for(let i = 0; i < this.path.length; i++){
            const frame = this.frames[i];
            const center = this.path[i];
            // Floor top surface (where marble rolls)
            leftFloorTop.push((0, $8f228f84b1e7d967$exports).fromValues(center[0] - frame.binormal[0] * railOffset + frame.normal[0] * railRadius, center[1] - frame.binormal[1] * railOffset + frame.normal[1] * railRadius, center[2] - frame.binormal[2] * railOffset + frame.normal[2] * railRadius));
            rightFloorTop.push((0, $8f228f84b1e7d967$exports).fromValues(center[0] + frame.binormal[0] * railOffset + frame.normal[0] * railRadius, center[1] + frame.binormal[1] * railOffset + frame.normal[1] * railRadius, center[2] + frame.binormal[2] * railOffset + frame.normal[2] * railRadius));
            // Floor bottom surface
            leftFloorBottom.push((0, $8f228f84b1e7d967$exports).fromValues(center[0] - frame.binormal[0] * (railOffset + guardThickness) - frame.normal[0] * floorThickness, center[1] - frame.binormal[1] * (railOffset + guardThickness) - frame.normal[1] * floorThickness, center[2] - frame.binormal[2] * (railOffset + guardThickness) - frame.normal[2] * floorThickness));
            rightFloorBottom.push((0, $8f228f84b1e7d967$exports).fromValues(center[0] + frame.binormal[0] * (railOffset + guardThickness) - frame.normal[0] * floorThickness, center[1] + frame.binormal[1] * (railOffset + guardThickness) - frame.normal[1] * floorThickness, center[2] + frame.binormal[2] * (railOffset + guardThickness) - frame.normal[2] * floorThickness));
            // Wall outer edges (at guard wall outer surface)
            leftWallOuter.push((0, $8f228f84b1e7d967$exports).fromValues(center[0] - frame.binormal[0] * (railOffset + guardThickness) - frame.normal[0] * floorThickness, center[1] - frame.binormal[1] * (railOffset + guardThickness) - frame.normal[1] * floorThickness, center[2] - frame.binormal[2] * (railOffset + guardThickness) - frame.normal[2] * floorThickness));
            rightWallOuter.push((0, $8f228f84b1e7d967$exports).fromValues(center[0] + frame.binormal[0] * (railOffset + guardThickness) - frame.normal[0] * floorThickness, center[1] + frame.binormal[1] * (railOffset + guardThickness) - frame.normal[1] * floorThickness, center[2] + frame.binormal[2] * (railOffset + guardThickness) - frame.normal[2] * floorThickness));
            // Wall tops
            leftWallTop.push((0, $8f228f84b1e7d967$exports).fromValues(center[0] - frame.binormal[0] * (railOffset + guardThickness) + frame.normal[0] * guardHeight, center[1] - frame.binormal[1] * (railOffset + guardThickness) + frame.normal[1] * guardHeight, center[2] - frame.binormal[2] * (railOffset + guardThickness) + frame.normal[2] * guardHeight));
            rightWallTop.push((0, $8f228f84b1e7d967$exports).fromValues(center[0] + frame.binormal[0] * (railOffset + guardThickness) + frame.normal[0] * guardHeight, center[1] + frame.binormal[1] * (railOffset + guardThickness) + frame.normal[1] * guardHeight, center[2] + frame.binormal[2] * (railOffset + guardThickness) + frame.normal[2] * guardHeight));
        }
        // Floor top surface (where marble rolls)
        this.meshes.push({
            mesh: (0, $5409e5fedd273992$export$97696543eb826098)(this.renderer, leftFloorTop, rightFloorTop, floorColor, 1),
            metallic: 0.2,
            roughness: 0.6
        });
        // Floor bottom surface
        this.meshes.push({
            mesh: (0, $5409e5fedd273992$export$97696543eb826098)(this.renderer, leftFloorBottom, rightFloorBottom, trackColor, -1),
            metallic: 0.3,
            roughness: 0.7
        });
        // Left guard wall (outer surface)
        this.meshes.push({
            mesh: (0, $5409e5fedd273992$export$97696543eb826098)(this.renderer, leftWallOuter, leftWallTop, trackColor, -1),
            metallic: 0.4,
            roughness: 0.5
        });
        // Right guard wall (outer surface)
        this.meshes.push({
            mesh: (0, $5409e5fedd273992$export$97696543eb826098)(this.renderer, rightWallOuter, rightWallTop, trackColor, 1),
            metallic: 0.4,
            roughness: 0.5
        });
        // Inner wall surfaces (facing the marble)
        const leftWallInner = [];
        const rightWallInner = [];
        for(let i = 0; i < this.path.length; i++){
            const frame = this.frames[i];
            const center = this.path[i];
            leftWallInner.push((0, $8f228f84b1e7d967$exports).fromValues(center[0] - frame.binormal[0] * railOffset + frame.normal[0] * railRadius, center[1] - frame.binormal[1] * railOffset + frame.normal[1] * railRadius, center[2] - frame.binormal[2] * railOffset + frame.normal[2] * railRadius));
            rightWallInner.push((0, $8f228f84b1e7d967$exports).fromValues(center[0] + frame.binormal[0] * railOffset + frame.normal[0] * railRadius, center[1] + frame.binormal[1] * railOffset + frame.normal[1] * railRadius, center[2] + frame.binormal[2] * railOffset + frame.normal[2] * railRadius));
        }
        // Left inner wall
        const leftInnerTop = [];
        for(let i = 0; i < this.path.length; i++){
            const frame = this.frames[i];
            leftInnerTop.push((0, $8f228f84b1e7d967$exports).fromValues(leftWallInner[i][0] + frame.normal[0] * (guardHeight - railRadius), leftWallInner[i][1] + frame.normal[1] * (guardHeight - railRadius), leftWallInner[i][2] + frame.normal[2] * (guardHeight - railRadius)));
        }
        this.meshes.push({
            mesh: (0, $5409e5fedd273992$export$97696543eb826098)(this.renderer, leftWallInner, leftInnerTop, trackColor, 1),
            metallic: 0.4,
            roughness: 0.5
        });
        // Right inner wall
        const rightInnerTop = [];
        for(let i = 0; i < this.path.length; i++){
            const frame = this.frames[i];
            rightInnerTop.push((0, $8f228f84b1e7d967$exports).fromValues(rightWallInner[i][0] + frame.normal[0] * (guardHeight - railRadius), rightWallInner[i][1] + frame.normal[1] * (guardHeight - railRadius), rightWallInner[i][2] + frame.normal[2] * (guardHeight - railRadius)));
        }
        this.meshes.push({
            mesh: (0, $5409e5fedd273992$export$97696543eb826098)(this.renderer, rightWallInner, rightInnerTop, trackColor, -1),
            metallic: 0.4,
            roughness: 0.5
        });
        // Top caps for walls
        this.meshes.push({
            mesh: (0, $5409e5fedd273992$export$97696543eb826098)(this.renderer, leftInnerTop, leftWallTop, trackColor, 1),
            metallic: 0.5,
            roughness: 0.4
        });
        this.meshes.push({
            mesh: (0, $5409e5fedd273992$export$97696543eb826098)(this.renderer, rightInnerTop, rightWallTop, trackColor, 1),
            metallic: 0.5,
            roughness: 0.4
        });
    }
    offsetPath(path, offset) {
        const result = [];
        for(let i = 0; i < path.length; i++){
            const frame = this.frames[i];
            result.push((0, $8f228f84b1e7d967$exports).fromValues(path[i][0] + frame.binormal[0] * offset, path[i][1] + frame.binormal[1] * offset, path[i][2] + frame.binormal[2] * offset));
        }
        return result;
    }
    createSupports() {
        const supportColor = [
            0.45,
            0.45,
            0.48
        ];
        const groundLevel = 0.05;
        for(let i = 0; i < this.path.length; i += 8){
            const p = this.path[i];
            if (p[1] > 1.2) {
                const supportPath = [
                    (0, $8f228f84b1e7d967$exports).fromValues(p[0], p[1] - 0.1, p[2]),
                    (0, $8f228f84b1e7d967$exports).fromValues(p[0], groundLevel, p[2])
                ];
                this.meshes.push({
                    mesh: (0, $5409e5fedd273992$export$16b64c4e1093e073)(this.renderer, supportPath, 0.06, 8, supportColor),
                    metallic: 0.7,
                    roughness: 0.4
                });
            }
        }
    }
    calculatePathLength() {
        let length = 0;
        for(let i = 1; i < this.path.length; i++)length += (0, $8f228f84b1e7d967$exports).distance(this.path[i], this.path[i - 1]);
        return length;
    }
    getPositionAtDistance(distance) {
        let accumulated = 0;
        for(let i = 1; i < this.path.length; i++){
            const segmentLength = (0, $8f228f84b1e7d967$exports).distance(this.path[i], this.path[i - 1]);
            if (accumulated + segmentLength >= distance) {
                const t = (distance - accumulated) / segmentLength;
                const pos = (0, $8f228f84b1e7d967$exports).create();
                (0, $8f228f84b1e7d967$exports).lerp(pos, this.path[i - 1], this.path[i], t);
                return {
                    position: pos,
                    index: i - 1,
                    t: t
                };
            }
            accumulated += segmentLength;
        }
        return {
            position: (0, $8f228f84b1e7d967$exports).clone(this.path[this.path.length - 1]),
            index: this.path.length - 2,
            t: 1
        };
    }
    getFrameAt(index, t) {
        const f0 = this.frames[index];
        const f1 = this.frames[Math.min(index + 1, this.frames.length - 1)];
        return {
            tangent: (0, $8f228f84b1e7d967$exports).lerp((0, $8f228f84b1e7d967$exports).create(), f0.tangent, f1.tangent, t),
            normal: (0, $8f228f84b1e7d967$exports).lerp((0, $8f228f84b1e7d967$exports).create(), f0.normal, f1.normal, t),
            binormal: (0, $8f228f84b1e7d967$exports).lerp((0, $8f228f84b1e7d967$exports).create(), f0.binormal, f1.binormal, t)
        };
    }
    /**
	 * Calculate track curvature at a given distance
	 * Curvature κ = |dT/ds| where T is unit tangent and s is arc length
	 * Returns: { curvature, curvatureVector, radius }
	 */ getCurvatureAtDistance(distance) {
        const delta = 0.1; // Sample distance for derivative
        // Get tangents at nearby points
        const pos0 = this.getPositionAtDistance(Math.max(0, distance - delta));
        const pos1 = this.getPositionAtDistance(Math.min(this.pathLength, distance + delta));
        const frame0 = this.getFrameAt(pos0.index, pos0.t);
        const frame1 = this.getFrameAt(pos1.index, pos1.t);
        // Normalize tangents
        (0, $8f228f84b1e7d967$exports).normalize(frame0.tangent, frame0.tangent);
        (0, $8f228f84b1e7d967$exports).normalize(frame1.tangent, frame1.tangent);
        // dT/ds approximation
        const dT = (0, $8f228f84b1e7d967$exports).sub((0, $8f228f84b1e7d967$exports).create(), frame1.tangent, frame0.tangent);
        const ds = 2 * delta;
        // Curvature magnitude
        const curvature = (0, $8f228f84b1e7d967$exports).length(dT) / ds;
        // Curvature vector (points toward center of curvature)
        const curvatureVector = (0, $8f228f84b1e7d967$exports).scale((0, $8f228f84b1e7d967$exports).create(), dT, 1 / ds);
        // Radius of curvature (1/κ), clamped to avoid infinity
        const radius = curvature > 0.001 ? 1 / curvature : 1000;
        return {
            curvature: curvature,
            curvatureVector: curvatureVector,
            radius: radius
        };
    }
    /**
	 * Get banking angle for a given curvature and design speed
	 * Bank angle θ = atan(v² / (r * g))
	 * Returns angle in radians
	 */ getBankingAngle(curvature, designSpeed = 3.0) {
        if (curvature < 0.01) return 0; // No banking on straight sections
        const radius = 1 / curvature;
        const g = 9.81;
        // Calculate ideal banking angle
        // tan(θ) = v² / (r * g)
        const tanTheta = designSpeed * designSpeed / (radius * g);
        // Clamp to reasonable range (-45° to 45°)
        const maxBank = Math.PI / 4;
        const angle = Math.atan(tanTheta);
        return Math.max(-maxBank, Math.min(maxBank, angle));
    }
    draw(renderer) {
        const identity = (0, $6e69ca24f4636b79$exports).create();
        for (const { mesh: mesh, metallic: metallic, roughness: roughness } of this.meshes)// isMarble=false, isGround=false, doubleSided=true for proper wall lighting
        renderer.drawMesh(mesh, identity, metallic, roughness, false, false, true);
    }
}




class $d5a33c4e62aaf32e$export$e91dba6fa3f67f68 {
    constructor(renderer, track){
        this.renderer = renderer;
        this.track = track;
        // Physical properties
        this.radius = 0.12;
        this.mass = 0.05; // 50 grams
        // Moment of inertia for solid sphere: I = (2/5) * m * r²
        this.momentOfInertia = 0.4 * this.mass * this.radius * this.radius;
        // Track geometry
        this.railRadius = 0.04;
        this.railOffset = 0.14;
        // Physics constants
        this.gravity = (0, $8f228f84b1e7d967$exports).fromValues(0, -9.81, 0);
        // Friction coefficients - Static > Kinetic (Coulomb friction model)
        this.staticFriction = 0.5; // Higher friction when stationary
        this.kineticFriction = 0.3; // Lower friction when sliding
        this.rollingResistance = 0.003; // Very low for rolling
        this.spinFriction = 0.001; // Friction for spinning in place (drilling)
        // Slip threshold - velocity difference between contact point and surface
        this.slipThreshold = 0.05; // Below this, considered rolling (no slip)
        // Air resistance
        this.dragCoefficient = 0.47;
        this.airDensity = 1.225;
        this.crossSectionArea = Math.PI * this.radius * this.radius;
        // Magnus effect coefficient (lift from spin)
        this.magnusCoefficient = 0.5; // Cl for spinning sphere
        // Gyroscopic precession coefficient
        this.gyroscopicScale = 1.0; // Scale factor for gyroscopic torque
        // Collision - LOW restitution to prevent bouncing
        // Base restitution (will be modified by velocity)
        this.baseRestitution = 0.25; // Base restitution for low-speed impacts
        this.minRestitution = 0.05; // Minimum restitution for high-speed impacts
        this.restitutionVelocityScale = 0.1; // How much velocity reduces restitution
        this.wallRestitution = 0.3;
        // Angular impulse transfer coefficient (0-1, how much spin transfers on impact)
        this.spinTransferCoefficient = 0.3;
        // Velocity threshold for "impact" vs "resting" contact
        this.impactThreshold = 0.5; // Only bounce if hitting faster than this
        // Centripetal force settings
        this.centripetalScale = 1.0; // Scale factor for centripetal force
        // Track banking
        this.bankingEnabled = true;
        this.bankingStrength = 0.8; // How much banking affects normal force direction
        // Sub-stepping
        this.maxSubSteps = 8;
        this.fixedDeltaTime = 1 / 240;
        // CCD - Continuous Collision Detection
        this.ccdEnabled = true;
        this.ccdIterations = 4; // Binary search iterations for precise impact time
        // Contact caching for smoother transitions
        this.contactCache = {
            lastFrame: null,
            lastTrackDistance: 0,
            lastNormal: (0, $8f228f84b1e7d967$exports).fromValues(0, 1, 0),
            contactDuration: 0,
            wasInContact: false
        };
        // Create mesh
        this.mesh = (0, $5409e5fedd273992$export$d21c7469ce5b89bf)(renderer, this.radius, 24, [
            0.1,
            0.4,
            0.15
        ]);
        this.reset();
    }
    reset() {
        const startPos = this.track.getPositionAtDistance(0.5);
        const frame = this.track.getFrameAt(startPos.index, startPos.t);
        // Position - place marble on track surface
        this.position = (0, $8f228f84b1e7d967$exports).clone(startPos.position);
        this.position[1] += this.railRadius + this.radius;
        // Velocity - small push along track
        (0, $8f228f84b1e7d967$exports).normalize(frame.tangent, frame.tangent);
        this.velocity = (0, $8f228f84b1e7d967$exports).scale((0, $8f228f84b1e7d967$exports).create(), frame.tangent, 0.5);
        // Angular velocity
        this.angularVelocity = (0, $8f228f84b1e7d967$exports).create();
        // Orientation
        this.orientation = (0, $c118a6fbc1a11e7b$exports).create();
        this.rotation = (0, $6e69ca24f4636b79$exports).create();
        // Track state
        this.trackDistance = 0.5;
        this.isOnTrack = false;
        this.isOnGround = false;
        // Store last valid contact normal for smooth transitions
        this.contactNormal = (0, $8f228f84b1e7d967$exports).fromValues(0, 1, 0);
        this.lastContactNormal = (0, $8f228f84b1e7d967$exports).fromValues(0, 1, 0);
        // Track curvature
        this.trackCurvature = 0;
        // Slip state tracking
        this.isSlipping = false; // true if sliding, false if rolling
        this.slipVelocity = 0; // magnitude of slip velocity
        // Energy tracking
        this.initialEnergy = this.calculateTotalEnergy();
        // Accumulator
        this.accumulator = 0;
        // Previous position for CCD
        this.prevPosition = (0, $8f228f84b1e7d967$exports).clone(this.position);
        // Reset contact cache
        this.contactCache = {
            lastFrame: null,
            lastTrackDistance: 0,
            lastNormal: (0, $8f228f84b1e7d967$exports).fromValues(0, 1, 0),
            contactDuration: 0,
            wasInContact: false
        };
    }
    update(dt) {
        if (!isFinite(dt) || dt <= 0) return {
            speed: 0,
            frame: null
        };
        dt = Math.min(dt, 0.1);
        this.accumulator += dt;
        let steps = 0;
        while(this.accumulator >= this.fixedDeltaTime && steps < this.maxSubSteps){
            this.physicsStep(this.fixedDeltaTime);
            this.accumulator -= this.fixedDeltaTime;
            steps++;
        }
        (0, $6e69ca24f4636b79$exports).fromQuat(this.rotation, this.orientation);
        // Bounds check
        if (this.position[1] < -5 || !this.isValidState()) {
            this.reset();
            return {
                speed: 0,
                frame: null
            };
        }
        // Track end
        if (this.trackDistance >= this.track.pathLength - 1) {
            this.reset();
            return {
                speed: 0,
                frame: null
            };
        }
        const speed = (0, $8f228f84b1e7d967$exports).length(this.velocity);
        return {
            speed: isFinite(speed) ? speed : 0,
            frame: this.isOnTrack ? this.getTrackFrame() : null
        };
    }
    isValidState() {
        return isFinite(this.position[0]) && isFinite(this.position[1]) && isFinite(this.position[2]) && isFinite(this.velocity[0]) && isFinite(this.velocity[1]) && isFinite(this.velocity[2]);
    }
    physicsStep(dt) {
        // Store previous position for CCD
        (0, $8f228f84b1e7d967$exports).copy(this.prevPosition, this.position);
        // === DETECT COLLISION FIRST ===
        // Find where the marble would be and check for collision
        const collision = this.detectCollision(this.position);
        // === CALCULATE FORCES ===
        const force = (0, $8f228f84b1e7d967$exports).create();
        // Gravity
        (0, $8f228f84b1e7d967$exports).scaleAndAdd(force, force, this.gravity, this.mass);
        // Air drag (only when not in contact, or always but reduced)
        const speed = (0, $8f228f84b1e7d967$exports).length(this.velocity);
        if (speed > 0.1) {
            const dragMagnitude = 0.5 * this.airDensity * this.dragCoefficient * this.crossSectionArea * speed * speed;
            const dragDir = (0, $8f228f84b1e7d967$exports).normalize((0, $8f228f84b1e7d967$exports).create(), this.velocity);
            (0, $8f228f84b1e7d967$exports).scaleAndAdd(force, force, dragDir, -dragMagnitude);
            // === MAGNUS EFFECT ===
            // Spinning ball experiences lift perpendicular to velocity and spin axis
            // F_magnus = 0.5 * Cl * rho * A * r * |omega x v|
            const angularSpeed = (0, $8f228f84b1e7d967$exports).length(this.angularVelocity);
            if (angularSpeed > 0.1 && !collision.hit) {
                // Magnus force direction: omega × velocity
                const magnusDir = (0, $8f228f84b1e7d967$exports).cross((0, $8f228f84b1e7d967$exports).create(), this.angularVelocity, this.velocity);
                const magnusDirLen = (0, $8f228f84b1e7d967$exports).length(magnusDir);
                if (magnusDirLen > 0.001) {
                    (0, $8f228f84b1e7d967$exports).scale(magnusDir, magnusDir, 1 / magnusDirLen);
                    // Magnus force magnitude
                    const magnusMagnitude = 0.5 * this.magnusCoefficient * this.airDensity * this.crossSectionArea * this.radius * angularSpeed * speed;
                    (0, $8f228f84b1e7d967$exports).scaleAndAdd(force, force, magnusDir, magnusMagnitude);
                }
            }
        }
        // === GYROSCOPIC PRECESSION ===
        // τ = ω × L, where L = I * ω
        // This makes spinning objects resist changes in orientation
        this.applyGyroscopicPrecession(dt);
        // === HANDLE CONTACT OR FREE FALL ===
        if (collision.hit) {
            // Update contact cache
            this.updateContactCache(collision, dt);
            // Apply centripetal force on curves
            this.applyCentripetalForce(collision, force, dt);
            this.handleContact(collision, force, dt);
        } else {
            // Free fall - just apply forces
            const acceleration = (0, $8f228f84b1e7d967$exports).scale((0, $8f228f84b1e7d967$exports).create(), force, 1 / this.mass);
            (0, $8f228f84b1e7d967$exports).scaleAndAdd(this.velocity, this.velocity, acceleration, dt);
            this.isOnTrack = false;
            this.isSlipping = false;
            // Reset contact cache
            this.contactCache.wasInContact = false;
            this.contactCache.contactDuration = 0;
        }
        // === UPDATE POSITION ===
        (0, $8f228f84b1e7d967$exports).scaleAndAdd(this.position, this.position, this.velocity, dt);
        // === CCD - Continuous Collision Detection ===
        if (this.ccdEnabled) this.performCCD(dt);
        // === POST-COLLISION CORRECTION ===
        // After moving, make sure we're not penetrating
        const postCollision = this.detectCollision(this.position);
        if (postCollision.hit && postCollision.penetration > 0.001) {
            // Push out of penetration
            (0, $8f228f84b1e7d967$exports).copy(this.position, postCollision.position);
            this.trackDistance = postCollision.trackDistance;
        }
        // Ground collision
        this.handleGroundCollision();
        // Update orientation from angular velocity
        this.updateOrientation(dt);
        // Clamp extreme values
        this.clampValues();
    }
    /**
	 * Apply gyroscopic precession torque
	 * τ = ω × L, where L = I * ω (angular momentum)
	 * This makes fast-spinning objects more stable
	 */ applyGyroscopicPrecession(dt) {
        const angularSpeed = (0, $8f228f84b1e7d967$exports).length(this.angularVelocity);
        if (angularSpeed < 0.5) return; // Only significant at higher spin rates
        // Angular momentum L = I * ω
        const angularMomentum = (0, $8f228f84b1e7d967$exports).scale((0, $8f228f84b1e7d967$exports).create(), this.angularVelocity, this.momentOfInertia);
        // Gyroscopic torque τ = ω × L
        // For a sphere, this creates a precession effect
        const gyroTorque = (0, $8f228f84b1e7d967$exports).cross((0, $8f228f84b1e7d967$exports).create(), this.angularVelocity, angularMomentum);
        // The torque magnitude is small but creates stability
        // Scale it down to avoid instability
        (0, $8f228f84b1e7d967$exports).scale(gyroTorque, gyroTorque, this.gyroscopicScale * 0.01);
        // Apply as angular acceleration: α = τ / I
        const angularAccel = (0, $8f228f84b1e7d967$exports).scale((0, $8f228f84b1e7d967$exports).create(), gyroTorque, 1 / this.momentOfInertia);
        (0, $8f228f84b1e7d967$exports).scaleAndAdd(this.angularVelocity, this.angularVelocity, angularAccel, dt);
    }
    /**
	 * Update contact cache for smoother transitions
	 */ updateContactCache(collision, dt) {
        if (this.contactCache.wasInContact) this.contactCache.contactDuration += dt;
        else this.contactCache.contactDuration = dt;
        this.contactCache.wasInContact = true;
        this.contactCache.lastTrackDistance = collision.trackDistance;
        this.contactCache.lastFrame = collision.frame;
        // Smoothly blend normal based on contact duration
        const blendFactor = Math.min(1, this.contactCache.contactDuration * 5);
        (0, $8f228f84b1e7d967$exports).lerp(this.contactCache.lastNormal, this.contactCache.lastNormal, collision.normal, blendFactor);
        (0, $8f228f84b1e7d967$exports).normalize(this.contactCache.lastNormal, this.contactCache.lastNormal);
    }
    /**
	 * Apply centripetal force on curved track sections
	 * F_centripetal = m * v² / r (pointing toward center of curvature)
	 */ applyCentripetalForce(collision, force, dt) {
        const speed = (0, $8f228f84b1e7d967$exports).length(this.velocity);
        if (speed < 0.5) return; // Not significant at low speeds
        // Get track curvature at current position
        const curvatureInfo = this.track.getCurvatureAtDistance(collision.trackDistance);
        const curvature = curvatureInfo.curvature;
        if (curvature < 0.01) return; // Straight section
        // Store curvature for debug display
        this.trackCurvature = curvature;
        // Centripetal acceleration = v² * κ
        const centripetalAccel = speed * speed * curvature;
        // Direction: toward center of curvature (curvature vector direction)
        const centripetalDir = (0, $8f228f84b1e7d967$exports).normalize((0, $8f228f84b1e7d967$exports).create(), curvatureInfo.curvatureVector);
        // Apply centripetal force
        const centripetalForce = centripetalAccel * this.mass * this.centripetalScale;
        (0, $8f228f84b1e7d967$exports).scaleAndAdd(force, force, centripetalDir, centripetalForce);
        // === TRACK BANKING ===
        if (this.bankingEnabled) {
            // Get banking angle for this curvature
            const bankAngle = this.track.getBankingAngle(curvature, speed);
            if (Math.abs(bankAngle) > 0.01) {
                // Rotate the contact normal by bank angle around track tangent
                // This simulates a banked track surface
                const frame = collision.frame;
                const tangent = (0, $8f228f84b1e7d967$exports).normalize((0, $8f228f84b1e7d967$exports).create(), frame.tangent);
                // Determine bank direction based on curve direction
                // If curving left, bank right (and vice versa)
                const curveDir = (0, $8f228f84b1e7d967$exports).dot(curvatureInfo.curvatureVector, frame.binormal);
                const bankDir = curveDir > 0 ? -1 : 1;
                // Create banked normal by rotating around tangent
                const bankedNormal = this.rotateVectorAroundAxis(collision.normal, tangent, bankAngle * bankDir * this.bankingStrength);
                // Apply banking effect to force distribution
                // This pushes the marble toward the inside of the curve
                const bankingForce = (0, $8f228f84b1e7d967$exports).scale((0, $8f228f84b1e7d967$exports).create(), bankedNormal, centripetalForce * Math.sin(bankAngle) * 0.5);
                (0, $8f228f84b1e7d967$exports).add(force, force, bankingForce);
            }
        }
    }
    /**
	 * Rotate a vector around an axis by a given angle (Rodrigues' rotation)
	 */ rotateVectorAroundAxis(v, axis, angle) {
        const cosA = Math.cos(angle);
        const sinA = Math.sin(angle);
        // Rodrigues' rotation formula:
        // v_rot = v*cos(θ) + (k×v)*sin(θ) + k*(k·v)*(1-cos(θ))
        const result = (0, $8f228f84b1e7d967$exports).create();
        // v * cos(θ)
        (0, $8f228f84b1e7d967$exports).scale(result, v, cosA);
        // (k × v) * sin(θ)
        const kCrossV = (0, $8f228f84b1e7d967$exports).cross((0, $8f228f84b1e7d967$exports).create(), axis, v);
        (0, $8f228f84b1e7d967$exports).scaleAndAdd(result, result, kCrossV, sinA);
        // k * (k · v) * (1 - cos(θ))
        const kDotV = (0, $8f228f84b1e7d967$exports).dot(axis, v);
        (0, $8f228f84b1e7d967$exports).scaleAndAdd(result, result, axis, kDotV * (1 - cosA));
        return result;
    }
    /**
	 * Calculate velocity-dependent restitution
	 * Higher impact velocity = lower restitution (more energy absorbed)
	 */ getVelocityDependentRestitution(impactVelocity) {
        const impactSpeed = Math.abs(impactVelocity);
        // Restitution decreases with impact velocity
        // e = e_base - k * v, clamped to [e_min, e_base]
        const restitution = this.baseRestitution - this.restitutionVelocityScale * impactSpeed;
        return Math.max(this.minRestitution, Math.min(this.baseRestitution, restitution));
    }
    handleContact(collision, force, dt) {
        const N = collision.normal;
        // Use contact cache for smoother normal transitions
        let smoothN;
        if (this.contactCache.wasInContact && this.contactCache.contactDuration > 0.01) {
            // Blend between cached normal and new normal for smooth transitions
            smoothN = (0, $8f228f84b1e7d967$exports).clone(this.contactCache.lastNormal);
            (0, $8f228f84b1e7d967$exports).lerp(smoothN, smoothN, N, 0.2);
            (0, $8f228f84b1e7d967$exports).normalize(smoothN, smoothN);
        } else {
            // First contact or cache expired - use direct normal with light smoothing
            (0, $8f228f84b1e7d967$exports).lerp(this.contactNormal, this.lastContactNormal, N, 0.3);
            (0, $8f228f84b1e7d967$exports).normalize(this.contactNormal, this.contactNormal);
            smoothN = this.contactNormal;
        }
        (0, $8f228f84b1e7d967$exports).copy(this.lastContactNormal, smoothN);
        // Update track distance
        this.trackDistance = collision.trackDistance;
        this.isOnTrack = true;
        // Velocity component into surface
        const vDotN = (0, $8f228f84b1e7d967$exports).dot(this.velocity, smoothN);
        // === IMPACT vs RESTING CONTACT ===
        if (vDotN < -this.impactThreshold) // IMPACT - apply bounce impulse with angular impulse transfer
        this.handleImpact(collision, smoothN, vDotN, dt);
        else if (vDotN < 0) // SOFT CONTACT - just remove the penetrating velocity, no bounce
        (0, $8f228f84b1e7d967$exports).scaleAndAdd(this.velocity, this.velocity, smoothN, -vDotN);
        // === CONTACT FORCES ===
        // Gravity component along surface (this is what makes marble roll down)
        const gravityDotN = (0, $8f228f84b1e7d967$exports).dot(this.gravity, smoothN);
        const gravityTangent = (0, $8f228f84b1e7d967$exports).scaleAndAdd((0, $8f228f84b1e7d967$exports).create(), this.gravity, smoothN, -gravityDotN);
        // Apply tangential gravity (acceleration down the slope)
        (0, $8f228f84b1e7d967$exports).scaleAndAdd(this.velocity, this.velocity, gravityTangent, dt);
        // Normal force magnitude
        const normalForce = Math.max(0, -gravityDotN * this.mass);
        // === SLIP DETECTION ===
        // Calculate contact point velocity vs expected rolling velocity
        const slipInfo = this.calculateSlip(smoothN);
        this.isSlipping = slipInfo.isSlipping;
        this.slipVelocity = slipInfo.slipSpeed;
        // === FRICTION WITH STATIC/KINETIC TRANSITION ===
        this.applyFriction(smoothN, normalForce, slipInfo, dt);
        // === WALL SPECIFIC ===
        if (collision.type.startsWith('wall')) {
            // Extra friction on walls to prevent sliding up
            const wallFriction = this.kineticFriction * normalForce * 0.5;
            const wallDecel = wallFriction / this.mass * dt;
            const verticalVel = this.velocity[1];
            if (verticalVel > 0) this.velocity[1] = Math.max(0, verticalVel - wallDecel);
        }
    }
    /**
	 * Handle impact collision with angular impulse transfer
	 * Uses velocity-dependent restitution for realistic energy absorption
	 */ handleImpact(collision, smoothN, vDotN, dt) {
        // Get velocity-dependent restitution
        const restitution = collision.type.startsWith('wall') ? this.wallRestitution : this.getVelocityDependentRestitution(vDotN);
        // === LINEAR IMPULSE ===
        // Remove velocity into surface and add bounce
        const impulseMagnitude = -vDotN * (1 + restitution) * this.mass;
        (0, $8f228f84b1e7d967$exports).scaleAndAdd(this.velocity, this.velocity, smoothN, impulseMagnitude / this.mass);
        // === ANGULAR IMPULSE TRANSFER ===
        // When marble hits surface, friction at contact point creates torque
        // This transfers some linear momentum to angular momentum
        // Tangent velocity at impact
        const tangentVel = (0, $8f228f84b1e7d967$exports).scaleAndAdd((0, $8f228f84b1e7d967$exports).create(), this.velocity, smoothN, -(0, $8f228f84b1e7d967$exports).dot(this.velocity, smoothN));
        const tangentSpeed = (0, $8f228f84b1e7d967$exports).length(tangentVel);
        if (tangentSpeed > 0.1) {
            // Contact point velocity due to current spin
            const contactPointVel = this.getContactPointVelocity(smoothN);
            // Relative sliding velocity at contact
            const relativeVel = (0, $8f228f84b1e7d967$exports).sub((0, $8f228f84b1e7d967$exports).create(), tangentVel, contactPointVel);
            const relativeSpeed = (0, $8f228f84b1e7d967$exports).length(relativeVel);
            if (relativeSpeed > 0.01) {
                // Friction impulse at contact creates torque
                // τ = r × F, where r is from center to contact point
                const contactPoint = (0, $8f228f84b1e7d967$exports).scale((0, $8f228f84b1e7d967$exports).create(), smoothN, -this.radius);
                // Friction impulse direction (opposes relative motion)
                const frictionDir = (0, $8f228f84b1e7d967$exports).normalize((0, $8f228f84b1e7d967$exports).create(), relativeVel);
                (0, $8f228f84b1e7d967$exports).negate(frictionDir, frictionDir);
                // Friction impulse magnitude (limited by impact force)
                const frictionImpulse = Math.min(relativeSpeed * this.mass * this.spinTransferCoefficient, Math.abs(vDotN) * this.mass * this.kineticFriction);
                // Torque = r × F
                const torqueDir = (0, $8f228f84b1e7d967$exports).cross((0, $8f228f84b1e7d967$exports).create(), contactPoint, frictionDir);
                const torqueMagnitude = this.radius * frictionImpulse;
                // Angular impulse: Δω = τ * dt / I
                // But for instantaneous impact: Δω = (r × J) / I
                const angularImpulse = (0, $8f228f84b1e7d967$exports).scale((0, $8f228f84b1e7d967$exports).create(), torqueDir, torqueMagnitude / this.momentOfInertia);
                (0, $8f228f84b1e7d967$exports).add(this.angularVelocity, this.angularVelocity, angularImpulse);
                // Also reduce linear velocity slightly (momentum conservation)
                (0, $8f228f84b1e7d967$exports).scaleAndAdd(this.velocity, this.velocity, frictionDir, -frictionImpulse * this.spinTransferCoefficient / this.mass);
            }
        }
    }
    /**
	 * Calculate slip between contact point and surface
	 * Returns { isSlipping, slipSpeed, slipDirection }
	 */ calculateSlip(normal) {
        // Tangent velocity of marble center
        const tangentVel = (0, $8f228f84b1e7d967$exports).scaleAndAdd((0, $8f228f84b1e7d967$exports).create(), this.velocity, normal, -(0, $8f228f84b1e7d967$exports).dot(this.velocity, normal));
        // Contact point velocity due to rotation
        // v_contact = ω × r, where r points from center to contact
        const contactPointVel = this.getContactPointVelocity(normal);
        // For pure rolling: tangentVel should equal contactPointVel
        // Slip velocity = tangentVel - contactPointVel
        const slipVel = (0, $8f228f84b1e7d967$exports).sub((0, $8f228f84b1e7d967$exports).create(), tangentVel, contactPointVel);
        const slipSpeed = (0, $8f228f84b1e7d967$exports).length(slipVel);
        // Normalize slip direction
        const slipDir = (0, $8f228f84b1e7d967$exports).create();
        if (slipSpeed > 0.001) (0, $8f228f84b1e7d967$exports).scale(slipDir, slipVel, 1 / slipSpeed);
        return {
            isSlipping: slipSpeed > this.slipThreshold,
            slipSpeed: slipSpeed,
            slipDirection: slipDir,
            slipVelocity: slipVel
        };
    }
    /**
	 * Get velocity of the contact point due to rotation
	 * v = ω × (-r * normal) where -r*normal is vector from center to contact
	 */ getContactPointVelocity(normal) {
        const contactRadius = (0, $8f228f84b1e7d967$exports).scale((0, $8f228f84b1e7d967$exports).create(), normal, -this.radius);
        return (0, $8f228f84b1e7d967$exports).cross((0, $8f228f84b1e7d967$exports).create(), this.angularVelocity, contactRadius);
    }
    /**
	 * Apply friction using Coulomb model with static/kinetic transition
	 */ applyFriction(normal, normalForce, slipInfo, dt) {
        if (normalForce <= 0) return;
        const tangentVel = (0, $8f228f84b1e7d967$exports).scaleAndAdd((0, $8f228f84b1e7d967$exports).create(), this.velocity, normal, -(0, $8f228f84b1e7d967$exports).dot(this.velocity, normal));
        const tangentSpeed = (0, $8f228f84b1e7d967$exports).length(tangentVel);
        if (tangentSpeed < 0.001) {
            // Nearly stopped - apply spin friction (drilling friction)
            const angularSpeed = (0, $8f228f84b1e7d967$exports).length(this.angularVelocity);
            if (angularSpeed > 0.01) {
                const spinTorque = this.spinFriction * normalForce * this.radius;
                const spinDecel = spinTorque / this.momentOfInertia * dt;
                const scale = Math.max(0, 1 - spinDecel / angularSpeed);
                (0, $8f228f84b1e7d967$exports).scale(this.angularVelocity, this.angularVelocity, scale);
            }
            return;
        }
        if (slipInfo.isSlipping) {
            // === KINETIC FRICTION (sliding) ===
            // Friction force opposes slip direction
            const frictionForce = this.kineticFriction * normalForce;
            const frictionDecel = frictionForce / this.mass * dt;
            // Apply friction to reduce slip
            if (frictionDecel < slipInfo.slipSpeed) {
                // Reduce linear velocity in slip direction
                (0, $8f228f84b1e7d967$exports).scaleAndAdd(this.velocity, this.velocity, slipInfo.slipDirection, -frictionDecel * 0.7);
                // Also accelerate rotation to match (friction creates torque)
                const contactPoint = (0, $8f228f84b1e7d967$exports).scale((0, $8f228f84b1e7d967$exports).create(), normal, -this.radius);
                const torqueDir = (0, $8f228f84b1e7d967$exports).cross((0, $8f228f84b1e7d967$exports).create(), contactPoint, slipInfo.slipDirection);
                const torqueMag = frictionForce * this.radius;
                const angularAccel = torqueMag / this.momentOfInertia;
                (0, $8f228f84b1e7d967$exports).scaleAndAdd(this.angularVelocity, this.angularVelocity, torqueDir, -angularAccel * dt);
            } else // Slip would reverse - snap to rolling
            this.enforceRolling(normal, dt);
        } else {
            // === STATIC FRICTION (rolling) ===
            // Apply rolling resistance (very small)
            const rollingForce = this.rollingResistance * normalForce;
            const frictionDecel = rollingForce / this.mass * dt;
            if (frictionDecel < tangentSpeed) {
                const tangentDir = (0, $8f228f84b1e7d967$exports).scale((0, $8f228f84b1e7d967$exports).create(), tangentVel, 1 / tangentSpeed);
                (0, $8f228f84b1e7d967$exports).scaleAndAdd(this.velocity, this.velocity, tangentDir, -frictionDecel);
            }
            // Enforce rolling constraint (keep angular and linear in sync)
            this.enforceRolling(normal, dt);
        }
    }
    enforceRolling(N, dt) {
        const speed = (0, $8f228f84b1e7d967$exports).length(this.velocity);
        if (speed < 0.05) return;
        const velDir = (0, $8f228f84b1e7d967$exports).normalize((0, $8f228f84b1e7d967$exports).create(), this.velocity);
        const rollAxis = (0, $8f228f84b1e7d967$exports).cross((0, $8f228f84b1e7d967$exports).create(), N, velDir);
        const rollAxisLen = (0, $8f228f84b1e7d967$exports).length(rollAxis);
        if (rollAxisLen < 0.001) return;
        (0, $8f228f84b1e7d967$exports).scale(rollAxis, rollAxis, 1 / rollAxisLen);
        const targetAngularSpeed = speed / this.radius;
        const targetAngular = (0, $8f228f84b1e7d967$exports).scale((0, $8f228f84b1e7d967$exports).create(), rollAxis, targetAngularSpeed);
        // Gradually sync angular velocity
        (0, $8f228f84b1e7d967$exports).lerp(this.angularVelocity, this.angularVelocity, targetAngular, Math.min(1, 10 * dt));
    }
    /**
	 * Continuous Collision Detection (CCD) using swept sphere
	 * Prevents tunneling through thin surfaces at high speeds
	 */ performCCD(dt) {
        const speed = (0, $8f228f84b1e7d967$exports).length(this.velocity);
        // Only needed at high speeds where tunneling might occur
        if (speed < 2.0) return;
        // Displacement this frame
        const displacement = (0, $8f228f84b1e7d967$exports).sub((0, $8f228f84b1e7d967$exports).create(), this.position, this.prevPosition);
        const moveDistance = (0, $8f228f84b1e7d967$exports).length(displacement);
        // If moved less than radius, discrete collision is fine
        if (moveDistance < this.radius * 0.5) return;
        // Binary search for time of impact
        let tMin = 0;
        let tMax = 1;
        let hitFound = false;
        let hitResult = null;
        for(let i = 0; i < this.ccdIterations; i++){
            const tMid = (tMin + tMax) / 2;
            // Interpolate position
            const testPos = (0, $8f228f84b1e7d967$exports).create();
            (0, $8f228f84b1e7d967$exports).lerp(testPos, this.prevPosition, this.position, tMid);
            const collision = this.detectCollision(testPos);
            if (collision.hit && collision.penetration > 0.001) {
                // Collision at this point, search earlier
                tMax = tMid;
                hitFound = true;
                hitResult = collision;
            } else // No collision, search later
            tMin = tMid;
        }
        if (hitFound && hitResult) {
            // Found time of impact - move to that position and resolve collision
            const toi = tMin; // Time just before impact
            // Position at time of impact
            const impactPos = (0, $8f228f84b1e7d967$exports).create();
            (0, $8f228f84b1e7d967$exports).lerp(impactPos, this.prevPosition, this.position, toi);
            // Move marble to impact position
            (0, $8f228f84b1e7d967$exports).copy(this.position, impactPos);
            // Detect collision at impact point
            const impactCollision = this.detectCollision(this.position);
            if (impactCollision.hit) {
                // Resolve the collision
                const N = impactCollision.normal;
                const vDotN = (0, $8f228f84b1e7d967$exports).dot(this.velocity, N);
                if (vDotN < 0) // Apply collision response with angular impulse
                this.handleImpact(impactCollision, N, vDotN, dt * (1 - toi));
                // Move to corrected position
                (0, $8f228f84b1e7d967$exports).copy(this.position, impactCollision.position);
                this.trackDistance = impactCollision.trackDistance;
            }
            // Continue with remaining time
            const remainingTime = dt * (1 - toi);
            if (remainingTime > 0.0001) (0, $8f228f84b1e7d967$exports).scaleAndAdd(this.position, this.position, this.velocity, remainingTime);
        }
    }
    detectCollision(pos) {
        // Find closest track point using hierarchical search
        let bestDist = Infinity;
        let bestTrackDist = this.trackDistance;
        const searchStart = Math.max(0, this.trackDistance - 2);
        const searchEnd = Math.min(this.track.pathLength, this.trackDistance + 4);
        // Coarse search
        for(let d = searchStart; d <= searchEnd; d += 0.2){
            const tp = this.track.getPositionAtDistance(d);
            const dist = (0, $8f228f84b1e7d967$exports).distance(pos, tp.position);
            if (dist < bestDist) {
                bestDist = dist;
                bestTrackDist = d;
            }
        }
        // Fine search
        for(let d = bestTrackDist - 0.25; d <= bestTrackDist + 0.25; d += 0.03){
            if (d < 0 || d > this.track.pathLength) continue;
            const tp = this.track.getPositionAtDistance(d);
            const dist = (0, $8f228f84b1e7d967$exports).distance(pos, tp.position);
            if (dist < bestDist) {
                bestDist = dist;
                bestTrackDist = d;
            }
        }
        const trackPoint = this.track.getPositionAtDistance(bestTrackDist);
        const frame = this.track.getFrameAt(trackPoint.index, trackPoint.t);
        (0, $8f228f84b1e7d967$exports).normalize(frame.tangent, frame.tangent);
        (0, $8f228f84b1e7d967$exports).normalize(frame.normal, frame.normal);
        (0, $8f228f84b1e7d967$exports).normalize(frame.binormal, frame.binormal);
        // Position relative to track center
        const toMarble = (0, $8f228f84b1e7d967$exports).sub((0, $8f228f84b1e7d967$exports).create(), pos, trackPoint.position);
        const lateralOffset = (0, $8f228f84b1e7d967$exports).dot(toMarble, frame.binormal);
        const heightAboveCenter = (0, $8f228f84b1e7d967$exports).dot(toMarble, frame.normal);
        const trackHalfWidth = this.railOffset;
        const isOverTrack = Math.abs(lateralOffset) < trackHalfWidth + this.radius;
        if (!isOverTrack) return {
            hit: false,
            trackDistance: bestTrackDist,
            frame: frame
        };
        // Floor collision check
        const floorHeight = this.railRadius;
        const distToFloor = heightAboveCenter - floorHeight;
        // Check floor first
        if (distToFloor < this.radius) {
            const penetration = this.radius - distToFloor;
            const correctedPos = (0, $8f228f84b1e7d967$exports).scaleAndAdd((0, $8f228f84b1e7d967$exports).create(), pos, frame.normal, penetration);
            // Also check walls while on floor
            const lateralAfterCorrection = lateralOffset; // lateral doesn't change from floor correction
            // Left wall
            if (lateralAfterCorrection < -trackHalfWidth + this.radius) {
                const wallPen = -trackHalfWidth + this.radius - lateralAfterCorrection;
                (0, $8f228f84b1e7d967$exports).scaleAndAdd(correctedPos, correctedPos, frame.binormal, wallPen);
                // Combined floor+wall normal (corner)
                const combinedNormal = (0, $8f228f84b1e7d967$exports).add((0, $8f228f84b1e7d967$exports).create(), frame.normal, frame.binormal);
                (0, $8f228f84b1e7d967$exports).normalize(combinedNormal, combinedNormal);
                return {
                    hit: true,
                    position: correctedPos,
                    normal: combinedNormal,
                    tangent: (0, $8f228f84b1e7d967$exports).clone(frame.tangent),
                    trackDistance: bestTrackDist,
                    penetration: Math.max(penetration, wallPen),
                    type: 'corner_left',
                    frame: frame
                };
            }
            // Right wall
            if (lateralAfterCorrection > trackHalfWidth - this.radius) {
                const wallPen = lateralAfterCorrection - (trackHalfWidth - this.radius);
                const negBinormal = (0, $8f228f84b1e7d967$exports).negate((0, $8f228f84b1e7d967$exports).create(), frame.binormal);
                (0, $8f228f84b1e7d967$exports).scaleAndAdd(correctedPos, correctedPos, negBinormal, wallPen);
                const combinedNormal = (0, $8f228f84b1e7d967$exports).add((0, $8f228f84b1e7d967$exports).create(), frame.normal, negBinormal);
                (0, $8f228f84b1e7d967$exports).normalize(combinedNormal, combinedNormal);
                return {
                    hit: true,
                    position: correctedPos,
                    normal: combinedNormal,
                    tangent: (0, $8f228f84b1e7d967$exports).clone(frame.tangent),
                    trackDistance: bestTrackDist,
                    penetration: Math.max(penetration, wallPen),
                    type: 'corner_right',
                    frame: frame
                };
            }
            return {
                hit: true,
                position: correctedPos,
                normal: (0, $8f228f84b1e7d967$exports).clone(frame.normal),
                tangent: (0, $8f228f84b1e7d967$exports).clone(frame.tangent),
                trackDistance: bestTrackDist,
                penetration: penetration,
                type: 'floor',
                frame: frame
            };
        }
        // Wall-only collision (marble is above floor level)
        // Left wall
        if (lateralOffset < -trackHalfWidth + this.radius) {
            const penetration = -trackHalfWidth + this.radius - lateralOffset;
            const correctedPos = (0, $8f228f84b1e7d967$exports).scaleAndAdd((0, $8f228f84b1e7d967$exports).create(), pos, frame.binormal, penetration);
            return {
                hit: true,
                position: correctedPos,
                normal: (0, $8f228f84b1e7d967$exports).clone(frame.binormal),
                tangent: (0, $8f228f84b1e7d967$exports).clone(frame.tangent),
                trackDistance: bestTrackDist,
                penetration: penetration,
                type: 'wall_left',
                frame: frame
            };
        }
        // Right wall
        if (lateralOffset > trackHalfWidth - this.radius) {
            const penetration = lateralOffset - (trackHalfWidth - this.radius);
            const negBinormal = (0, $8f228f84b1e7d967$exports).negate((0, $8f228f84b1e7d967$exports).create(), frame.binormal);
            const correctedPos = (0, $8f228f84b1e7d967$exports).scaleAndAdd((0, $8f228f84b1e7d967$exports).create(), pos, negBinormal, penetration);
            return {
                hit: true,
                position: correctedPos,
                normal: negBinormal,
                tangent: (0, $8f228f84b1e7d967$exports).clone(frame.tangent),
                trackDistance: bestTrackDist,
                penetration: penetration,
                type: 'wall_right',
                frame: frame
            };
        }
        return {
            hit: false,
            trackDistance: bestTrackDist,
            frame: frame
        };
    }
    handleGroundCollision() {
        if (this.position[1] >= this.radius) {
            this.isOnGround = false;
            return;
        }
        this.position[1] = this.radius;
        this.isOnGround = true;
        // Only bounce on hard impact
        if (this.velocity[1] < -this.impactThreshold) this.velocity[1] = -this.velocity[1] * 0.3;
        else if (this.velocity[1] < 0) this.velocity[1] = 0;
        // Rolling friction on ground
        const hSpeed = Math.sqrt(this.velocity[0] ** 2 + this.velocity[2] ** 2);
        if (hSpeed > 0.01) {
            const friction = 0.1962 * this.fixedDeltaTime;
            const scale = Math.max(0, 1 - friction / hSpeed);
            this.velocity[0] *= scale;
            this.velocity[2] *= scale;
        }
    }
    updateOrientation(dt) {
        const angularSpeed = (0, $8f228f84b1e7d967$exports).length(this.angularVelocity);
        if (angularSpeed > 0.001) {
            const axis = (0, $8f228f84b1e7d967$exports).scale((0, $8f228f84b1e7d967$exports).create(), this.angularVelocity, 1 / angularSpeed);
            const angle = angularSpeed * dt;
            const deltaQuat = (0, $c118a6fbc1a11e7b$exports).setAxisAngle((0, $c118a6fbc1a11e7b$exports).create(), axis, angle);
            (0, $c118a6fbc1a11e7b$exports).multiply(this.orientation, deltaQuat, this.orientation);
            (0, $c118a6fbc1a11e7b$exports).normalize(this.orientation, this.orientation);
        }
    }
    clampValues() {
        const maxSpeed = 50;
        const maxAngular = 200;
        const speed = (0, $8f228f84b1e7d967$exports).length(this.velocity);
        if (speed > maxSpeed) (0, $8f228f84b1e7d967$exports).scale(this.velocity, this.velocity, maxSpeed / speed);
        const angSpeed = (0, $8f228f84b1e7d967$exports).length(this.angularVelocity);
        if (angSpeed > maxAngular) (0, $8f228f84b1e7d967$exports).scale(this.angularVelocity, this.angularVelocity, maxAngular / angSpeed);
    }
    getTrackFrame() {
        const trackPoint = this.track.getPositionAtDistance(this.trackDistance);
        return this.track.getFrameAt(trackPoint.index, trackPoint.t);
    }
    calculateKineticEnergy() {
        const linearKE = 0.5 * this.mass * (0, $8f228f84b1e7d967$exports).squaredLength(this.velocity);
        const angularKE = 0.5 * this.momentOfInertia * (0, $8f228f84b1e7d967$exports).squaredLength(this.angularVelocity);
        return linearKE + angularKE;
    }
    calculatePotentialEnergy() {
        return this.mass * 9.81 * Math.max(0, this.position[1]);
    }
    calculateTotalEnergy() {
        return this.calculateKineticEnergy() + this.calculatePotentialEnergy();
    }
    getEnergyConservation() {
        if (!this.initialEnergy || this.initialEnergy <= 0) return 1;
        const current = this.calculateTotalEnergy();
        const ratio = current / this.initialEnergy;
        return isFinite(ratio) ? Math.min(ratio, 2) : 1;
    }
    draw(renderer) {
        const model = (0, $6e69ca24f4636b79$exports).create();
        (0, $6e69ca24f4636b79$exports).translate(model, model, this.position);
        (0, $6e69ca24f4636b79$exports).multiply(model, model, this.rotation);
        renderer.drawMesh(this.mesh, model, 0.15, 0.25, true);
    }
    getSpeed() {
        const speed = (0, $8f228f84b1e7d967$exports).length(this.velocity);
        return isFinite(speed) ? speed : 0;
    }
    getDebugInfo() {
        const speed = (0, $8f228f84b1e7d967$exports).length(this.velocity);
        const angularSpeed = (0, $8f228f84b1e7d967$exports).length(this.angularVelocity);
        return {
            speed: isFinite(speed) ? speed : 0,
            angularSpeed: isFinite(angularSpeed) ? angularSpeed : 0,
            height: this.position[1],
            kineticEnergy: this.calculateKineticEnergy(),
            potentialEnergy: this.calculatePotentialEnergy(),
            totalEnergy: this.calculateTotalEnergy(),
            energyConservation: this.getEnergyConservation(),
            isOnTrack: this.isOnTrack,
            isOnGround: this.isOnGround,
            trackCurvature: isFinite(this.trackCurvature) ? this.trackCurvature : 0,
            isSlipping: this.isSlipping,
            slipVelocity: isFinite(this.slipVelocity) ? this.slipVelocity : 0,
            contactDuration: this.contactCache.contactDuration
        };
    }
}



class $b816bb6ffceb6f80$export$79f141de891a5fed {
    constructor(){
        this.position = (0, $8f228f84b1e7d967$exports).fromValues(0, 15, 20);
        this.target = (0, $8f228f84b1e7d967$exports).fromValues(0, 5, 0);
        this.smoothPosition = (0, $8f228f84b1e7d967$exports).clone(this.position);
        this.smoothTarget = (0, $8f228f84b1e7d967$exports).clone(this.target);
        this.mode = 'follow';
        this.orbitAngle = 0;
    }
    setMode(mode) {
        this.mode = mode;
    }
    update(marble, track, dt) {
        switch(this.mode){
            case 'follow':
                this.updateFollow(marble, track);
                break;
            case 'orbit':
                this.updateOrbit(marble, dt);
                break;
            case 'firstPerson':
                this.updateFirstPerson(marble, track);
                break;
        }
        // Faster smoothing for follow/FPV to keep up with marble
        const smoothing = this.mode === 'firstPerson' ? 0.25 : this.mode === 'follow' ? 0.12 : 0.06;
        (0, $8f228f84b1e7d967$exports).lerp(this.smoothPosition, this.smoothPosition, this.position, smoothing);
        (0, $8f228f84b1e7d967$exports).lerp(this.smoothTarget, this.smoothTarget, this.target, smoothing);
    }
    updateFollow(marble, track) {
        // Use trackDistance (the correct property name)
        const trackDist = marble.trackDistance || 0;
        const { index: index, t: t } = track.getPositionAtDistance(trackDist);
        const frame = track.getFrameAt(index, t);
        (0, $8f228f84b1e7d967$exports).normalize(frame.tangent, frame.tangent);
        // Position camera behind and above the marble
        // Behind = opposite of tangent direction
        const behind = (0, $8f228f84b1e7d967$exports).create();
        (0, $8f228f84b1e7d967$exports).scale(behind, frame.tangent, -5); // 5 units behind
        const up = (0, $8f228f84b1e7d967$exports).fromValues(0, 3, 0); // 3 units above
        (0, $8f228f84b1e7d967$exports).add(this.position, marble.position, behind);
        (0, $8f228f84b1e7d967$exports).add(this.position, this.position, up);
        // Look ahead on the track
        const lookAheadDist = Math.min(trackDist + 3, track.pathLength - 0.1);
        const aheadPos = track.getPositionAtDistance(lookAheadDist);
        (0, $8f228f84b1e7d967$exports).copy(this.target, aheadPos.position);
        this.target[1] += 0.3; // Slightly above track
    }
    updateOrbit(marble, dt) {
        this.orbitAngle += dt * 0.3;
        const radius = 12;
        const height = 8;
        this.position[0] = marble.position[0] + Math.cos(this.orbitAngle) * radius;
        this.position[1] = marble.position[1] + height;
        this.position[2] = marble.position[2] + Math.sin(this.orbitAngle) * radius;
        (0, $8f228f84b1e7d967$exports).copy(this.target, marble.position);
    }
    updateFirstPerson(marble, track) {
        // Use trackDistance (the correct property name)
        const trackDist = marble.trackDistance || 0;
        const { index: index, t: t } = track.getPositionAtDistance(trackDist);
        const frame = track.getFrameAt(index, t);
        (0, $8f228f84b1e7d967$exports).normalize(frame.tangent, frame.tangent);
        (0, $8f228f84b1e7d967$exports).normalize(frame.normal, frame.normal);
        // Position camera at marble position, slightly above
        (0, $8f228f84b1e7d967$exports).copy(this.position, marble.position);
        // Lift camera up along track normal (so it's above the marble on the track surface)
        (0, $8f228f84b1e7d967$exports).scaleAndAdd(this.position, this.position, frame.normal, 0.15);
        // Look ahead along track direction
        const lookAheadDist = Math.min(trackDist + 2, track.pathLength - 0.1);
        const aheadPos = track.getPositionAtDistance(lookAheadDist);
        (0, $8f228f84b1e7d967$exports).copy(this.target, aheadPos.position);
    }
    getPosition() {
        return this.smoothPosition;
    }
    getTarget() {
        return this.smoothTarget;
    }
}



class $44b158d58ed7b048$export$f219b6a0e4bb0b6d {
    constructor(renderer, maxParticles = 500){
        this.renderer = renderer;
        this.gl = renderer.gl;
        this.maxParticles = maxParticles;
        this.particles = [];
        this.positionData = new Float32Array(maxParticles * 3);
        this.sizeData = new Float32Array(maxParticles);
        this.lifeData = new Float32Array(maxParticles);
        this.colorData = new Float32Array(maxParticles * 3);
        this.positionBuffer = this.gl.createBuffer();
        this.sizeBuffer = this.gl.createBuffer();
        this.lifeBuffer = this.gl.createBuffer();
        this.colorBuffer = this.gl.createBuffer();
    }
    emit(position, velocity, count = 3) {
        for(let i = 0; i < count; i++){
            if (this.particles.length >= this.maxParticles) this.particles.shift();
            const spread = 0.1;
            this.particles.push({
                position: (0, $8f228f84b1e7d967$exports).fromValues(position[0] + (Math.random() - 0.5) * spread, position[1] + (Math.random() - 0.5) * spread, position[2] + (Math.random() - 0.5) * spread),
                velocity: (0, $8f228f84b1e7d967$exports).fromValues(velocity[0] * 0.2 + (Math.random() - 0.5) * 0.5, velocity[1] * 0.2 + Math.random() * 0.3, velocity[2] * 0.2 + (Math.random() - 0.5) * 0.5),
                life: 1.0,
                maxLife: 0.5 + Math.random() * 0.5,
                size: 0.05 + Math.random() * 0.08,
                color: [
                    1.0,
                    0.5 + Math.random() * 0.3,
                    0.2
                ]
            });
        }
    }
    update(dt) {
        const gravity = -2;
        for(let i = this.particles.length - 1; i >= 0; i--){
            const p = this.particles[i];
            p.velocity[1] += gravity * dt;
            (0, $8f228f84b1e7d967$exports).scaleAndAdd(p.position, p.position, p.velocity, dt);
            p.life -= dt / p.maxLife;
            if (p.life <= 0) this.particles.splice(i, 1);
        }
    }
    draw() {
        const gl = this.gl;
        const count = this.particles.length;
        if (count === 0) return;
        for(let i = 0; i < count; i++){
            const p = this.particles[i];
            this.positionData[i * 3] = p.position[0];
            this.positionData[i * 3 + 1] = p.position[1];
            this.positionData[i * 3 + 2] = p.position[2];
            this.sizeData[i] = p.size * p.life;
            this.lifeData[i] = p.life;
            this.colorData[i * 3] = p.color[0];
            this.colorData[i * 3 + 1] = p.color[1];
            this.colorData[i * 3 + 2] = p.color[2];
        }
        gl.useProgram(this.renderer.particleProgram);
        const loc = this.renderer.particleLocations;
        gl.uniformMatrix4fv(loc.uProjection, false, this.renderer.projection);
        gl.uniformMatrix4fv(loc.uView, false, this.renderer.view);
        gl.bindBuffer(gl.ARRAY_BUFFER, this.positionBuffer);
        gl.bufferData(gl.ARRAY_BUFFER, this.positionData.subarray(0, count * 3), gl.DYNAMIC_DRAW);
        gl.enableVertexAttribArray(loc.aPosition);
        gl.vertexAttribPointer(loc.aPosition, 3, gl.FLOAT, false, 0, 0);
        gl.bindBuffer(gl.ARRAY_BUFFER, this.sizeBuffer);
        gl.bufferData(gl.ARRAY_BUFFER, this.sizeData.subarray(0, count), gl.DYNAMIC_DRAW);
        gl.enableVertexAttribArray(loc.aSize);
        gl.vertexAttribPointer(loc.aSize, 1, gl.FLOAT, false, 0, 0);
        gl.bindBuffer(gl.ARRAY_BUFFER, this.lifeBuffer);
        gl.bufferData(gl.ARRAY_BUFFER, this.lifeData.subarray(0, count), gl.DYNAMIC_DRAW);
        gl.enableVertexAttribArray(loc.aLife);
        gl.vertexAttribPointer(loc.aLife, 1, gl.FLOAT, false, 0, 0);
        gl.bindBuffer(gl.ARRAY_BUFFER, this.colorBuffer);
        gl.bufferData(gl.ARRAY_BUFFER, this.colorData.subarray(0, count * 3), gl.DYNAMIC_DRAW);
        gl.enableVertexAttribArray(loc.aColor);
        gl.vertexAttribPointer(loc.aColor, 3, gl.FLOAT, false, 0, 0);
        gl.enable(gl.BLEND);
        gl.blendFunc(gl.SRC_ALPHA, gl.ONE);
        gl.depthMask(false);
        gl.drawArrays(gl.POINTS, 0, count);
        gl.depthMask(true);
        gl.disable(gl.BLEND);
    }
}



// ============================================
// Main Application
// ============================================
class $bcc49ce5a4824452$var$App {
    constructor(){
        this.canvas = document.getElementById('canvas');
        this.renderer = new (0, $69f13b8a7d15be5e$export$88530751e3977073)(this.canvas);
        this.track = new (0, $97dbf72491973e01$export$13921ac0cc260818)(this.renderer);
        this.marble = new (0, $d5a33c4e62aaf32e$export$e91dba6fa3f67f68)(this.renderer, this.track);
        this.camera = new (0, $b816bb6ffceb6f80$export$79f141de891a5fed)();
        this.particles = new (0, $44b158d58ed7b048$export$f219b6a0e4bb0b6d)(this.renderer);
        this.ground = (0, $5409e5fedd273992$export$41fd1f401015bea3)(this.renderer, 100, 50);
        this.lastTime = performance.now();
        this.totalTime = 0;
        this.speedDisplay = document.getElementById('speed');
        this.spinDisplay = document.getElementById('spin');
        this.energyDisplay = document.getElementById('energy');
        this.stateDisplay = document.getElementById('state');
        this.setupUI();
        this.animate();
    }
    setupUI() {
        document.getElementById('reset-btn').addEventListener('click', ()=>{
            this.marble.reset();
        });
        // Camera mode buttons
        const cameraContainer = document.getElementById('camera-modes');
        if (cameraContainer) cameraContainer.querySelectorAll('button').forEach((btn)=>{
            btn.addEventListener('click', ()=>{
                this.camera.setMode(btn.dataset.mode);
                cameraContainer.querySelectorAll('button').forEach((b)=>b.classList.remove('active'));
                btn.classList.add('active');
            });
        });
    }
    animate() {
        const now = performance.now();
        const dt = Math.min((now - this.lastTime) / 1000, 0.05);
        this.lastTime = now;
        this.totalTime += dt;
        // Update
        const marbleData = this.marble.update(dt);
        this.camera.update(this.marble, this.track, dt);
        // Emit particles when moving fast
        const speed = marbleData.speed;
        if (speed > 3 && marbleData.frame) {
            const emitRate = Math.floor(speed / 3);
            // Use opposite of velocity direction for particle emission
            const vel = (0, $8f228f84b1e7d967$exports).create();
            (0, $8f228f84b1e7d967$exports).scale(vel, this.marble.velocity, -0.5);
            this.particles.emit(this.marble.position, vel, emitRate);
        }
        this.particles.update(dt);
        // Update UI
        const debugInfo = this.marble.getDebugInfo();
        this.speedDisplay.textContent = debugInfo.speed.toFixed(1);
        this.spinDisplay.textContent = debugInfo.angularSpeed.toFixed(1);
        this.energyDisplay.textContent = (debugInfo.energyConservation * 100).toFixed(0);
        // State display: Rolling, Sliding, or Flying
        let state = 'Flying';
        if (debugInfo.isOnTrack || debugInfo.isOnGround) state = debugInfo.isSlipping ? 'Sliding' : 'Rolling';
        this.stateDisplay.textContent = state;
        // Render
        this.renderer.updateTime(this.totalTime);
        this.renderer.clear();
        this.renderer.setCamera(this.camera.getPosition(), this.camera.getTarget());
        // Draw sky first
        this.renderer.drawSky();
        // Main pass for objects
        this.renderer.beginMainPass();
        // Ground (with isGround flag for contact shadows)
        const groundMatrix = (0, $6e69ca24f4636b79$exports).create();
        this.renderer.drawMesh(this.ground, groundMatrix, 0.0, 0.85, false, true);
        // Track and marble
        this.track.draw(this.renderer);
        this.marble.draw(this.renderer);
        // Particles (after main pass with blending)
        this.particles.draw();
        requestAnimationFrame(()=>this.animate());
    }
}
// Start
new $bcc49ce5a4824452$var$App();


//# sourceMappingURL=marble-run.f8ac4f16.js.map
